const tailwindMap = {
    // custom add
    "mx-auto": "margin-left:auto;\nmargin-right:auto;",
    "text-white": "color: rgba(255,255,255, 1);",
    "flex-shrink-0": "flex-shrink:0;",

    // from https://tailwindcomponents.com/cheatsheet/
    "aspect-auto": "aspect-ratio: auto;",
    "container": "width: 100%;",
    "aspect-square": "aspect-ratio: 1 / 1;",
    "aspect-video": "aspect-ratio: 16 / 9;",
    "columns-1": "columns: 1;",
    "columns-2": "columns: 2;",
    "columns-3": "columns: 3;",
    "columns-4": "columns: 4;",
    "columns-5": "columns: 5;",
    "columns-6": "columns: 6;",
    "columns-7": "columns: 7;",
    "columns-8": "columns: 8;",
    "columns-9": "columns: 9;",
    "columns-10": "columns: 10;",
    "columns-11": "columns: 11;",
    "columns-12": "columns: 12;",
    "columns-auto": "columns: auto;",
    "columns-3xs": "columns: 16rem;",
    "columns-2xs": "columns: 18rem;",
    "columns-xs": "columns: 20rem;",
    "columns-sm": "columns: 24rem;",
    "columns-md": "columns: 28rem;",
    "columns-lg": "columns: 32rem;",
    "columns-xl": "columns: 36rem;",
    "columns-2xl": "columns: 42rem;",
    "columns-3xl": "columns: 48rem;",
    "columns-4xl": "columns: 56rem;",
    "columns-5xl": "columns: 64rem;",
    "columns-6xl": "columns: 72rem;",
    "columns-7xl": "columns: 80rem;",
    "break-after-auto": "break-after: auto;",
    "break-after-avoid": "break-after: avoid;",
    "break-after-all": "break-after: all;",
    "break-after-avoid-page": "break-after: avoid-page;",
    "break-after-page": "break-after: page;",
    "break-after-left": "break-after: left;",
    "break-after-right": "break-after: right;",
    "break-after-column": "break-after: column;",
    "break-before-auto": "break-before: auto;",
    "break-before-avoid": "break-before: avoid;",
    "break-before-all": "break-before: all;",
    "break-before-avoid-page": "break-before: avoid-page;",
    "break-before-page": "break-before: page;",
    "break-before-left": "break-before: left;",
    "break-before-right": "break-before: right;",
    "break-before-column": "break-before: column;",
    "break-inside-auto": "break-inside: auto;",
    "break-inside-avoid": "break-inside: avoid;",
    "break-inside-avoid-page": "break-inside: avoid-page;",
    "break-inside-column": "break-inside: column;",
    "decoration-slice": "box-decoration-break: slice;",
    "decoration-clone": "box-decoration-break: clone;",
    "box-border": "box-sizing: border-box;",
    "box-content": "box-sizing: content-box;",
    "block": "display: block;",
    "inline-block": "display: inline-block;",
    "inline": "display: inline;",
    "flex": "display: flex;",
    "inline-flex": "display: inline-flex;",
    "table": "display: table;",
    "inline-table": "display: inline-table;",
    "table-caption": "display: table-caption;",
    "table-cell": "display: table-cell;",
    "table-column": "display: table-column;",
    "table-column-group": "display: table-column-group;",
    "table-footer-group": "display: table-footer-group;",
    "table-header-group": "display: table-header-group;",
    "table-row-group": "display: table-row-group;",
    "table-row": "display: table-row;",
    "flow-root": "display: flow-root;",
    "grid": "display: grid;",
    "inline-grid": "display: inline-grid;",
    "contents": "display: contents;",
    "list-item": "display: list-item;",
    "hidden": "display: none;",
    "float-right": "float: right;",
    "float-left": "float: left;",
    "float-none": "float: none;",
    "clear-left": "clear: left;",
    "clear-right": "clear: right;",
    "clear-both": "clear: both;",
    "clear-none": "clear: none;",
    "isolate": "isolation: isolate;",
    "isolate-auto": "isolation: auto;",
    "object-contain": "object-fit: contain;",
    "object-cover": "object-fit: cover;",
    "object-fill": "object-fit: fill;",
    "object-none": "object-fit: none;",
    "object-scale-down": "object-fit: scale-down;",
    "object-bottom": "object-position: bottom;",
    "object-center": "object-position: center;",
    "object-left": "object-position: left;",
    "object-left-bottom": "object-position: left bottom;",
    "object-left-top": "object-position: left top;",
    "object-right": "object-position: right;",
    "object-right-bottom": "object-position: right bottom;",
    "object-right-top": "object-position: right top;",
    "object-top": "object-position: top;",
    "overflow-auto": "overflow: auto;",
    "overflow-x-auto": "overflow-x: auto;",
    "overflow-y-auto": "overflow-y: auto;",
    "overflow-hidden": "overflow: hidden;",
    "overflow-x-hidden": "overflow-x: hidden;",
    "overflow-y-hidden": "overflow-y: hidden;",
    "overflow-visible": "overflow: visible;",
    "overflow-x-visible": "overflow-x: visible;",
    "overflow-y-visible": "overflow-y: visible;",
    "overflow-scroll": "overflow: scroll;",
    "overflow-x-scroll": "overflow-x: scroll;",
    "overflow-y-scroll": "overflow-y: scroll;",
    "scrolling-touch": "-webkit-overflow-scrolling: touch;",
    "scrolling-auto": "-webkit-overflow-scrolling: auto;",
    "overscroll-auto": "overscroll-behavior: auto;",
    "overscroll-y-auto": "overscroll-behavior-y: auto;",
    "overscroll-x-auto": "overscroll-behavior-x: auto;",
    "overscroll-contain": "overscroll-behavior: contain;",
    "overscroll-y-contain": "overscroll-behavior-y: contain;",
    "overscroll-x-contain": "overscroll-behavior-x: contain;",
    "overscroll-none": "overscroll-behavior: none;",
    "overscroll-y-none": "overscroll-behavior-y: none;",
    "overscroll-x-none": "overscroll-behavior-x: none;",
    "static": "position: static;",
    "fixed": "position: fixed;",
    "absolute": "position: absolute;",
    "relative": "position: relative;",
    "sticky": "position: sticky;",
    "inset-0": "top: 0;\nright: 0;\nbottom: 0;\nleft: 0;",
    "-inset-0": "top: 0;\nright: 0;\nbottom: 0;\nleft: 0;",
    "inset-y-0": "top: 0;\nbottom: 0;",
    "-inset-y-0": "top: 0;\nbottom: 0;",
    "inset-x-0": "right: 0;\nleft: 0;",
    "-inset-x-0": "right: 0;\nleft: 0;",
    "top-0": "top: 0;",
    "right-0": "right: 0;",
    "bottom-0": "bottom: 0;",
    "left-0": "left: 0;",
    "-top-0": "top: 0;",
    "-right-0": "right: 0;",
    "-bottom-0": "bottom: 0;",
    "-left-0": "left: 0;",
    "inset-0.5": "top: 0.125rem;\nright: 0.125rem;\nbottom: 0.125rem;\nleft: 0.125rem;",
    "-inset-0.5": "top: -0.125rem;\nright: -0.125rem;\nbottom: -0.125rem;\nleft: -0.125rem;",
    "inset-y-0.5": "top: 0.125rem;\nbottom: 0.125rem;",
    "-inset-y-0.5": "top: -0.125rem;\nbottom: -0.125rem;",
    "inset-x-0.5": "right: 0.125rem;\nleft: 0.125rem;",
    "-inset-x-0.5": "right: -0.125rem;\nleft: -0.125rem;",
    "top-0.5": "top: 0.125rem;",
    "right-0.5": "right: 0.125rem;",
    "bottom-0.5": "bottom: 0.125rem;",
    "left-0.5": "left: 0.125rem;",
    "-top-0.5": "top: -0.125rem;",
    "-right-0.5": "right: -0.125rem;",
    "-bottom-0.5": "bottom: -0.125rem;",
    "-left-0.5": "left: -0.125rem;",
    "inset-1": "top: 0.25rem;\nright: 0.25rem;\nbottom: 0.25rem;\nleft: 0.25rem;",
    "-inset-1": "top: -0.25rem;\nright: -0.25rem;\nbottom: -0.25rem;\nleft: -0.25rem;",
    "inset-y-1": "top: 0.25rem;\nbottom: 0.25rem;",
    "-inset-y-1": "top: -0.25rem;\nbottom: -0.25rem;",
    "inset-x-1": "right: 0.25rem;\nleft: 0.25rem;",
    "-inset-x-1": "right: -0.25rem;\nleft: -0.25rem;",
    "top-1": "top: 0.25rem;",
    "right-1": "right: 0.25rem;",
    "bottom-1": "bottom: 0.25rem;",
    "left-1": "left: 0.25rem;",
    "-top-1": "top: -0.25rem;",
    "-right-1": "right: -0.25rem;",
    "-bottom-1": "bottom: -0.25rem;",
    "-left-1": "left: -0.25rem;",
    "inset-1.5": "top: 0.375rem;\nright: 0.375rem;\nbottom: 0.375rem;\nleft: 0.375rem;",
    "-inset-1.5": "top: -0.375rem;\nright: -0.375rem;\nbottom: -0.375rem;\nleft: -0.375rem;",
    "inset-y-1.5": "top: 0.375rem;\nbottom: 0.375rem;",
    "-inset-y-1.5": "top: -0.375rem;\nbottom: -0.375rem;",
    "inset-x-1.5": "right: 0.375rem;\nleft: 0.375rem;",
    "-inset-x-1.5": "right: -0.375rem;\nleft: -0.375rem;",
    "top-1.5": "top: 0.375rem;",
    "right-1.5": "right: 0.375rem;",
    "bottom-1.5": "bottom: 0.375rem;",
    "left-1.5": "left: 0.375rem;",
    "-top-1.5": "top: -0.375rem;",
    "-right-1.5": "right: -0.375rem;",
    "-bottom-1.5": "bottom: -0.375rem;",
    "-left-1.5": "left: -0.375rem;",
    "inset-2": "top: 0.5rem;\nright: 0.5rem;\nbottom: 0.5rem;\nleft: 0.5rem;",
    "-inset-2": "top: -0.5rem;\nright: -0.5rem;\nbottom: -0.5rem;\nleft: -0.5rem;",
    "inset-y-2": "top: 0.5rem;\nbottom: 0.5rem;",
    "-inset-y-2": "top: -0.5rem;\nbottom: -0.5rem;",
    "inset-x-2": "right: 0.5rem;\nleft: 0.5rem;",
    "-inset-x-2": "right: -0.5rem;\nleft: -0.5rem;",
    "top-2": "top: 0.5rem;",
    "right-2": "right: 0.5rem;",
    "bottom-2": "bottom: 0.5rem;",
    "left-2": "left: 0.5rem;",
    "-top-2": "top: -0.5rem;",
    "-right-2": "right: -0.5rem;",
    "-bottom-2": "bottom: -0.5rem;",
    "-left-2": "left: -0.5rem;",
    "inset-2.5": "top: 0.625rem;\nright: 0.625rem;\nbottom: 0.625rem;\nleft: 0.625rem;",
    "-inset-2.5": "top: -0.625rem;\nright: -0.625rem;\nbottom: -0.625rem;\nleft: -0.625rem;",
    "inset-y-2.5": "top: 0.625rem;\nbottom: 0.625rem;",
    "-inset-y-2.5": "top: -0.625rem;\nbottom: -0.625rem;",
    "inset-x-2.5": "right: 0.625rem;\nleft: 0.625rem;",
    "-inset-x-2.5": "right: -0.625rem;\nleft: -0.625rem;",
    "top-2.5": "top: 0.625rem;",
    "right-2.5": "right: 0.625rem;",
    "bottom-2.5": "bottom: 0.625rem;",
    "left-2.5": "left: 0.625rem;",
    "-top-2.5": "top: -0.625rem;",
    "-right-2.5": "right: -0.625rem;",
    "-bottom-2.5": "bottom: -0.625rem;",
    "-left-2.5": "left: -0.625rem;",
    "inset-3": "top: 0.75rem;\nright: 0.75rem;\nbottom: 0.75rem;\nleft: 0.75rem;",
    "-inset-3": "top: -0.75rem;\nright: -0.75rem;\nbottom: -0.75rem;\nleft: -0.75rem;",
    "inset-y-3": "top: 0.75rem;\nbottom: 0.75rem;",
    "-inset-y-3": "top: -0.75rem;\nbottom: -0.75rem;",
    "inset-x-3": "right: 0.75rem;\nleft: 0.75rem;",
    "-inset-x-3": "right: -0.75rem;\nleft: -0.75rem;",
    "top-3": "top: 0.75rem;",
    "right-3": "right: 0.75rem;",
    "bottom-3": "bottom: 0.75rem;",
    "left-3": "left: 0.75rem;",
    "-top-3": "top: -0.75rem;",
    "-right-3": "right: -0.75rem;",
    "-bottom-3": "bottom: -0.75rem;",
    "-left-3": "left: -0.75rem;",
    "inset-3.5": "top: 0.875rem;\nright: 0.875rem;\nbottom: 0.875rem;\nleft: 0.875rem;",
    "-inset-3.5": "top: -0.875rem;\nright: -0.875rem;\nbottom: -0.875rem;\nleft: -0.875rem;",
    "inset-y-3.5": "top: 0.875rem;\nbottom: 0.875rem;",
    "-inset-y-3.5": "top: -0.875rem;\nbottom: -0.875rem;",
    "inset-x-3.5": "right: 0.875rem;\nleft: 0.875rem;",
    "-inset-x-3.5": "right: -0.875rem;\nleft: -0.875rem;",
    "top-3.5": "top: 0.875rem;",
    "right-3.5": "right: 0.875rem;",
    "bottom-3.5": "bottom: 0.875rem;",
    "left-3.5": "left: 0.875rem;",
    "-top-3.5": "top: -0.875rem;",
    "-right-3.5": "right: -0.875rem;",
    "-bottom-3.5": "bottom: -0.875rem;",
    "-left-3.5": "left: -0.875rem;",
    "inset-4": "top: 1rem;\nright: 1rem;\nbottom: 1rem;\nleft: 1rem;",
    "-inset-4": "top: -1rem;\nright: -1rem;\nbottom: -1rem;\nleft: -1rem;",
    "inset-y-4": "top: 1rem;\nbottom: 1rem;",
    "-inset-y-4": "top: -1rem;\nbottom: -1rem;",
    "inset-x-4": "right: 1rem;\nleft: 1rem;",
    "-inset-x-4": "right: -1rem;\nleft: -1rem;",
    "top-4": "top: 1rem;",
    "right-4": "right: 1rem;",
    "bottom-4": "bottom: 1rem;",
    "left-4": "left: 1rem;",
    "-top-4": "top: -1rem;",
    "-right-4": "right: -1rem;",
    "-bottom-4": "bottom: -1rem;",
    "-left-4": "left: -1rem;",
    "inset-5": "top: 1.25rem;\nright: 1.25rem;\nbottom: 1.25rem;\nleft: 1.25rem;",
    "-inset-5": "top: -1.25rem;\nright: -1.25rem;\nbottom: -1.25rem;\nleft: -1.25rem;",
    "inset-y-5": "top: 1.25rem;\nbottom: 1.25rem;",
    "-inset-y-5": "top: -1.25rem;\nbottom: -1.25rem;",
    "inset-x-5": "right: 1.25rem;\nleft: 1.25rem;",
    "-inset-x-5": "right: -1.25rem;\nleft: -1.25rem;",
    "top-5": "top: 1.25rem;",
    "right-5": "right: 1.25rem;",
    "bottom-5": "bottom: 1.25rem;",
    "left-5": "left: 1.25rem;",
    "-top-5": "top: -1.25rem;",
    "-right-5": "right: -1.25rem;",
    "-bottom-5": "bottom: -1.25rem;",
    "-left-5": "left: -1.25rem;",
    "inset-6": "top: 1.5rem;\nright: 1.5rem;\nbottom: 1.5rem;\nleft: 1.5rem;",
    "-inset-6": "top: -1.5rem;\nright: -1.5rem;\nbottom: -1.5rem;\nleft: -1.5rem;",
    "inset-y-6": "top: 1.5rem;\nbottom: 1.5rem;",
    "-inset-y-6": "top: -1.5rem;\nbottom: -1.5rem;",
    "inset-x-6": "right: 1.5rem;\nleft: 1.5rem;",
    "-inset-x-6": "right: -1.5rem;\nleft: -1.5rem;",
    "top-6": "top: 1.5rem;",
    "right-6": "right: 1.5rem;",
    "bottom-6": "bottom: 1.5rem;",
    "left-6": "left: 1.5rem;",
    "-top-6": "top: -1.5rem;",
    "-right-6": "right: -1.5rem;",
    "-bottom-6": "bottom: -1.5rem;",
    "-left-6": "left: -1.5rem;",
    "inset-7": "top: 1.75rem;\nright: 1.75rem;\nbottom: 1.75rem;\nleft: 1.75rem;",
    "-inset-7": "top: -1.75rem;\nright: -1.75rem;\nbottom: -1.75rem;\nleft: -1.75rem;",
    "inset-y-7": "top: 1.75rem;\nbottom: 1.75rem;",
    "-inset-y-7": "top: -1.75rem;\nbottom: -1.75rem;",
    "inset-x-7": "right: 1.75rem;\nleft: 1.75rem;",
    "-inset-x-7": "right: -1.75rem;\nleft: -1.75rem;",
    "top-7": "top: 1.75rem;",
    "right-7": "right: 1.75rem;",
    "bottom-7": "bottom: 1.75rem;",
    "left-7": "left: 1.75rem;",
    "-top-7": "top: -1.75rem;",
    "-right-7": "right: -1.75rem;",
    "-bottom-7": "bottom: -1.75rem;",
    "-left-7": "left: -1.75rem;",
    "inset-8": "top: 2rem;\nright: 2rem;\nbottom: 2rem;\nleft: 2rem;",
    "-inset-8": "top: -2rem;\nright: -2rem;\nbottom: -2rem;\nleft: -2rem;",
    "inset-y-8": "top: 2rem;\nbottom: 2rem;",
    "-inset-y-8": "top: -2rem;\nbottom: -2rem;",
    "inset-x-8": "right: 2rem;\nleft: 2rem;",
    "-inset-x-8": "right: -2rem;\nleft: -2rem;",
    "top-8": "top: 2rem;",
    "right-8": "right: 2rem;",
    "bottom-8": "bottom: 2rem;",
    "left-8": "left: 2rem;",
    "-top-8": "top: -2rem;",
    "-right-8": "right: -2rem;",
    "-bottom-8": "bottom: -2rem;",
    "-left-8": "left: -2rem;",
    "inset-9": "top: 2.25rem;\nright: 2.25rem;\nbottom: 2.25rem;\nleft: 2.25rem;",
    "-inset-9": "top: -2.25rem;\nright: -2.25rem;\nbottom: -2.25rem;\nleft: -2.25rem;",
    "inset-y-9": "top: 2.25rem;\nbottom: 2.25rem;",
    "-inset-y-9": "top: -2.25rem;\nbottom: -2.25rem;",
    "inset-x-9": "right: 2.25rem;\nleft: 2.25rem;",
    "-inset-x-9": "right: -2.25rem;\nleft: -2.25rem;",
    "top-9": "top: 2.25rem;",
    "right-9": "right: 2.25rem;",
    "bottom-9": "bottom: 2.25rem;",
    "left-9": "left: 2.25rem;",
    "-top-9": "top: -2.25rem;",
    "-right-9": "right: -2.25rem;",
    "-bottom-9": "bottom: -2.25rem;",
    "-left-9": "left: -2.25rem;",
    "inset-10": "top: 2.5rem;\nright: 2.5rem;\nbottom: 2.5rem;\nleft: 2.5rem;",
    "-inset-10": "top: -2.5rem;\nright: -2.5rem;\nbottom: -2.5rem;\nleft: -2.5rem;",
    "inset-y-10": "top: 2.5rem;\nbottom: 2.5rem;",
    "-inset-y-10": "top: -2.5rem;\nbottom: -2.5rem;",
    "inset-x-10": "right: 2.5rem;\nleft: 2.5rem;",
    "-inset-x-10": "right: -2.5rem;\nleft: -2.5rem;",
    "top-10": "top: 2.5rem;",
    "right-10": "right: 2.5rem;",
    "bottom-10": "bottom: 2.5rem;",
    "left-10": "left: 2.5rem;",
    "-top-10": "top: -2.5rem;",
    "-right-10": "right: -2.5rem;",
    "-bottom-10": "bottom: -2.5rem;",
    "-left-10": "left: -2.5rem;",
    "inset-11": "top: 2.75rem;\nright: 2.75rem;\nbottom: 2.75rem;\nleft: 2.75rem;",
    "-inset-11": "top: -2.75rem;\nright: -2.75rem;\nbottom: -2.75rem;\nleft: -2.75rem;",
    "inset-y-11": "top: 2.75rem;\nbottom: 2.75rem;",
    "-inset-y-11": "top: -2.75rem;\nbottom: -2.75rem;",
    "inset-x-11": "right: 2.75rem;\nleft: 2.75rem;",
    "-inset-x-11": "right: -2.75rem;\nleft: -2.75rem;",
    "top-11": "top: 2.75rem;",
    "right-11": "right: 2.75rem;",
    "bottom-11": "bottom: 2.75rem;",
    "left-11": "left: 2.75rem;",
    "-top-11": "top: -2.75rem;",
    "-right-11": "right: -2.75rem;",
    "-bottom-11": "bottom: -2.75rem;",
    "-left-11": "left: -2.75rem;",
    "inset-12": "top: 3rem;\nright: 3rem;\nbottom: 3rem;\nleft: 3rem;",
    "-inset-12": "top: -3rem;\nright: -3rem;\nbottom: -3rem;\nleft: -3rem;",
    "inset-y-12": "top: 3rem;\nbottom: 3rem;",
    "-inset-y-12": "top: -3rem;\nbottom: -3rem;",
    "inset-x-12": "right: 3rem;\nleft: 3rem;",
    "-inset-x-12": "right: -3rem;\nleft: -3rem;",
    "top-12": "top: 3rem;",
    "right-12": "right: 3rem;",
    "bottom-12": "bottom: 3rem;",
    "left-12": "left: 3rem;",
    "-top-12": "top: -3rem;",
    "-right-12": "right: -3rem;",
    "-bottom-12": "bottom: -3rem;",
    "-left-12": "left: -3rem;",
    "inset-14": "top: 3.5rem;\nright: 3.5rem;\nbottom: 3.5rem;\nleft: 3.5rem;",
    "-inset-14": "top: -3.5rem;\nright: -3.5rem;\nbottom: -3.5rem;\nleft: -3.5rem;",
    "inset-y-14": "top: 3.5rem;\nbottom: 3.5rem;",
    "-inset-y-14": "top: -3.5rem;\nbottom: -3.5rem;",
    "inset-x-14": "right: 3.5rem;\nleft: 3.5rem;",
    "-inset-x-14": "right: -3.5rem;\nleft: -3.5rem;",
    "top-14": "top: 3.5rem;",
    "right-14": "right: 3.5rem;",
    "bottom-14": "bottom: 3.5rem;",
    "left-14": "left: 3.5rem;",
    "-top-14": "top: -3.5rem;",
    "-right-14": "right: -3.5rem;",
    "-bottom-14": "bottom: -3.5rem;",
    "-left-14": "left: -3.5rem;",
    "inset-16": "top: 4rem;\nright: 4rem;\nbottom: 4rem;\nleft: 4rem;",
    "-inset-16": "top: -4rem;\nright: -4rem;\nbottom: -4rem;\nleft: -4rem;",
    "inset-y-16": "top: 4rem;\nbottom: 4rem;",
    "-inset-y-16": "top: -4rem;\nbottom: -4rem;",
    "inset-x-16": "right: 4rem;\nleft: 4rem;",
    "-inset-x-16": "right: -4rem;\nleft: -4rem;",
    "top-16": "top: 4rem;",
    "right-16": "right: 4rem;",
    "bottom-16": "bottom: 4rem;",
    "left-16": "left: 4rem;",
    "-top-16": "top: -4rem;",
    "-right-16": "right: -4rem;",
    "-bottom-16": "bottom: -4rem;",
    "-left-16": "left: -4rem;",
    "inset-20": "top: 5rem;\nright: 5rem;\nbottom: 5rem;\nleft: 5rem;",
    "-inset-20": "top: -5rem;\nright: -5rem;\nbottom: -5rem;\nleft: -5rem;",
    "inset-y-20": "top: 5rem;\nbottom: 5rem;",
    "-inset-y-20": "top: -5rem;\nbottom: -5rem;",
    "inset-x-20": "right: 5rem;\nleft: 5rem;",
    "-inset-x-20": "right: -5rem;\nleft: -5rem;",
    "top-20": "top: 5rem;",
    "right-20": "right: 5rem;",
    "bottom-20": "bottom: 5rem;",
    "left-20": "left: 5rem;",
    "-top-20": "top: -5rem;",
    "-right-20": "right: -5rem;",
    "-bottom-20": "bottom: -5rem;",
    "-left-20": "left: -5rem;",
    "inset-24": "top: 6rem;\nright: 6rem;\nbottom: 6rem;\nleft: 6rem;",
    "-inset-24": "top: -6rem;\nright: -6rem;\nbottom: -6rem;\nleft: -6rem;",
    "inset-y-24": "top: 6rem;\nbottom: 6rem;",
    "-inset-y-24": "top: -6rem;\nbottom: -6rem;",
    "inset-x-24": "right: 6rem;\nleft: 6rem;",
    "-inset-x-24": "right: -6rem;\nleft: -6rem;",
    "top-24": "top: 6rem;",
    "right-24": "right: 6rem;",
    "bottom-24": "bottom: 6rem;",
    "left-24": "left: 6rem;",
    "-top-24": "top: -6rem;",
    "-right-24": "right: -6rem;",
    "-bottom-24": "bottom: -6rem;",
    "-left-24": "left: -6rem;",
    "inset-28": "top: 7rem;\nright: 7rem;\nbottom: 7rem;\nleft: 7rem;",
    "-inset-28": "top: -7rem;\nright: -7rem;\nbottom: -7rem;\nleft: -7rem;",
    "inset-y-28": "top: 7rem;\nbottom: 7rem;",
    "-inset-y-28": "top: -7rem;\nbottom: -7rem;",
    "inset-x-28": "right: 7rem;\nleft: 7rem;",
    "-inset-x-28": "right: -7rem;\nleft: -7rem;",
    "top-28": "top: 7rem;",
    "right-28": "right: 7rem;",
    "bottom-28": "bottom: 7rem;",
    "left-28": "left: 7rem;",
    "-top-28": "top: -7rem;",
    "-right-28": "right: -7rem;",
    "-bottom-28": "bottom: -7rem;",
    "-left-28": "left: -7rem;",
    "inset-32": "top: 8rem;\nright: 8rem;\nbottom: 8rem;\nleft: 8rem;",
    "-inset-32": "top: -8rem;\nright: -8rem;\nbottom: -8rem;\nleft: -8rem;",
    "inset-y-32": "top: 8rem;\nbottom: 8rem;",
    "-inset-y-32": "top: -8rem;\nbottom: -8rem;",
    "inset-x-32": "right: 8rem;\nleft: 8rem;",
    "-inset-x-32": "right: -8rem;\nleft: -8rem;",
    "top-32": "top: 8rem;",
    "right-32": "right: 8rem;",
    "bottom-32": "bottom: 8rem;",
    "left-32": "left: 8rem;",
    "-top-32": "top: -8rem;",
    "-right-32": "right: -8rem;",
    "-bottom-32": "bottom: -8rem;",
    "-left-32": "left: -8rem;",
    "inset-36": "top: 9rem;\nright: 9rem;\nbottom: 9rem;\nleft: 9rem;",
    "-inset-36": "top: -9rem;\nright: -9rem;\nbottom: -9rem;\nleft: -9rem;",
    "inset-y-36": "top: 9rem;\nbottom: 9rem;",
    "-inset-y-36": "top: -9rem;\nbottom: -9rem;",
    "inset-x-36": "right: 9rem;\nleft: 9rem;",
    "-inset-x-36": "right: -9rem;\nleft: -9rem;",
    "top-36": "top: 9rem;",
    "right-36": "right: 9rem;",
    "bottom-36": "bottom: 9rem;",
    "left-36": "left: 9rem;",
    "-top-36": "top: -9rem;",
    "-right-36": "right: -9rem;",
    "-bottom-36": "bottom: -9rem;",
    "-left-36": "left: -9rem;",
    "inset-40": "top: 10rem;\nright: 10rem;\nbottom: 10rem;\nleft: 10rem;",
    "-inset-40": "top: -10rem;\nright: -10rem;\nbottom: -10rem;\nleft: -10rem;",
    "inset-y-40": "top: 10rem;\nbottom: 10rem;",
    "-inset-y-40": "top: -10rem;\nbottom: -10rem;",
    "inset-x-40": "right: 10rem;\nleft: 10rem;",
    "-inset-x-40": "right: -10rem;\nleft: -10rem;",
    "top-40": "top: 10rem;",
    "right-40": "right: 10rem;",
    "bottom-40": "bottom: 10rem;",
    "left-40": "left: 10rem;",
    "-top-40": "top: -10rem;",
    "-right-40": "right: -10rem;",
    "-bottom-40": "bottom: -10rem;",
    "-left-40": "left: -10rem;",
    "inset-44": "top: 11rem;\nright: 11rem;\nbottom: 11rem;\nleft: 11rem;",
    "-inset-44": "top: -11rem;\nright: -11rem;\nbottom: -11rem;\nleft: -11rem;",
    "inset-y-44": "top: 11rem;\nbottom: 11rem;",
    "-inset-y-44": "top: -11rem;\nbottom: -11rem;",
    "inset-x-44": "right: 11rem;\nleft: 11rem;",
    "-inset-x-44": "right: -11rem;\nleft: -11rem;",
    "top-44": "top: 11rem;",
    "right-44": "right: 11rem;",
    "bottom-44": "bottom: 11rem;",
    "left-44": "left: 11rem;",
    "-top-44": "top: -11rem;",
    "-right-44": "right: -11rem;",
    "-bottom-44": "bottom: -11rem;",
    "-left-44": "left: -11rem;",
    "inset-48": "top: 12rem;\nright: 12rem;\nbottom: 12rem;\nleft: 12rem;",
    "-inset-48": "top: -12rem;\nright: -12rem;\nbottom: -12rem;\nleft: -12rem;",
    "inset-y-48": "top: 12rem;\nbottom: 12rem;",
    "-inset-y-48": "top: -12rem;\nbottom: -12rem;",
    "inset-x-48": "right: 12rem;\nleft: 12rem;",
    "-inset-x-48": "right: -12rem;\nleft: -12rem;",
    "top-48": "top: 12rem;",
    "right-48": "right: 12rem;",
    "bottom-48": "bottom: 12rem;",
    "left-48": "left: 12rem;",
    "-top-48": "top: -12rem;",
    "-right-48": "right: -12rem;",
    "-bottom-48": "bottom: -12rem;",
    "-left-48": "left: -12rem;",
    "inset-52": "top: 13rem;\nright: 13rem;\nbottom: 13rem;\nleft: 13rem;",
    "-inset-52": "top: -13rem;\nright: -13rem;\nbottom: -13rem;\nleft: -13rem;",
    "inset-y-52": "top: 13rem;\nbottom: 13rem;",
    "-inset-y-52": "top: -13rem;\nbottom: -13rem;",
    "inset-x-52": "right: 13rem;\nleft: 13rem;",
    "-inset-x-52": "right: -13rem;\nleft: -13rem;",
    "top-52": "top: 13rem;",
    "right-52": "right: 13rem;",
    "bottom-52": "bottom: 13rem;",
    "left-52": "left: 13rem;",
    "-top-52": "top: -13rem;",
    "-right-52": "right: -13rem;",
    "-bottom-52": "bottom: -13rem;",
    "-left-52": "left: -13rem;",
    "inset-56": "top: 14rem;\nright: 14rem;\nbottom: 14rem;\nleft: 14rem;",
    "-inset-56": "top: -14rem;\nright: -14rem;\nbottom: -14rem;\nleft: -14rem;",
    "inset-y-56": "top: 14rem;\nbottom: 14rem;",
    "-inset-y-56": "top: -14rem;\nbottom: -14rem;",
    "inset-x-56": "right: 14rem;\nleft: 14rem;",
    "-inset-x-56": "right: -14rem;\nleft: -14rem;",
    "top-56": "top: 14rem;",
    "right-56": "right: 14rem;",
    "bottom-56": "bottom: 14rem;",
    "left-56": "left: 14rem;",
    "-top-56": "top: -14rem;",
    "-right-56": "right: -14rem;",
    "-bottom-56": "bottom: -14rem;",
    "-left-56": "left: -14rem;",
    "inset-60": "top: 15rem;\nright: 15rem;\nbottom: 15rem;\nleft: 15rem;",
    "-inset-60": "top: -15rem;\nright: -15rem;\nbottom: -15rem;\nleft: -15rem;",
    "inset-y-60": "top: 15rem;\nbottom: 15rem;",
    "-inset-y-60": "top: -15rem;\nbottom: -15rem;",
    "inset-x-60": "right: 15rem;\nleft: 15rem;",
    "-inset-x-60": "right: -15rem;\nleft: -15rem;",
    "top-60": "top: 15rem;",
    "right-60": "right: 15rem;",
    "bottom-60": "bottom: 15rem;",
    "left-60": "left: 15rem;",
    "-top-60": "top: -15rem;",
    "-right-60": "right: -15rem;",
    "-bottom-60": "bottom: -15rem;",
    "-left-60": "left: -15rem;",
    "inset-64": "top: 16rem;\nright: 16rem;\nbottom: 16rem;\nleft: 16rem;",
    "-inset-64": "top: -16rem;\nright: -16rem;\nbottom: -16rem;\nleft: -16rem;",
    "inset-y-64": "top: 16rem;\nbottom: 16rem;",
    "-inset-y-64": "top: -16rem;\nbottom: -16rem;",
    "inset-x-64": "right: 16rem;\nleft: 16rem;",
    "-inset-x-64": "right: -16rem;\nleft: -16rem;",
    "top-64": "top: 16rem;",
    "right-64": "right: 16rem;",
    "bottom-64": "bottom: 16rem;",
    "left-64": "left: 16rem;",
    "-top-64": "top: -16rem;",
    "-right-64": "right: -16rem;",
    "-bottom-64": "bottom: -16rem;",
    "-left-64": "left: -16rem;",
    "inset-72": "top: 18rem;\nright: 18rem;\nbottom: 18rem;\nleft: 18rem;",
    "-inset-72": "top: -18rem;\nright: -18rem;\nbottom: -18rem;\nleft: -18rem;",
    "inset-y-72": "top: 18rem;\nbottom: 18rem;",
    "-inset-y-72": "top: -18rem;\nbottom: -18rem;",
    "inset-x-72": "right: 18rem;\nleft: 18rem;",
    "-inset-x-72": "right: -18rem;\nleft: -18rem;",
    "top-72": "top: 18rem;",
    "right-72": "right: 18rem;",
    "bottom-72": "bottom: 18rem;",
    "left-72": "left: 18rem;",
    "-top-72": "top: -18rem;",
    "-right-72": "right: -18rem;",
    "-bottom-72": "bottom: -18rem;",
    "-left-72": "left: -18rem;",
    "inset-80": "top: 20;\nright: 20;\nbottom: 20;\nleft: 20;",
    "-inset-80": "top: -20;\nright: -20;\nbottom: -20;\nleft: -20;",
    "inset-y-80": "top: 20;\nbottom: 20;",
    "-inset-y-80": "top: -20;\nbottom: -20;",
    "inset-x-80": "right: 20;\nleft: 20;",
    "-inset-x-80": "right: -20;\nleft: -20;",
    "top-80": "top: 20;",
    "right-80": "right: 20;",
    "bottom-80": "bottom: 20;",
    "left-80": "left: 20;",
    "-top-80": "top: -20;",
    "-right-80": "right: -20;",
    "-bottom-80": "bottom: -20;",
    "-left-80": "left: -20rem;",
    "inset-96": "top: 24rem;\nright: 24rem;\nbottom: 24rem;\nleft: 24rem;",
    "-inset-96": "top: -24rem;\nright: -24rem;\nbottom: -24rem;\nleft: -24rem;",
    "inset-y-96": "top: 24rem;\nbottom: 24rem;",
    "-inset-y-96": "top: -24rem;\nbottom: -24rem;",
    "inset-x-96": "right: 24rem;\nleft: 24rem;",
    "-inset-x-96": "right: -24rem;\nleft: -24rem;",
    "top-96": "top: 24rem;",
    "right-96": "right: 24rem;",
    "bottom-96": "bottom: 24rem;",
    "left-96": "left: 24rem;",
    "-top-96": "top: -24rem;",
    "-right-96": "right: -24rem;",
    "-bottom-96": "bottom: -24rem;",
    "-left-96": "left: -24rem;",
    "inset-auto": "top: auto;\nright: auto;\nbottom: auto;\nleft: auto;",
    "inset-y-auto": "top: auto;\nbottom: auto;",
    "inset-x-auto": "right: auto;\nleft: auto;",
    "top-auto": "top: auto;",
    "right-auto": "right: auto;",
    "bottom-auto": "bottom: auto;",
    "left-auto": "left: auto;",
    "inset-1/2": "top: 50%;\nright: 50%;\nbottom: 50%;\nleft: 50%;",
    "inset-2/3": "top: 66.666667%;\nright: 66.666667%;\nbottom: 66.666667%;\nleft: 66.666667%;",
    "inset-1/4": "top: 25%;\nright: 25%;\nbottom: 25%;\nleft: 25%;",
    "inset-3/4": "top: 75%;\nright: 75%;\nbottom: 75%;\nleft: 75%;",
    "inset-full": "top: 100%;\nright: 100%;\nbottom: 100%;\nleft: 100%;",
    "-inset-1/2": "top: -50%;\nright: -50%;\nbottom: -50%;\nleft: -50%;",
    "-inset-2/3": "top: -66.666667%;\nright: -66.666667%;\nbottom: -66.666667%;\nleft: -66.666667%;",
    "-inset-1/4": "top: -25%;\nright: -25%;\nbottom: -25%;\nleft: -25%;",
    "-inset-3/4": "top: -75%;\nright: -75%;\nbottom: -75%;\nleft: -75%;",
    "-inset-full": "top: -100%;\nright: -100%;\nbottom: -100%;\nleft: -100%;",
    "inset-x-1/2": "right: 50%;\nleft: 50%;",
    "inset-x-2/3": "right: 66.666667%;\nleft: 66.666667%;",
    "inset-x-1/4": "right: 25%;\nleft: 25%;",
    "inset-x-3/4": "right: 75%;\nleft: 75%;",
    "inset-x-full": "right: 100%;\nleft: 100%;",
    "-inset-x-1/2": "right: -50%;\nleft: -50%;",
    "-inset-x-2/3": "right: -66.666667%;\nleft: -66.666667%;",
    "-inset-x-1/4": "right: -25%;\nleft: -25%;",
    "-inset-x-3/4": "right: -75%;\nleft: -75%;",
    "-inset-x-full": "right: -100%;\nleft: -100%;",
    "inset-y-1/2": "top: 50%;\nbottom: 50%;",
    "inset-y-2/3": "top: 66.666667%;\nbottom: 66.666667%;",
    "inset-y-1/4": "top: 25%;\nbottom: 25%;",
    "inset-y-3/4": "top: 75%;\nbottom: 75%;",
    "inset-y-full": "top: 100%;\nbottom: 100%;",
    "-inset-y-1/2": "top: -50%;\nbottom: -50%;",
    "-inset-y-2/3": "top: -66.666667%;\nbottom: -66.666667%;",
    "-inset-y-1/4": "top: -25%;\nbottom: -25%;",
    "-inset-y-3/4": "top: -75%;\nbottom: -75%;",
    "-inset-y-full": "top: -100%;\nbottom: -100%;",
    "top-1/2": "top: 50%;",
    "top-2/3": "top: 66.666667%;",
    "top-1/4": "top: 25%;",
    "top-3/4": "top: 75%;",
    "top-full": "top: 100%;",
    "-top-1/2": "top: -50%;",
    "-top-2/3": "top: -66.666667%;",
    "-top-1/4": "top: -25%;",
    "-top-3/4": "top: -75%;",
    "-top-full": "top: -100%;",
    "right-1/2": "right: 50%;",
    "right-2/3": "right: 66.666667%;",
    "right-1/4": "right: 25%;",
    "right-3/4": "right: 75%;",
    "right-full": "right: 100%;",
    "-right-1/2": "right: -50%;",
    "-right-2/3": "right: -66.666667%;",
    "-right-1/4": "right: -25%;",
    "-right-3/4": "right: -75%;",
    "-right-full": "right: -100%;",
    "bottom-1/2": "bottom: 50%;",
    "bottom-2/3": "bottom: 66.666667%;",
    "bottom-1/4": "bottom: 25%;",
    "bottom-3/4": "bottom: 75%;",
    "bottom-full": "bottom: 100%;",
    "-bottom-1/2": "bottom: -50%;",
    "-bottom-2/3": "bottom: -66.666667%;",
    "-bottom-1/4": "bottom: -25%;",
    "-bottom-3/4": "bottom: -75%;",
    "-bottom-full": "bottom: -100%;",
    "left-1/2": "left: 50%;",
    "left-2/3": "left: 66.666667%;",
    "left-1/4": "left: 25%;",
    "left-3/4": "left: 75%;",
    "left-full": "left: 100%;",
    "-left-1/2": "left: -50%;",
    "-left-2/3": "left: -66.666667%;",
    "-left-1/4": "left: -25%;",
    "-left-3/4": "left: -75%;",
    "-left-full": "left: -100%;",
    "visible": "visibility: visible;",
    "invisible": "visibility: hidden;",
    "z-0": "z-index: 0;",
    "z-10": "z-index: 10;",
    "z-20": "z-index: 20;",
    "z-30": "z-index: 30;",
    "z-40": "z-index: 40;",
    "z-50": "z-index: 50;",
    "z-auto": "z-index: auto;",
    "w-0": "width: 0;",
    "w-0.5": "width: 0.125rem;",
    "w-1": "width: 0.25rem;",
    "w-1.5": "width: 0.375rem;",
    "w-2": "width: 0.5rem;",
    "w-2.5": "width: 0.625rem;",
    "w-3": "width: 0.75rem;",
    "w-3.5": "width: 0.875rem;",
    "w-4": "width: 1rem;",
    "w-5": "width: 1.25rem;",
    "w-6": "width: 1.5rem;",
    "w-8": "width: 2rem;",
    "w-10": "width: 2.5rem;",
    "w-11": "width: 2.75rem;",
    "w-12": "width: 3rem;",
    "w-14": "width: 3.5rem;",
    "w-16": "width: 4rem;",
    "w-20": "width: 5rem;",
    "w-24": "width: 6rem;",
    "w-28": "width: 7rem;",
    "w-32": "width: 8rem;",
    "w-36": "width: 9rem;",
    "w-40": "width: 10rem;",
    "w-44": "width: 11rem;",
    "w-48": "width: 12rem;",
    "w-52": "width: 13rem;",
    "w-56": "width: 14rem;",
    "w-64": "width: 16rem;",
    "w-72": "width: 18rem;",
    "w-80": "width: 20rem;",
    "w-96": "width: 24rem;",
    "w-px": "width: 1px;",
    "w-auto": "width: auto;",
    "w-1/2": "width: 50%;",
    "w-1/3": "width: 33.333333%;",
    "w-2/3": "width: 66.666667%;",
    "w-1/4": "width: 25%;",
    "w-2/4": "width: 50%;",
    "w-3/4": "width: 75%;",
    "w-1/5": "width: 20%;",
    "w-2/5": "width: 40%;",
    "w-3/5": "width: 60%;",
    "w-4/5": "width: 80%;",
    "w-1/6": "width: 16.666667%;",
    "w-2/6": "width: 33.333333%;",
    "w-3/6": "width: 50%;",
    "w-4/6": "width: 66.666667%;",
    "w-5/6": "width: 83.333333%;",
    "w-1/12": "width: 8.333333%;",
    "w-2/12": "width: 16.666667%;",
    "w-3/12": "width: 25%;",
    "w-4/12": "width: 33.333333%;",
    "w-5/12": "width: 41.666667%;",
    "w-6/12": "width: 50%;",
    "w-7/12": "width: 58.333333%;",
    "w-8/12": "width: 66.666667%;",
    "w-9/12": "width: 75%;",
    "w-10/12": "width: 83.333333%;",
    "w-11/12": "width: 91.666667%;",
    "w-full": "width: 100%;",
    "w-screen": "width: 100vw;",
    "w-min": "width: min-content;",
    "w-max": "width: max-content;",
    "w-fit": "width: fit-content;",
    "min-w-0": "min-width: 0;",
    "min-w-full": "min-width: 100%;",
    "min-w-min": "min-width: min-content;",
    "min-w-max": "min-width: max-content;",
    "min-w-fit": "min-width: fit-content;",
    "max-w-0": "max-width: 0rem;",
    "max-w-none": "max-width: none;",
    "max-w-xs": "max-width: 20rem;",
    "max-w-sm": "max-width: 24rem;",
    "max-w-md": "max-width: 28rem;",
    "max-w-lg": "max-width: 32rem;",
    "max-w-xl": "max-width: 36rem;",
    "max-w-2xl": "max-width: 42rem;",
    "max-w-3xl": "max-width: 48rem;",
    "max-w-4xl": "max-width: 56rem;",
    "max-w-5xl": "max-width: 64rem;",
    "max-w-6xl": "max-width: 72rem;",
    "max-w-7xl": "max-width: 80rem;",
    "max-w-full": "max-width: 100%;",
    "max-w-min": "max-width: min-content;",
    "max-w-max": "max-width: max-content;",
    "max-w-fit": "max-width: fit-content;",
    "max-w-prose": "max-width: 65ch;",
    "max-w-screen-sm": "max-width: 640px;",
    "max-w-screen-md": "max-width: 768px;",
    "max-w-screen-lg": "max-width: 1024px;",
    "max-w-screen-xl": "max-width: 1280px;",
    "max-w-screen-2xl": "max-width: 1536px;",
    "h-0": "height: 0;",
    "h-0.5": "height: 0.125rem;",
    "h-1": "height: 0.25rem;",
    "h-1.5": "height: 0.375rem;",
    "h-2": "height: 0.5rem;",
    "h-2.5": "height: 0.625rem;",
    "h-3": "height: 0.75rem;",
    "h-3.5": "height: 0.875rem;",
    "h-4": "height: 1rem;",
    "h-5": "height: 1.25rem;",
    "h-6": "height: 1.5rem;",
    "h-8": "height: 2rem;",
    "h-10": "height: 2.5rem;",
    "h-11": "height: 2.75rem;",
    "h-12": "height: 3rem;",
    "h-14": "height: 3.5rem;",
    "h-16": "height: 4rem;",
    "h-20": "height: 5rem;",
    "h-24": "height: 6rem;",
    "h-28": "height: 7rem;",
    "h-32": "height: 8rem;",
    "h-36": "height: 9rem;",
    "h-40": "height: 10rem;",
    "h-44": "height: 11rem;",
    "h-48": "height: 12rem;",
    "h-52": "height: 13rem;",
    "h-56": "height: 14rem;",
    "h-64": "height: 16rem;",
    "h-72": "height: 18rem;",
    "h-80": "height: 20rem;",
    "h-96": "height: 24rem;",
    "h-px": "height: 1px;",
    "h-auto": "height: auto;",
    "h-1/2": "height: 50%;",
    "h-1/3": "height: 33.333333%;",
    "h-2/3": "height: 66.666667%;",
    "h-1/4": "height: 25%;",
    "h-2/4": "height: 50%;",
    "h-3/4": "height: 75%;",
    "h-1/5": "height: 20%;",
    "h-2/5": "height: 40%;",
    "h-3/5": "height: 60%;",
    "h-4/5": "height: 80%;",
    "h-1/6": "height: 16.666667%;",
    "h-2/6": "height: 33.333333%;",
    "h-3/6": "height: 50%;",
    "h-4/6": "height: 66.666667%;",
    "h-5/6": "height: 83.333333%;",
    "h-full": "height: 100%;",
    "h-screen": "height: 100vh;",
    "h-min": "height: min-content;",
    "h-max": "height: max-content;",
    "h-fit": "height: fit-content;",
    "min-h-0": "min-height: 0;",
    "min-h-full": "min-height: 100%;",
    "min-h-screen": "min-height: 100vh;",
    "min-h-min": "min-height: min-content;",
    "min-h-max": "min-height: max-content;",
    "min-h-fit": "min-height: fit-content;",
    "max-h-0": "max-height: 0;",
    "max-h-0.5": "max-height: 0.125rem;",
    "max-h-1": "max-height: 0.25rem;",
    "max-h-1.5": "max-height: 0.375rem;",
    "max-h-2": "max-height: 0.5rem;",
    "max-h-2.5": "max-height: 0.625rem;",
    "max-h-3": "max-height: 0.75rem;",
    "max-h-3.5": "max-height: 0.875rem;",
    "max-h-4": "max-height: 1rem;",
    "max-h-5": "max-height: 1.25rem;",
    "max-h-6": "max-height: 1.5rem;",
    "max-h-8": "max-height: 2rem;",
    "max-h-10": "max-height: 2.5rem;",
    "max-h-11": "max-height: 2.75rem;",
    "max-h-12": "max-height: 3rem;",
    "max-h-14": "max-height: 3.5rem;",
    "max-h-16": "max-height: 4rem;",
    "max-h-20": "max-height: 5rem;",
    "max-h-24": "max-height: 6rem;",
    "max-h-28": "max-height: 7rem;",
    "max-h-32": "max-height: 8rem;",
    "max-h-36": "max-height: 9rem;",
    "max-h-40": "max-height: 10rem;",
    "max-h-44": "max-height: 11rem;",
    "max-h-48": "max-height: 12rem;",
    "max-h-52": "max-height: 13rem;",
    "max-h-56": "max-height: 14rem;",
    "max-h-64": "max-height: 16rem;",
    "max-h-72": "max-height: 18rem;",
    "max-h-80": "max-height: 20rem;",
    "max-h-96": "max-height: 24rem;",
    "max-h-px": "max-height: 1px;",
    "max-h-full": "max-height: 100%;",
    "max-h-screen": "max-height: 100vh;",
    "max-h-min": "max-height: min-content;",
    "max-h-max": "max-height: max-content;",
    "max-h-fit": "max-height: fit-content;",
    "scale-0": "--transform-scale-x: 0;\n--transform-scale-y: 0;",
    "scale-50": "--transform-scale-x: .5;\n--transform-scale-y: .5;",
    "scale-75": "--transform-scale-x: .75;\n--transform-scale-y: .75;",
    "scale-90": "--transform-scale-x: .9;\n--transform-scale-y: .9;",
    "scale-95": "--transform-scale-x: .95;\n--transform-scale-y: .95;",
    "scale-100": "--transform-scale-x: 1;\n--transform-scale-y: 1;",
    "scale-105": "--transform-scale-x: 1.05;\n--transform-scale-y: 1.05;",
    "scale-110": "--transform-scale-x: 1.1;\n--transform-scale-y: 1.1;",
    "scale-125": "--transform-scale-x: 1.25;\n--transform-scale-y: 1.25;",
    "scale-150": "--transform-scale-x: 1.5;\n--transform-scale-y: 1.5;",
    "scale-x-0": "--transform-scale-x: 0;",
    "scale-x-50": "--transform-scale-x: .5;",
    "scale-x-75": "--transform-scale-x: .75;",
    "scale-x-90": "--transform-scale-x: .9;",
    "scale-x-95": "--transform-scale-x: .95;",
    "scale-x-100": "--transform-scale-x: 1;",
    "scale-x-105": "--transform-scale-x: 1.05;",
    "scale-x-110": "--transform-scale-x: 1.1;",
    "scale-x-125": "--transform-scale-x: 1.25;",
    "scale-x-150": "--transform-scale-x: 1.5;",
    "scale-y-0": "--transform-scale-y: 0;",
    "scale-y-50": "--transform-scale-y: .5;",
    "scale-y-75": "--transform-scale-y: .75;",
    "scale-y-90": "--transform-scale-y: .9;",
    "scale-y-95": "--transform-scale-y: .95;",
    "scale-y-100": "--transform-scale-y: 1;",
    "scale-y-105": "--transform-scale-y: 1.05;",
    "scale-y-110": "--transform-scale-y: 1.1;",
    "scale-y-125": "--transform-scale-y: 1.25;",
    "scale-y-150": "--transform-scale-y: 1.5;",
    "rotate-0": "--transform-rotate: 0;",
    "rotate-1": "--transform-rotate: 1deg;",
    "rotate-2": "--transform-rotate: 2deg;",
    "rotate-3": "--transform-rotate: 3deg;",
    "rotate-6": "--transform-rotate: 6deg;",
    "rotate-12": "--transform-rotate: 12deg;",
    "rotate-45": "--transform-rotate: 45deg;",
    "rotate-90": "--transform-rotate: 90deg;",
    "rotate-180": "--transform-rotate: 180deg;",
    "translate-x-0": "--transform-translate-x: 0;",
    "translate-x-0.5": "--transform-translate-x: 0.125rem;",
    "translate-x-1": "--transform-translate-x: 0.25rem;",
    "translate-x-1.5": "--transform-translate-x: 0.375rem;",
    "translate-x-2": "--transform-translate-x: 0.5rem;",
    "translate-x-2.5": "--transform-translate-x: 0.625rem;",
    "translate-x-3": "--transform-translate-x: 0.75rem;",
    "translate-x-3.5": "--transform-translate-x: 0.875rem;",
    "translate-x-4": "--transform-translate-x: 1rem;",
    "translate-x-5": "--transform-translate-x: 1.25rem;",
    "translate-x-6": "--transform-translate-x: 1.5rem;",
    "translate-x-7": "--transform-translate-x: 1.75rem;",
    "translate-x-8": "--transform-translate-x: 2rem;",
    "translate-x-9": "--transform-translate-x: 2.25rem;",
    "translate-x-10": "--transform-translate-x: 2.5rem;",
    "translate-x-11": "--transform-translate-x: 2.75rem;",
    "translate-x-12": "--transform-translate-x: 3rem;",
    "translate-x-14": "--transform-translate-x: 3.5rem;",
    "translate-x-16": "--transform-translate-x: 4rem;",
    "translate-x-20": "--transform-translate-x: 5rem;",
    "translate-x-24": "--transform-translate-x: 6rem;",
    "translate-x-28": "--transform-translate-x: 7rem;",
    "translate-x-32": "--transform-translate-x: 8rem;",
    "translate-x-36": "--transform-translate-x: 8rem;",
    "translate-x-40": "--transform-translate-x: 10rem;",
    "translate-x-44": "--transform-translate-x: 11rem;",
    "translate-x-48": "--transform-translate-x: 12rem;",
    "translate-x-52": "--transform-translate-x: 13rem;",
    "translate-x-56": "--transform-translate-x: 14rem;",
    "translate-x-60": "--transform-translate-x: 15rem;",
    "translate-x-64": "--transform-translate-x: 16rem;",
    "translate-x-72": "--transform-translate-x: 18rem;",
    "translate-x-80": "--transform-translate-x: 20rem;",
    "translate-x-96": "--transform-translate-x: 24rem;",
    "translate-x-px": "--transform-translate-x: 1px;",
    "translate-x-1/2": "--transform-translate-x: 50%;",
    "translate-x-1/3": "--transform-translate-x: 33.333333%;",
    "translate-x-2/3": "--transform-translate-x: 66.6666666%;",
    "translate-x-1/4": "--transform-translate-x: 25%;",
    "translate-x-2/4": "--transform-translate-x: 50%;",
    "translate-x-3/4": "--transform-translate-x: 75%;",
    "translate-x-full": "--transform-translate-x: 100%;",
    "translate-y-0": "--transform-translate-y: 0;",
    "translate-y-0.5": "--transform-translate-y: 0.125rem;",
    "translate-y-1": "--transform-translate-y: 0.25rem;",
    "translate-y-1.5": "--transform-translate-y: 0.375rem;",
    "translate-y-2": "--transform-translate-y: 0.5rem;",
    "translate-y-2.5": "--transform-translate-y: 0.625rem;",
    "translate-y-3": "--transform-translate-y: 0.75rem;",
    "translate-y-3.5": "--transform-translate-y: 0.875rem;",
    "translate-y-4": "--transform-translate-y: 1rem;",
    "translate-y-5": "--transform-translate-y: 1.25rem;",
    "translate-y-6": "--transform-translate-y: 1.5rem;",
    "translate-y-7": "--transform-translate-y: 1.75rem;",
    "translate-y-8": "--transform-translate-y: 2rem;",
    "translate-y-9": "--transform-translate-y: 2.25rem;",
    "translate-y-10": "--transform-translate-y: 2.5rem;",
    "translate-y-11": "--transform-translate-y: 2.75rem;",
    "translate-y-12": "--transform-translate-y: 3rem;",
    "translate-y-14": "--transform-translate-y: 3.5rem;",
    "translate-y-16": "--transform-translate-y: 4rem;",
    "translate-y-20": "--transform-translate-y: 5rem;",
    "translate-y-24": "--transform-translate-y: 6rem;",
    "translate-y-28": "--transform-translate-y: 7rem;",
    "translate-y-32": "--transform-translate-y: 8rem;",
    "translate-y-36": "--transform-translate-y: 8rem;",
    "translate-y-40": "--transform-translate-y: 10rem;",
    "translate-y-44": "--transform-translate-y: 11rem;",
    "translate-y-48": "--transform-translate-y: 12rem;",
    "translate-y-52": "--transform-translate-y: 13rem;",
    "translate-y-56": "--transform-translate-y: 14rem;",
    "translate-y-60": "--transform-translate-y: 15rem;",
    "translate-y-64": "--transform-translate-y: 16rem;",
    "translate-y-72": "--transform-translate-y: 18rem;",
    "translate-y-80": "--transform-translate-y: 20rem;",
    "translate-y-96": "--transform-translate-y: 24rem;",
    "translate-y-px": "--transform-translate-y: 1px;",
    "translate-y-1/2": "--transform-translate-y: 50%;",
    "translate-y-1/3": "--transform-translate-y: 33.333333%;",
    "translate-y-2/3": "--transform-translate-y: 66.6666666%;",
    "translate-y-1/4": "--transform-translate-y: 25%;",
    "translate-y-2/4": "--transform-translate-y: 50%;",
    "translate-y-3/4": "--transform-translate-y: 75%;",
    "translate-y-full": "--transform-translate-y: 100%;",
    "skew-x-0": "--transform-skew-x: 0;",
    "skew-x-1": "--transform-skew-x: 1deg;",
    "skew-x-2": "--transform-skew-x: 2deg;",
    "skew-x-3": "--transform-skew-x: 3deg;",
    "skew-x-6": "--transform-skew-x: 6deg;",
    "skew-x-12": "--transform-skew-x: 12deg;",
    "skew-y-0": "--transform-skew-y: 0;",
    "skew-y-1": "--transform-skew-y: 1deg;",
    "skew-y-2": "--transform-skew-y: 2deg;",
    "skew-y-3": "--transform-skew-y: 3deg;",
    "skew-y-6": "--transform-skew-y: 6deg;",
    "skew-y-12": "--transform-skew-y: 12deg;",
    "origin-center": "transform-origin: center;",
    "origin-top": "transform-origin: top;",
    "origin-top-right": "transform-origin: top right;",
    "origin-right": "transform-origin: right;",
    "origin-bottom-right": "transform-origin: bottom right;",
    "origin-bottom": "transform-origin: bottom;",
    "origin-bottom-left": "transform-origin: bottom left;",
    "origin-left": "transform-origin: left;",
    "origin-top-left": "transform-origin: top left;",
    "shadow-xs": "box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);",
    "shadow-sm": "box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);",
    "shadow": "box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);",
    "shadow-md": "box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);",
    "shadow-lg": "box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);",
    "shadow-xl": "box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);",
    "shadow-2xl": "box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);",
    "shadow-inner": "box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);",
    "shadow-outline": "box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);",
    "shadow-none": "box-shadow: none;",
    "opacity-0": "opacity: 0;",
    "opacity-5": "opacity: 0.05;",
    "opacity-10": "opacity: 0.1;",
    "opacity-20": "opacity: 0.2;",
    "opacity-25": "opacity: 0.25;",
    "opacity-30": "opacity: 0.3;",
    "opacity-40": "opacity: 0.4;",
    "opacity-50": "opacity: 0.5;",
    "opacity-60": "opacity: 0.6;",
    "opacity-70": "opacity: 0.7;",
    "opacity-75": "opacity: 0.75;",
    "opacity-80": "opacity: 0.8;",
    "opacity-90": "opacity: 0.9;",
    "opacity-100": "opacity: 1;",
    "mix-blend-normal": "mix-blend-mode: normal;",
    "mix-blend-multiply": "mix-blend-mode: multiply;",
    "mix-blend-screen": "mix-blend-mode: screen;",
    "mix-blend-overlay": "mix-blend-mode: overlay;",
    "mix-blend-darken": "mix-blend-mode: darken;",
    "mix-blend-lighten": "mix-blend-mode: lighten;",
    "mix-blend-color-dodge": "mix-blend-mode: color-dodge;",
    "mix-blend-color-burn": "mix-blend-mode: color-burn;",
    "mix-blend-hard-light": "mix-blend-mode: hard-light;",
    "mix-blend-soft-light": "mix-blend-mode: soft-light;",
    "mix-blend-difference": "mix-blend-mode: difference;",
    "mix-blend-exclusion": "mix-blend-mode: exclusion;",
    "mix-blend-hue": "mix-blend-mode: hue;",
    "mix-blend-saturation": "mix-blend-mode: saturation;",
    "mix-blend-color": "mix-blend-mode: color;",
    "mix-blend-luminosity": "mix-blend-mode: luminosity;",
    "bg-blend-normal": "background-blend-mode: normal;",
    "bg-blend-multiply": "background-blend-mode: multiply;",
    "bg-blend-screen": "background-blend-mode: screen;",
    "bg-blend-overlay": "background-blend-mode: overlay;",
    "bg-blend-darken": "background-blend-mode: darken;",
    "bg-blend-lighten": "background-blend-mode: lighten;",
    "bg-blend-color-dodge": "background-blend-mode: color-dodge;",
    "bg-blend-color-burn": "background-blend-mode: color-burn;",
    "bg-blend-hard-light": "background-blend-mode: hard-light;",
    "bg-blend-soft-light": "background-blend-mode: soft-light;",
    "bg-blend-difference": "background-blend-mode: difference;",
    "bg-blend-exclusion": "background-blend-mode: exclusion;",
    "bg-blend-hue": "background-blend-mode: hue;",
    "bg-blend-saturation": "background-blend-mode: saturation;",
    "bg-blend-color": "background-blend-mode: color;",
    "bg-blend-luminosity": "background-blend-mode: luminosity;",
    "p-0": "padding: 0;",
    "p-0.5": "padding: 0.125rem;",
    "p-1": "padding: 0.25rem;",
    "p-1.5": "padding: 0.375rem;",
    "p-2": "padding: 0.5rem;",
    "p-2.5": "padding: 0.625rem;",
    "p-3": "padding: 0.75rem;",
    "p-3.5": "padding: 0.875rem;",
    "p-4": "padding: 1rem;",
    "p-5": "padding: 1.25rem;",
    "p-6": "padding: 1.5rem;",
    "p-8": "padding: 2rem;",
    "p-10": "padding: 2.5rem;",
    "p-11": "padding: 2.75rem;",
    "p-12": "padding: 3rem;",
    "p-14": "padding: 3.5rem;",
    "p-16": "padding: 4rem;",
    "p-20": "padding: 5rem;",
    "p-24": "padding: 6rem;",
    "p-28": "padding: 7rem;",
    "p-32": "padding: 8rem;",
    "p-36": "padding: 9rem;",
    "p-40": "padding: 10rem;",
    "p-44": "padding: 11rem;",
    "p-48": "padding: 12rem;",
    "p-52": "padding: 13rem;",
    "p-56": "padding: 14rem;",
    "p-64": "padding: 16rem;",
    "p-72": "padding: 18rem;",
    "p-80": "padding: 20rem;",
    "p-96": "padding: 24rem;",
    "p-px": "padding: 1px;",
    "py-0": "padding-top: 0;\npadding-bottom: 0;",
    "px-0": "padding-left: 0;\npadding-right: 0;",
    "py-0.5": "padding-top: 0.125rem;\npadding-bottom: 0.125rem;",
    "px-0.5": "padding-left: 0.125rem;\npadding-right: 0.125rem;",
    "py-1": "padding-top: 0.25rem;\npadding-bottom: 0.25rem;",
    "px-1": "padding-left: 0.25rem;\npadding-right: 0.25rem;",
    "py-1.5": "padding-top: 0.375rem;\npadding-bottom: 0.375rem;",
    "px-1.5": "padding-left: 0.375rem;\npadding-right: 0.375rem;",
    "py-2": "padding-top: 0.5rem;\npadding-bottom: 0.5rem;",
    "px-2": "padding-left: 0.5rem;\npadding-right: 0.5rem;",
    "py-2.5": "padding-top: 0.625rem;\npadding-bottom: 0.625rem;",
    "px-2.5": "padding-left: 0.625rem;\npadding-right: 0.625rem;",
    "py-3": "padding-top: 0.75rem;\npadding-bottom: 0.75rem;",
    "px-3": "padding-left: 0.75rem;\npadding-right: 0.75rem;",
    "py-3.5": "padding-top: 0.875rem;\npadding-bottom: 0.875rem;",
    "px-3.5": "padding-left: 0.875rem;\npadding-right: 0.875rem;",
    "py-4": "padding-top: 1rem;\npadding-bottom: 1rem;",
    "px-4": "padding-left: 1rem;\npadding-right: 1rem;",
    "py-5": "padding-top: 1.25rem;\npadding-bottom: 1.25rem;",
    "px-5": "padding-left: 1.25rem;\npadding-right: 1.25rem;",
    "py-6": "padding-top: 1.5rem;\npadding-bottom: 1.5rem;",
    "px-6": "padding-left: 1.5rem;\npadding-right: 1.5rem;",
    "py-7": "padding-top: 1.75rem;\npadding-bottom: 1.75rem;",
    "px-7": "padding-left: 1.75rem;\npadding-right: 1.75rem;",
    "py-8": "padding-top: 2rem;\npadding-bottom: 2rem;",
    "px-8": "padding-left: 2rem;\npadding-right: 2rem;",
    "py-9": "padding-top: 2.25rem;\npadding-bottom: 2.25rem;",
    "px-9": "padding-left: 2.25rem;\npadding-right: 2.25rem;",
    "py-10": "padding-top: 2.5rem;\npadding-bottom: 2.5rem;",
    "px-10": "padding-left: 2.5rem;\npadding-right: 2.5rem;",
    "py-11": "padding-top: 2.75rem;\npadding-bottom: 2.75rem;",
    "px-11": "padding-left: 2.75rem;\npadding-right: 2.75rem;",
    "py-12": "padding-top: 3rem;\npadding-bottom: 3rem;",
    "px-12": "padding-left: 3rem;\npadding-right: 3rem;",
    "py-14": "padding-top: 3.5rem;\npadding-bottom: 3.5rem;",
    "px-14": "padding-left: 3.5rem;\npadding-right: 3.5rem;",
    "py-16": "padding-top: 4rem;\npadding-bottom: 4rem;",
    "px-16": "padding-left: 4rem;\npadding-right: 4rem;",
    "py-20": "padding-top: 5rem;\npadding-bottom: 5rem;",
    "px-20": "padding-left: 5rem;\npadding-right: 5rem;",
    "py-24": "padding-top: 6rem;\npadding-bottom: 6rem;",
    "px-24": "padding-left: 6rem;\npadding-right: 6rem;",
    "py-28": "padding-top: 7rem;\npadding-bottom: 7rem;",
    "px-28": "padding-left: 7rem;\npadding-right: 7rem;",
    "py-32": "padding-top: 8rem;\npadding-bottom: 8rem;",
    "px-32": "padding-left: 8rem;\npadding-right: 8rem;",
    "py-36": "padding-top: 9rem;\npadding-bottom: 9rem;",
    "px-36": "padding-left: 9rem;\npadding-right: 9rem;",
    "py-40": "padding-top: 10rem;\npadding-bottom: 10rem;",
    "px-40": "padding-left: 10rem;\npadding-right: 10rem;",
    "py-44": "padding-top: 11rem;\npadding-bottom: 11rem;",
    "px-44": "padding-left: 11rem;\npadding-right: 11rem;",
    "py-48": "padding-top: 12rem;\npadding-bottom: 12rem;",
    "px-48": "padding-left: 12rem;\npadding-right: 12rem;",
    "py-52": "padding-top: 13rem;\npadding-bottom: 13rem;",
    "px-52": "padding-left: 13rem;\npadding-right: 13rem;",
    "py-56": "padding-top: 14rem;\npadding-bottom: 14rem;",
    "px-56": "padding-left: 14rem;\npadding-right: 14rem;",
    "py-60": "padding-top: 15rem;\npadding-bottom: 15rem;",
    "px-60": "padding-left: 15rem;\npadding-right: 15rem;",
    "py-64": "padding-top: 16rem;\npadding-bottom: 16rem;",
    "px-64": "padding-left: 16rem;\npadding-right: 16rem;",
    "py-70": "padding-top: 18rem;\npadding-bottom: 18rem;",
    "px-70": "padding-left: 18rem;\npadding-right: 18rem;",
    "py-80": "padding-top: 20rem;\npadding-bottom: 20rem;",
    "px-80": "padding-left: 20rem;\npadding-right: 20rem;",
    "py-96": "padding-top: 24rem;\npadding-bottom: 24rem;",
    "px-96": "padding-left: 24rem;\npadding-right: 24rem;",
    "py-px": "padding-top: 1px;\npadding-bottom: 1px;",
    "px-px": "padding-left: 1px;\npadding-right: 1px;",
    "pt-0": "padding-top: 0;",
    "pr-0": "padding-right: 0;",
    "pb-0": "padding-bottom: 0;",
    "pl-0": "padding-left: 0;",
    "pt-0.5": "padding-top: 0.125rem;",
    "pr-0.5": "padding-right: 0.125rem;",
    "pb-0.5": "padding-bottom: 0.125rem;",
    "pl-0.5": "padding-left: 0.125rem;",
    "pt-1": "padding-top: 0.25rem;",
    "pr-1": "padding-right: 0.25rem;",
    "pb-1": "padding-bottom: 0.25rem;",
    "pl-1": "padding-left: 0.25rem;",
    "pt-1.5": "padding-top: 0.375rem;",
    "pr-1.5": "padding-right: 0.375rem;",
    "pb-1.5": "padding-bottom: 0.375rem;",
    "pl-1.5": "padding-left: 0.375rem;",
    "pt-2": "padding-top: 0.5rem;",
    "pr-2": "padding-right: 0.5rem;",
    "pb-2": "padding-bottom: 0.5rem;",
    "pl-2": "padding-left: 0.5rem;",
    "pt-2.5": "padding-top: 0.625rem;",
    "pr-2.5": "padding-right: 0.625rem;",
    "pb-2.5": "padding-bottom: 0.625rem;",
    "pl-2.5": "padding-left: 0.625rem;",
    "pt-3": "padding-top: 0.75rem;",
    "pr-3": "padding-right: 0.75rem;",
    "pb-3": "padding-bottom: 0.75rem;",
    "pl-3": "padding-left: 0.75rem;",
    "pt-3.5": "padding-top: 0.875rem;",
    "pr-3.5": "padding-right: 0.875rem;",
    "pb-3.5": "padding-bottom: 0.875rem;",
    "pl-3.5": "padding-left: 0.875rem;",
    "pt-4": "padding-top: 1rem;",
    "pr-4": "padding-right: 1rem;",
    "pb-4": "padding-bottom: 1rem;",
    "pl-4": "padding-left: 1rem;",
    "pt-5": "padding-top: 1.25rem;",
    "pr-5": "padding-right: 1.25rem;",
    "pb-5": "padding-bottom: 1.25rem;",
    "pl-5": "padding-left: 1.25rem;",
    "pt-6": "padding-top: 1.5rem;",
    "pr-6": "padding-right: 1.5rem;",
    "pb-6": "padding-bottom: 1.5rem;",
    "pl-6": "padding-left: 1.5rem;",
    "pt-7": "padding-top: 1.75rem;",
    "pr-7": "padding-right: 1.75rem;",
    "pb-7": "padding-bottom: 1.75rem;",
    "pl-7": "padding-left: 1.75rem;",
    "pt-8": "padding-top: 2rem;",
    "pr-8": "padding-right: 2rem;",
    "pb-8": "padding-bottom: 2rem;",
    "pl-8": "padding-left: 2rem;",
    "pt-9": "padding-top: 2.25rem;",
    "pr-9": "padding-right: 2.25rem;",
    "pb-9": "padding-bottom: 2.25rem;",
    "pl-9": "padding-left: 2.25rem;",
    "pt-10": "padding-top: 2.5rem;",
    "pr-10": "padding-right: 2.5rem;",
    "pb-10": "padding-bottom: 2.5rem;",
    "pl-10": "padding-left: 2.5rem;",
    "pt-11": "padding-top: 2.75rem;",
    "pr-11": "padding-right: 2.75rem;",
    "pb-11": "padding-bottom: 2.75rem;",
    "pl-11": "padding-left: 2.75rem;",
    "pt-12": "padding-top: 3rem;",
    "pr-12": "padding-right: 3rem;",
    "pb-12": "padding-bottom: 3rem;",
    "pl-12": "padding-left: 3rem;",
    "pt-14": "padding-top: 3.5rem;",
    "pr-14": "padding-right: 3.5rem;",
    "pb-14": "padding-bottom: 3.5rem;",
    "pl-14": "padding-left: 3.5rem;",
    "pt-16": "padding-top: 4rem;",
    "pr-16": "padding-right: 4rem;",
    "pb-16": "padding-bottom: 4rem;",
    "pl-16": "padding-left: 4rem;",
    "pt-20": "padding-top: 5rem;",
    "pr-20": "padding-right: 5rem;",
    "pb-20": "padding-bottom: 5rem;",
    "pl-20": "padding-left: 5rem;",
    "pt-24": "padding-top: 6rem;",
    "pr-24": "padding-right: 6rem;",
    "pb-24": "padding-bottom: 6rem;",
    "pl-24": "padding-left: 6rem;",
    "pt-28": "padding-top: 7rem;",
    "pr-28": "padding-right: 7rem;",
    "pb-28": "padding-bottom: 7rem;",
    "pl-28": "padding-left: 7rem;",
    "pt-32": "padding-top: 8rem;",
    "pr-32": "padding-right: 8rem;",
    "pb-32": "padding-bottom: 8rem;",
    "pl-32": "padding-left: 8rem;",
    "pt-36": "padding-top: 9rem;",
    "pr-36": "padding-right: 9rem;",
    "pb-36": "padding-bottom: 9rem;",
    "pl-36": "padding-left: 9rem;",
    "pt-40": "padding-top: 10rem;",
    "pr-40": "padding-right: 10rem;",
    "pb-40": "padding-bottom: 10rem;",
    "pl-40": "padding-left: 10rem;",
    "pt-44": "padding-top: 11rem;",
    "pr-44": "padding-right: 11rem;",
    "pb-44": "padding-bottom: 11rem;",
    "pl-44": "padding-left: 11rem;",
    "pt-48": "padding-top: 12rem;",
    "pr-48": "padding-right: 12rem;",
    "pb-48": "padding-bottom: 12rem;",
    "pl-48": "padding-left: 12rem;",
    "pt-52": "padding-top: 13rem;",
    "pr-52": "padding-right: 13rem;",
    "pb-52": "padding-bottom: 13rem;",
    "pl-52": "padding-left: 13rem;",
    "pt-56": "padding-top: 14rem;",
    "pr-56": "padding-right: 14rem;",
    "pb-56": "padding-bottom: 14rem;",
    "pl-56": "padding-left: 14rem;",
    "pt-60": "padding-top: 15rem;",
    "pr-60": "padding-right: 15rem;",
    "pb-60": "padding-bottom: 15rem;",
    "pl-60": "padding-left: 15rem;",
    "pt-64": "padding-top: 16rem;",
    "pr-64": "padding-right: 16rem;",
    "pb-64": "padding-bottom: 16rem;",
    "pl-64": "padding-left: 16rem;",
    "pt-72": "padding-top: 18rem;",
    "pr-72": "padding-right: 18rem;",
    "pb-72": "padding-bottom: 18rem;",
    "pl-72": "padding-left: 18rem;",
    "pt-80": "padding-top: 20rem;",
    "pr-80": "padding-right: 20rem;",
    "pb-80": "padding-bottom: 20rem;",
    "pl-80": "padding-left: 20rem;",
    "pt-96": "padding-top: 24rem;",
    "pr-96": "padding-right: 24rem;",
    "pb-96": "padding-bottom: 24rem;",
    "pl-96": "padding-left: 24rem;",
    "pt-px": "padding-top: 1px;",
    "pr-px": "padding-right: 1px;",
    "pb-px": "padding-bottom: 1px;",
    "pl-px": "padding-left: 1px;",
    "m-0": "margin: 0;",
    "m-0.5": "margin: 0.125rem;",
    "m-1": "margin: 0.25rem;",
    "m-1.5": "margin: 0.375rem;",
    "m-2": "margin: 0.5rem;",
    "m-2.5": "margin: 0.625rem;",
    "m-3": "margin: 0.75rem;",
    "m-3.5": "margin: 0.875rem;",
    "m-4": "margin: 1rem;",
    "m-5": "margin: 1.25rem;",
    "m-6": "margin: 1.5rem;",
    "m-8": "margin: 2rem;",
    "m-10": "margin: 2.5rem;",
    "m-11": "margin: 2.75rem;",
    "m-12": "margin: 3rem;",
    "m-14": "margin: 3.5rem;",
    "m-16": "margin: 4rem;",
    "m-20": "margin: 5rem;",
    "m-24": "margin: 6rem;",
    "m-28": "margin: 7rem;",
    "m-32": "margin: 8rem;",
    "m-36": "margin: 9rem;",
    "m-40": "margin: 10rem;",
    "m-44": "margin: 11rem;",
    "m-48": "margin: 12rem;",
    "m-52": "margin: 13rem;",
    "m-56": "margin: 14rem;",
    "m-64": "margin: 16rem;",
    "m-72": "margin: 18rem;",
    "m-80": "margin: 20rem;",
    "m-96": "margin: 24rem;",
    "m-px": "margin: 1px;",
    "my-0": "margin-top: 0;\nmargin-bottom: 0;",
    "mx-0": "margin-left: 0;\nmargin-right: 0;",
    "my-0.5": "margin-top: 0.125rem;\nmargin-bottom: 0.125rem;",
    "mx-0.5": "margin-left: 0.125rem;\nmargin-right: 0.125rem;",
    "my-1": "margin-top: 0.25rem;\nmargin-bottom: 0.25rem;",
    "mx-1": "margin-left: 0.25rem;\nmargin-right: 0.25rem;",
    "my-1.5": "margin-top: 0.375rem;\nmargin-bottom: 0.375rem;",
    "mx-1.5": "margin-left: 0.375rem;\nmargin-right: 0.375rem;",
    "my-2": "margin-top: 0.5rem;\nmargin-bottom: 0.5rem;",
    "mx-2": "margin-left: 0.5rem;\nmargin-right: 0.5rem;",
    "my-2.5": "margin-top: 0.625rem;\nmargin-bottom: 0.625rem;",
    "mx-2.5": "margin-left: 0.625rem;\nmargin-right: 0.625rem;",
    "my-3": "margin-top: 0.75rem;\nmargin-bottom: 0.75rem;",
    "mx-3": "margin-left: 0.75rem;\nmargin-right: 0.75rem;",
    "my-3.5": "margin-top: 0.875rem;\nmargin-bottom: 0.875rem;",
    "mx-3.5": "margin-left: 0.875rem;\nmargin-right: 0.875rem;",
    "my-4": "margin-top: 1rem;\nmargin-bottom: 1rem;",
    "mx-4": "margin-left: 1rem;\nmargin-right: 1rem;",
    "my-5": "margin-top: 1.25rem;\nmargin-bottom: 1.25rem;",
    "mx-5": "margin-left: 1.25rem;\nmargin-right: 1.25rem;",
    "my-6": "margin-top: 1.5rem;\nmargin-bottom: 1.5rem;",
    "mx-6": "margin-left: 1.5rem;\nmargin-right: 1.5rem;",
    "my-7": "margin-top: 1.75rem;\nmargin-bottom: 1.75rem;",
    "mx-7": "margin-left: 1.75rem;\nmargin-right: 1.75rem;",
    "my-8": "margin-top: 2rem;\nmargin-bottom: 2rem;",
    "mx-8": "margin-left: 2rem;\nmargin-right: 2rem;",
    "my-9": "margin-top: 2.25rem;\nmargin-bottom: 2.25rem;",
    "mx-9": "margin-left: 2.25rem;\nmargin-right: 2.25rem;",
    "my-10": "margin-top: 2.5rem;\nmargin-bottom: 2.5rem;",
    "mx-10": "margin-left: 2.5rem;\nmargin-right: 2.5rem;",
    "my-11": "margin-top: 2.75rem;\nmargin-bottom: 2.75rem;",
    "mx-11": "margin-left: 2.75rem;\nmargin-right: 2.75rem;",
    "my-12": "margin-top: 3rem;\nmargin-bottom: 3rem;",
    "mx-12": "margin-left: 3rem;\nmargin-right: 3rem;",
    "my-14": "margin-top: 3.5rem;\nmargin-bottom: 3.5rem;",
    "mx-14": "margin-left: 3.5rem;\nmargin-right: 3.5rem;",
    "my-16": "margin-top: 4rem;\nmargin-bottom: 4rem;",
    "mx-16": "margin-left: 4rem;\nmargin-right: 4rem;",
    "my-20": "margin-top: 5rem;\nmargin-bottom: 5rem;",
    "mx-20": "margin-left: 5rem;\nmargin-right: 5rem;",
    "my-24": "margin-top: 6rem;\nmargin-bottom: 6rem;",
    "mx-24": "margin-left: 6rem;\nmargin-right: 6rem;",
    "my-28": "margin-top: 7rem;\nmargin-bottom: 7rem;",
    "mx-28": "margin-left: 7rem;\nmargin-right: 7rem;",
    "my-32": "margin-top: 8rem;\nmargin-bottom: 8rem;",
    "mx-32": "margin-left: 8rem;\nmargin-right: 8rem;",
    "my-36": "margin-top: 9rem;\nmargin-bottom: 9rem;",
    "mx-36": "margin-left: 9rem;\nmargin-right: 9rem;",
    "my-40": "margin-top: 10rem;\nmargin-bottom: 10rem;",
    "mx-40": "margin-left: 10rem;\nmargin-right: 10rem;",
    "my-44": "margin-top: 11rem;\nmargin-bottom: 11rem;",
    "mx-44": "margin-left: 11rem;\nmargin-right: 11rem;",
    "my-48": "margin-top: 12rem;\nmargin-bottom: 12rem;",
    "mx-48": "margin-left: 12rem;\nmargin-right: 12rem;",
    "my-52": "margin-top: 13rem;\nmargin-bottom: 13rem;",
    "mx-52": "margin-left: 13rem;\nmargin-right: 13rem;",
    "my-56": "margin-top: 14rem;\nmargin-bottom: 14rem;",
    "mx-56": "margin-left: 14rem;\nmargin-right: 14rem;",
    "my-60": "margin-top: 15rem;\nmargin-bottom: 15rem;",
    "mx-60": "margin-left: 15rem;\nmargin-right: 15rem;",
    "my-64": "margin-top: 16rem;\nmargin-bottom: 16rem;",
    "mx-64": "margin-left: 16rem;\nmargin-right: 16rem;",
    "my-70": "margin-top: 18rem;\nmargin-bottom: 18rem;",
    "mx-70": "margin-left: 18rem;\nmargin-right: 18rem;",
    "my-80": "margin-top: 20rem;\nmargin-bottom: 20rem;",
    "mx-80": "margin-left: 20rem;\nmargin-right: 20rem;",
    "my-96": "margin-top: 24rem;\nmargin-bottom: 24rem;",
    "mx-96": "margin-left: 24rem;\nmargin-right: 24rem;",
    "my-px": "margin-top: 1px;\nmargin-bottom: 1px;",
    "mx-px": "margin-left: 1px;\nmargin-right: 1px;",
    "mt-0": "margin-top: 0;",
    "mr-0": "margin-right: 0;",
    "mb-0": "margin-bottom: 0;",
    "ml-0": "margin-left: 0;",
    "mt-0.5": "margin-top: 0.125rem;",
    "mr-0.5": "margin-right: 0.125rem;",
    "mb-0.5": "margin-bottom: 0.125rem;",
    "ml-0.5": "margin-left: 0.125rem;",
    "mt-1": "margin-top: 0.25rem;",
    "mr-1": "margin-right: 0.25rem;",
    "mb-1": "margin-bottom: 0.25rem;",
    "ml-1": "margin-left: 0.25rem;",
    "mt-1.5": "margin-top: 0.375rem;",
    "mr-1.5": "margin-right: 0.375rem;",
    "mb-1.5": "margin-bottom: 0.375rem;",
    "ml-1.5": "margin-left: 0.375rem;",
    "mt-2": "margin-top: 0.5rem;",
    "mr-2": "margin-right: 0.5rem;",
    "mb-2": "margin-bottom: 0.5rem;",
    "ml-2": "margin-left: 0.5rem;",
    "mt-2.5": "margin-top: 0.625rem;",
    "mr-2.5": "margin-right: 0.625rem;",
    "mb-2.5": "margin-bottom: 0.625rem;",
    "ml-2.5": "margin-left: 0.625rem;",
    "mt-3": "margin-top: 0.75rem;",
    "mr-3": "margin-right: 0.75rem;",
    "mb-3": "margin-bottom: 0.75rem;",
    "ml-3": "margin-left: 0.75rem;",
    "mt-3.5": "margin-top: 0.875rem;",
    "mr-3.5": "margin-right: 0.875rem;",
    "mb-3.5": "margin-bottom: 0.875rem;",
    "ml-3.5": "margin-left: 0.875rem;",
    "mt-4": "margin-top: 1rem;",
    "mr-4": "margin-right: 1rem;",
    "mb-4": "margin-bottom: 1rem;",
    "ml-4": "margin-left: 1rem;",
    "mt-5": "margin-top: 1.25rem;",
    "mr-5": "margin-right: 1.25rem;",
    "mb-5": "margin-bottom: 1.25rem;",
    "ml-5": "margin-left: 1.25rem;",
    "mt-6": "margin-top: 1.5rem;",
    "mr-6": "margin-right: 1.5rem;",
    "mb-6": "margin-bottom: 1.5rem;",
    "ml-6": "margin-left: 1.5rem;",
    "mt-7": "margin-top: 1.75rem;",
    "mr-7": "margin-right: 1.75rem;",
    "mb-7": "margin-bottom: 1.75rem;",
    "ml-7": "margin-left: 1.75rem;",
    "mt-8": "margin-top: 2rem;",
    "mr-8": "margin-right: 2rem;",
    "mb-8": "margin-bottom: 2rem;",
    "ml-8": "margin-left: 2rem;",
    "mt-9": "margin-top: 2.25rem;",
    "mr-9": "margin-right: 2.25rem;",
    "mb-9": "margin-bottom: 2.25rem;",
    "ml-9": "margin-left: 2.25rem;",
    "mt-10": "margin-top: 2.5rem;",
    "mr-10": "margin-right: 2.5rem;",
    "mb-10": "margin-bottom: 2.5rem;",
    "ml-10": "margin-left: 2.5rem;",
    "mt-11": "margin-top: 2.75rem;",
    "mr-11": "margin-right: 2.75rem;",
    "mb-11": "margin-bottom: 2.75rem;",
    "ml-11": "margin-left: 2.75rem;",
    "mt-12": "margin-top: 3rem;",
    "mr-12": "margin-right: 3rem;",
    "mb-12": "margin-bottom: 3rem;",
    "ml-12": "margin-left: 3rem;",
    "mt-14": "margin-top: 3.5rem;",
    "mr-14": "margin-right: 3.5rem;",
    "mb-14": "margin-bottom: 3.5rem;",
    "ml-14": "margin-left: 3.5rem;",
    "mt-16": "margin-top: 4rem;",
    "mr-16": "margin-right: 4rem;",
    "mb-16": "margin-bottom: 4rem;",
    "ml-16": "margin-left: 4rem;",
    "mt-20": "margin-top: 5rem;",
    "mr-20": "margin-right: 5rem;",
    "mb-20": "margin-bottom: 5rem;",
    "ml-20": "margin-left: 5rem;",
    "mt-24": "margin-top: 6rem;",
    "mr-24": "margin-right: 6rem;",
    "mb-24": "margin-bottom: 6rem;",
    "ml-24": "margin-left: 6rem;",
    "mt-28": "margin-top: 7rem;",
    "mr-28": "margin-right: 7rem;",
    "mb-28": "margin-bottom: 7rem;",
    "ml-28": "margin-left: 7rem;",
    "mt-32": "margin-top: 8rem;",
    "mr-32": "margin-right: 8rem;",
    "mb-32": "margin-bottom: 8rem;",
    "ml-32": "margin-left: 8rem;",
    "mt-36": "margin-top: 9rem;",
    "mr-36": "margin-right: 9rem;",
    "mb-36": "margin-bottom: 9rem;",
    "ml-36": "margin-left: 9rem;",
    "mt-40": "margin-top: 10rem;",
    "mr-40": "margin-right: 10rem;",
    "mb-40": "margin-bottom: 10rem;",
    "ml-40": "margin-left: 10rem;",
    "mt-44": "margin-top: 11rem;",
    "mr-44": "margin-right: 11rem;",
    "mb-44": "margin-bottom: 11rem;",
    "ml-44": "margin-left: 11rem;",
    "mt-48": "margin-top: 12rem;",
    "mr-48": "margin-right: 12rem;",
    "mb-48": "margin-bottom: 12rem;",
    "ml-48": "margin-left: 12rem;",
    "mt-52": "margin-top: 13rem;",
    "mr-52": "margin-right: 13rem;",
    "mb-52": "margin-bottom: 13rem;",
    "ml-52": "margin-left: 13rem;",
    "mt-56": "margin-top: 14rem;",
    "mr-56": "margin-right: 14rem;",
    "mb-56": "margin-bottom: 14rem;",
    "ml-56": "margin-left: 14rem;",
    "mt-60": "margin-top: 15rem;",
    "mr-60": "margin-right: 15rem;",
    "mb-60": "margin-bottom: 15rem;",
    "ml-60": "margin-left: 15rem;",
    "mt-64": "margin-top: 16rem;",
    "mr-64": "margin-right: 16rem;",
    "mb-64": "margin-bottom: 16rem;",
    "ml-64": "margin-left: 16rem;",
    "mt-72": "margin-top: 18rem;",
    "mr-72": "margin-right: 18rem;",
    "mb-72": "margin-bottom: 18rem;",
    "ml-72": "margin-left: 18rem;",
    "mt-80": "margin-top: 20rem;",
    "mr-80": "margin-right: 20rem;",
    "mb-80": "margin-bottom: 20rem;",
    "ml-80": "margin-left: 20rem;",
    "mt-96": "margin-top: 24rem;",
    "mr-96": "margin-right: 24rem;",
    "mb-96": "margin-bottom: 24rem;",
    "ml-96": "margin-left: 24rem;",
    "mt-px": "margin-top: 1px;",
    "mr-px": "margin-right: 1px;",
    "mb-px": "margin-bottom: 1px;",
    "ml-px": "margin-left: 1px;",
    "-m-0": "margin: 0;",
    "-m-0.5": "margin: -0.125rem;",
    "-m-1": "margin: -0.25rem;",
    "-m-1.5": "margin: -0.375rem;",
    "-m-2": "margin: -0.5rem;",
    "-m-2.5": "margin: -0.625rem;",
    "-m-3": "margin: -0.75rem;",
    "-m-3.5": "margin: -0.875rem;",
    "-m-4": "margin: -1rem;",
    "-m-5": "margin: -1.25rem;",
    "-m-6": "margin: -1.5rem;",
    "-m-8": "margin: -2rem;",
    "-m-10": "margin: -2.5rem;",
    "-m-11": "margin: -2.75rem;",
    "-m-12": "margin: -3rem;",
    "-m-14": "margin: -3.5rem;",
    "-m-16": "margin: -4rem;",
    "-m-20": "margin: -5rem;",
    "-m-24": "margin: -6rem;",
    "-m-28": "margin: -7rem;",
    "-m-32": "margin: -8rem;",
    "-m-36": "margin: -9rem;",
    "-m-40": "margin: -10rem;",
    "-m-44": "margin: -11rem;",
    "-m-48": "margin: -12rem;",
    "-m-52": "margin: -13rem;",
    "-m-56": "margin: -14rem;",
    "-m-64": "margin: -16rem;",
    "-m-72": "margin: -18rem;",
    "-m-80": "margin: -20rem;",
    "-m-96": "margin: -24rem;",
    "-m-px": "margin: -1px;",
    "-my-0": "margin-top: 0;\nmargin-bottom: 0;",
    "-mx-0": "margin-left: 0;\nmargin-right: 0;",
    "-my-0.5": "margin-top: -0.125rem;\nmargin-bottom: -0.125rem;",
    "-mx-0.5": "margin-left: -0.125rem;\nmargin-right: -0.125rem;",
    "-my-1": "margin-top: -0.25rem;\nmargin-bottom: -0.25rem;",
    "-mx-1": "margin-left: -0.25rem;\nmargin-right: -0.25rem;",
    "-my-1.5": "margin-top: -0.375rem;\nmargin-bottom: -0.375rem;",
    "-mx-1.5": "margin-left: -0.375rem;\nmargin-right: -0.375rem;",
    "-my-2": "margin-top: -0.5rem;\nmargin-bottom: -0.5rem;",
    "-mx-2": "margin-left: -0.5rem;\nmargin-right: -0.5rem;",
    "-my-2.5": "margin-top: -0.625rem;\nmargin-bottom: -0.625rem;",
    "-mx-2.5": "margin-left: -0.625rem;\nmargin-right: -0.625rem;",
    "-my-3": "margin-top: -0.75rem;\nmargin-bottom: -0.75rem;",
    "-mx-3": "margin-left: -0.75rem;\nmargin-right: -0.75rem;",
    "-my-3.5": "margin-top: -0.875rem;\nmargin-bottom: -0.875rem;",
    "-mx-3.5": "margin-left: -0.875rem;\nmargin-right: -0.875rem;",
    "-my-4": "margin-top: -1rem;\nmargin-bottom: -1rem;",
    "-mx-4": "margin-left: -1rem;\nmargin-right: -1rem;",
    "-my-5": "margin-top: -1.25rem;\nmargin-bottom: -1.25rem;",
    "-mx-5": "margin-left: -1.25rem;\nmargin-right: -1.25rem;",
    "-my-6": "margin-top: -1.5rem;\nmargin-bottom: -1.5rem;",
    "-mx-6": "margin-left: -1.5rem;\nmargin-right: -1.5rem;",
    "-my-7": "margin-top: 1.75rem;\nmargin-bottom: 1.75rem;",
    "-mx-7": "margin-left: 1.75rem;\nmargin-right: 1.75rem;",
    "-my-8": "margin-top: -2rem;\nmargin-bottom: -2rem;",
    "-mx-8": "margin-left: -2rem;\nmargin-right: -2rem;",
    "-my-9": "margin-top: 2.25rem;\nmargin-bottom: 2.25rem;",
    "-mx-9": "margin-left: 2.25rem;\nmargin-right: 2.25rem;",
    "-my-10": "margin-top: -2.5rem;\nmargin-bottom: -2.5rem;",
    "-mx-10": "margin-left: -2.5rem;\nmargin-right: -2.5rem;",
    "-my-11": "margin-top: -2.75rem;\nmargin-bottom: -2.75rem;",
    "-mx-11": "margin-left: -2.75rem;\nmargin-right: -2.75rem;",
    "-my-12": "margin-top: -3rem;\nmargin-bottom: -3rem;",
    "-mx-12": "margin-left: -3rem;\nmargin-right: -3rem;",
    "-my-14": "margin-top: -3.5rem;\nmargin-bottom: -3.5rem;",
    "-mx-14": "margin-left: -3.5rem;\nmargin-right: -3.5rem;",
    "-my-16": "margin-top: -4rem;\nmargin-bottom: -4rem;",
    "-mx-16": "margin-left: -4rem;\nmargin-right: -4rem;",
    "-my-20": "margin-top: -5rem;\nmargin-bottom: -5rem;",
    "-mx-20": "margin-left: -5rem;\nmargin-right: -5rem;",
    "-my-24": "margin-top: -6rem;\nmargin-bottom: -6rem;",
    "-mx-24": "margin-left: -6rem;\nmargin-right: -6rem;",
    "-my-28": "margin-top: -7rem;\nmargin-bottom: -7rem;",
    "-mx-28": "margin-left: -7rem;\nmargin-right: -7rem;",
    "-my-32": "margin-top: -8rem;\nmargin-bottom: -8rem;",
    "-mx-32": "margin-left: -8rem;\nmargin-right: -8rem;",
    "-my-36": "margin-top: -9rem;\nmargin-bottom: -9rem;",
    "-mx-36": "margin-left: -9rem;\nmargin-right: -9rem;",
    "-my-40": "margin-top: -10rem;\nmargin-bottom: -10rem;",
    "-mx-40": "margin-left: -10rem;\nmargin-right: -10rem;",
    "-my-44": "margin-top: -11rem;\nmargin-bottom: -11rem;",
    "-mx-44": "margin-left: -11rem;\nmargin-right: -11rem;",
    "-my-48": "margin-top: -12rem;\nmargin-bottom: -12rem;",
    "-mx-48": "margin-left: -12rem;\nmargin-right: -12rem;",
    "-my-52": "margin-top: -13rem;\nmargin-bottom: -13rem;",
    "-mx-52": "margin-left: -13rem;\nmargin-right: -13rem;",
    "-my-56": "margin-top: -14rem;\nmargin-bottom: -14rem;",
    "-mx-56": "margin-left: -14rem;\nmargin-right: -14rem;",
    "-my-60": "margin-top: 15rem;\nmargin-bottom: 15rem;",
    "-mx-60": "margin-left: 15rem;\nmargin-right: 15rem;",
    "-my-64": "margin-top: -16rem;\nmargin-bottom: -16rem;",
    "-mx-64": "margin-left: -16rem;\nmargin-right: -16rem;",
    "-my-70": "margin-top: -18rem;\nmargin-bottom: -18rem;",
    "-mx-70": "margin-left: -18rem;\nmargin-right: -18rem;",
    "-my-80": "margin-top: -20rem;\nmargin-bottom: -20rem;",
    "-mx-80": "margin-left: -20rem;\nmargin-right: -20rem;",
    "-my-96": "margin-top: -24rem;\nmargin-bottom: -24rem;",
    "-mx-96": "margin-left: -24rem;\nmargin-right: -24rem;",
    "-my-px": "margin-top: -1px;\nmargin-bottom: -1px;",
    "-mx-px": "margin-left: -1px;\nmargin-right: -1px;",
    "-mt-0": "margin-top: 0;",
    "-mr-0": "margin-right: 0;",
    "-mb-0": "margin-bottom: 0;",
    "-ml-0": "margin-left: 0;",
    "-mt-0.5": "margin-top: -0.125rem;",
    "-mr-0.5": "margin-right: -0.125rem;",
    "-mb-0.5": "margin-bottom: -0.125rem;",
    "-ml-0.5": "margin-left: -0.125rem;",
    "-mt-1": "margin-top: -0.25rem;",
    "-mr-1": "margin-right: -0.25rem;",
    "-mb-1": "margin-bottom: -0.25rem;",
    "-ml-1": "margin-left: -0.25rem;",
    "-mt-1.5": "margin-top: -0.375rem;",
    "-mr-1.5": "margin-right: -0.375rem;",
    "-mb-1.5": "margin-bottom: -0.375rem;",
    "-ml-1.5": "margin-left: -0.375rem;",
    "-mt-2": "margin-top: -0.5rem;",
    "-mr-2": "margin-right: -0.5rem;",
    "-mb-2": "margin-bottom: -0.5rem;",
    "-ml-2": "margin-left: -0.5rem;",
    "-mt-2.5": "margin-top: -0.625rem;",
    "-mr-2.5": "margin-right: -0.625rem;",
    "-mb-2.5": "margin-bottom: -0.625rem;",
    "-ml-2.5": "margin-left: -0.625rem;",
    "-mt-3": "margin-top: -0.75rem;",
    "-mr-3": "margin-right: -0.75rem;",
    "-mb-3": "margin-bottom: -0.75rem;",
    "-ml-3": "margin-left: -0.75rem;",
    "-mt-3.5": "margin-top: -0.875rem;",
    "-mr-3.5": "margin-right: -0.875rem;",
    "-mb-3.5": "margin-bottom: -0.875rem;",
    "-ml-3.5": "margin-left: -0.875rem;",
    "-mt-4": "margin-top: -1rem;",
    "-mr-4": "margin-right: -1rem;",
    "-mb-4": "margin-bottom: -1rem;",
    "-ml-4": "margin-left: -1rem;",
    "-mt-5": "margin-top: -1.25rem;",
    "-mr-5": "margin-right: -1.25rem;",
    "-mb-5": "margin-bottom: -1.25rem;",
    "-ml-5": "margin-left: -1.25rem;",
    "-mt-6": "margin-top: -1.5rem;",
    "-mr-6": "margin-right: -1.5rem;",
    "-mb-6": "margin-bottom: -1.5rem;",
    "-ml-6": "margin-left: -1.5rem;",
    "-mt-7": "margin-top: 1.75rem;",
    "-mr-7": "margin-right: 1.75rem;",
    "-mb-7": "margin-bottom: 1.75rem;",
    "-ml-7": "margin-left: 1.75rem;",
    "-mt-8": "margin-top: -2rem;",
    "-mr-8": "margin-right: -2rem;",
    "-mb-8": "margin-bottom: -2rem;",
    "-ml-8": "margin-left: -2rem;",
    "-mt-9": "margin-top: 2.25rem;",
    "-mr-9": "margin-right: 2.25rem;",
    "-mb-9": "margin-bottom: 2.25rem;",
    "-ml-9": "margin-left: 2.25rem;",
    "-mt-10": "margin-top: -2.5rem;",
    "-mr-10": "margin-right: -2.5rem;",
    "-mb-10": "margin-bottom: -2.5rem;",
    "-ml-10": "margin-left: -2.5rem;",
    "-mt-11": "margin-top: -2.75rem;",
    "-mr-11": "margin-right: -2.75rem;",
    "-mb-11": "margin-bottom: -2.75rem;",
    "-ml-11": "margin-left: -2.75rem;",
    "-mt-12": "margin-top: -3rem;",
    "-mr-12": "margin-right: -3rem;",
    "-mb-12": "margin-bottom: -3rem;",
    "-ml-12": "margin-left: -3rem;",
    "-mt-14": "margin-top: -3.5rem;",
    "-mr-14": "margin-right: -3.5rem;",
    "-mb-14": "margin-bottom: -3.5rem;",
    "-ml-14": "margin-left: -3.5rem;",
    "-mt-16": "margin-top: -4rem;",
    "-mr-16": "margin-right: -4rem;",
    "-mb-16": "margin-bottom: -4rem;",
    "-ml-16": "margin-left: -4rem;",
    "-mt-20": "margin-top: -5rem;",
    "-mr-20": "margin-right: -5rem;",
    "-mb-20": "margin-bottom: -5rem;",
    "-ml-20": "margin-left: -5rem;",
    "-mt-24": "margin-top: -6rem;",
    "-mr-24": "margin-right: -6rem;",
    "-mb-24": "margin-bottom: -6rem;",
    "-ml-24": "margin-left: -6rem;",
    "-mt-28": "margin-top: -7rem;",
    "-mr-28": "margin-right: -7rem;",
    "-mb-28": "margin-bottom: -7rem;",
    "-ml-28": "margin-left: -7rem;",
    "-mt-32": "margin-top: -8rem;",
    "-mr-32": "margin-right: -8rem;",
    "-mb-32": "margin-bottom: -8rem;",
    "-ml-32": "margin-left: -8rem;",
    "-mt-36": "margin-top: -9rem;",
    "-mr-36": "margin-right: -9rem;",
    "-mb-36": "margin-bottom: -9rem;",
    "-ml-36": "margin-left: -9rem;",
    "-mt-40": "margin-top: -10rem;",
    "-mr-40": "margin-right: -10rem;",
    "-mb-40": "margin-bottom: -10rem;",
    "-ml-40": "margin-left: -10rem;",
    "-mt-44": "margin-top: -11rem;",
    "-mr-44": "margin-right: -11rem;",
    "-mb-44": "margin-bottom: -11rem;",
    "-ml-44": "margin-left: -11rem;",
    "-mt-48": "margin-top: -12rem;",
    "-mr-48": "margin-right: -12rem;",
    "-mb-48": "margin-bottom: -12rem;",
    "-ml-48": "margin-left: -12rem;",
    "-mt-52": "margin-top: -13rem;",
    "-mr-52": "margin-right: -13rem;",
    "-mb-52": "margin-bottom: -13rem;",
    "-ml-52": "margin-left: -13rem;",
    "-mt-56": "margin-top: -14rem;",
    "-mr-56": "margin-right: -14rem;",
    "-mb-56": "margin-bottom: -14rem;",
    "-ml-56": "margin-left: -14rem;",
    "-mt-60": "margin-top: 15rem;",
    "-mr-60": "margin-right: 15rem;",
    "-mb-60": "margin-bottom: 15rem;",
    "-ml-60": "margin-left: 15rem;",
    "-mt-64": "margin-top: -16rem;",
    "-mr-64": "margin-right: -16rem;",
    "-mb-64": "margin-bottom: -16rem;",
    "-ml-64": "margin-left: -16rem;",
    "-mt-72": "margin-top: -18rem;",
    "-mr-72": "margin-right: -18rem;",
    "-mb-72": "margin-bottom: -18rem;",
    "-ml-72": "margin-left: -18rem;",
    "-mt-80": "margin-top: -20rem;",
    "-mr-80": "margin-right: -20rem;",
    "-mb-80": "margin-bottom: -20rem;",
    "-ml-80": "margin-left: -20rem;",
    "-mt-96": "margin-top: -24rem;",
    "-mr-96": "margin-right: -24rem;",
    "-mb-96": "margin-bottom: -24rem;",
    "-ml-96": "margin-left: -24rem;",
    "-mt-px": "margin-top: -1px;",
    "-mr-px": "margin-right: -1px;",
    "-mb-px": "margin-bottom: -1px;",
    "-ml-px": "margin-left: -1px;",
    "space-x-0": "margin-left: 0;",
    "space-x-0.5": "margin-left: 0.125rem;",
    "space-x-1": "margin-left: 0.25rem;",
    "space-x-1.5": "margin-left: 0.375rem;",
    "space-x-2": "margin-left: 0.5rem;",
    "space-x-2.5": "margin-left: 0.625rem;",
    "space-x-3": "margin-left: 0.875rem;",
    "space-x-4": "margin-left: 1rem;",
    "space-x-5": "margin-left: 1.25rem;",
    "space-x-6": "margin-left: 1.5rem;",
    "space-x-7": "margin-left: 1.75rem;",
    "space-x-8": "margin-left: 2rem;",
    "space-x-9": "margin-left: 2.25rem;",
    "space-x-10": "margin-left: 2.5rem;",
    "space-x-11": "margin-left: 2.75rem;",
    "space-x-12": "margin-left: 3rem;",
    "space-x-14": "margin-left: 3.5rem;",
    "space-x-16": "margin-left: 4rem;",
    "space-x-20": "margin-left: 5rem;",
    "space-x-24": "margin-left: 6rem;",
    "space-x-28": "margin-left: 7rem;",
    "space-x-32": "margin-left: 8rem;",
    "space-x-36": "margin-left: 9rem;",
    "space-x-40": "margin-left: 10rem;",
    "space-x-44": "margin-left: 11rem;",
    "space-x-48": "margin-left: 12rem;",
    "space-x-52": "margin-left: 13rem;",
    "space-x-56": "margin-left: 14rem;",
    "space-x-60": "margin-left: 15rem;",
    "space-x-64": "margin-left: 16rem;",
    "space-x-72": "margin-left: 18rem;",
    "space-x-80": "margin-left: 20rem;",
    "space-x-96": "margin-left: 24rem;",
    "space-x-px": "margin-left: 1px;",
    "-space-x-0": "margin-left: 0;",
    "-space-x-0.5": "margin-left: -0.125rem;",
    "-space-x-1": "margin-left: -0.25rem;",
    "-space-x-1.5": "margin-left: -0.375rem;",
    "-space-x-2": "margin-left: -0.5rem;",
    "-space-x-2.5": "margin-left: -0.625rem;",
    "-space-x-3": "margin-left: -0.875rem;",
    "-space-x-4": "margin-left: -1rem;",
    "-space-x-5": "margin-left: -1.25rem;",
    "-space-x-6": "margin-left: -1.5rem;",
    "-space-x-7": "margin-left: -1.75rem;",
    "-space-x-8": "margin-left: -2rem;",
    "-space-x-9": "margin-left: -2.25rem;",
    "-space-x-10": "margin-left: -2.5rem;",
    "-space-x-11": "margin-left: -2.75rem;",
    "-space-x-12": "margin-left: -3rem;",
    "-space-x-14": "margin-left: -3.5rem;",
    "-space-x-16": "margin-left: -4rem;",
    "-space-x-20": "margin-left: -5rem;",
    "-space-x-24": "margin-left: -6rem;",
    "-space-x-28": "margin-left: -7rem;",
    "-space-x-32": "margin-left: -8rem;",
    "-space-x-36": "margin-left: -9rem;",
    "-space-x-40": "margin-left: -10rem;",
    "-space-x-44": "margin-left: -11rem;",
    "-space-x-48": "margin-left: -12rem;",
    "-space-x-52": "margin-left: -13rem;",
    "-space-x-56": "margin-left: -14rem;",
    "-space-x-60": "margin-left: -15rem;",
    "-space-x-64": "margin-left: -16rem;",
    "-space-x-72": "margin-left: -18rem;",
    "-space-x-80": "margin-left: -20rem;",
    "-space-x-96": "margin-left: -24rem;",
    "-space-x-px": "margin-left: -1px;",
    "space-y-0": "margin-top: 0;",
    "space-y-0.5": "margin-top: 0.125rem;",
    "space-y-1": "margin-top: 0.25rem;",
    "space-y-1.5": "margin-top: 0.375rem;",
    "space-y-2": "margin-top: 0.5rem;",
    "space-y-2.5": "margin-top: 0.625rem;",
    "space-y-3": "margin-top: 0.875rem;",
    "space-y-4": "margin-top: 1rem;",
    "space-y-5": "margin-top: 1.25rem;",
    "space-y-6": "margin-top: 1.5rem;",
    "space-y-7": "margin-top: 1.75rem;",
    "space-y-8": "margin-top: 2rem;",
    "space-y-9": "margin-top: 2.25rem;",
    "space-y-10": "margin-top: 2.5rem;",
    "space-y-11": "margin-top: 2.75rem;",
    "space-y-12": "margin-top: 3rem;",
    "space-y-14": "margin-top: 3.5rem;",
    "space-y-16": "margin-top: 4rem;",
    "space-y-20": "margin-top: 5rem;",
    "space-y-24": "margin-top: 6rem;",
    "space-y-28": "margin-top: 7rem;",
    "space-y-32": "margin-top: 8rem;",
    "space-y-36": "margin-top: 9rem;",
    "space-y-40": "margin-top: 10rem;",
    "space-y-44": "margin-top: 11rem;",
    "space-y-48": "margin-top: 12rem;",
    "space-y-52": "margin-top: 13rem;",
    "space-y-56": "margin-top: 14rem;",
    "space-y-60": "margin-top: 15rem;",
    "space-y-64": "margin-top: 16rem;",
    "space-y-72": "margin-top: 18rem;",
    "space-y-80": "margin-top: 20rem;",
    "space-y-96": "margin-top: 24rem;",
    "space-y-px": "margin-top: 1px;",
    "-space-y-0": "margin-top: 0;",
    "-space-y-0.5": "margin-top: -0.125rem;",
    "-space-y-1": "margin-top: -0.25rem;",
    "-space-y-1.5": "margin-top: -0.375rem;",
    "-space-y-2": "margin-top: -0.5rem;",
    "-space-y-2.5": "margin-top: -0.625rem;",
    "-space-y-3": "margin-top: -0.875rem;",
    "-space-y-4": "margin-top: -1rem;",
    "-space-y-5": "margin-top: -1.25rem;",
    "-space-y-6": "margin-top: -1.5rem;",
    "-space-y-7": "margin-top: -1.75rem;",
    "-space-y-8": "margin-top: -2rem;",
    "-space-y-9": "margin-top: -2.25rem;",
    "-space-y-10": "margin-top: -2.5rem;",
    "-space-y-11": "margin-top: -2.75rem;",
    "-space-y-12": "margin-top: -3rem;",
    "-space-y-14": "margin-top: -3.5rem;",
    "-space-y-16": "margin-top: -4rem;",
    "-space-y-20": "margin-top: -5rem;",
    "-space-y-24": "margin-top: -6rem;",
    "-space-y-28": "margin-top: -7rem;",
    "-space-y-32": "margin-top: -8rem;",
    "-space-y-36": "margin-top: -9rem;",
    "-space-y-40": "margin-top: -10rem;",
    "-space-y-44": "margin-top: -11rem;",
    "-space-y-48": "margin-top: -12rem;",
    "-space-y-52": "margin-top: -13rem;",
    "-space-y-56": "margin-top: -14rem;",
    "-space-y-60": "margin-top: -15rem;",
    "-space-y-64": "margin-top: -16rem;",
    "-space-y-72": "margin-top: -18rem;",
    "-space-y-80": "margin-top: -20rem;",
    "-space-y-96": "margin-top: -24rem;",
    "-space-y-px": "margin-top: -1px;",
    "space-x-reverse": "--space-x-reverse: 1;",
    "space-y-reverse": "--space-y-reverse: 1;",
    "font-sans": "font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";",
    "font-serif": "font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;",
    "font-mono": "font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;",
    "text-xs": "font-size: 0.75rem;\nline-height: 1rem;",
    "text-sm": "font-size: 0.875rem;\nline-height: 1.25rem;",
    "text-base": "font-size: 1rem;\nline-height: 1.5rem;",
    "text-lg": "font-size: 1.125rem;\nline-height: 1.75rem;",
    "text-xl": "font-size: 1.25rem;\nline-height: 1.75rem;",
    "text-2xl": "font-size: 1.5rem;\nline-height: 2rem;",
    "text-3xl": "font-size: 1.875rem;\nline-height: 2.25rem;",
    "text-4xl": "font-size: 2.25rem;\nline-height: 2.5rem;",
    "text-5xl": "font-size: 3rem;\nline-height: 1;",
    "text-6xl": "font-size: 3.75rem;\nline-height: 1;",
    "text-7xl": "font-size: 4.5rem;\nline-height: 1;",
    "text-8xl": "font-size: 6rem;\nline-height: 1;",
    "text-9xl": "font-size: 8rem;\nline-height: 1;",
    "antialiased": "-webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale;",
    "subpixel-antialiased": "-webkit-font-smoothing: auto;\n-moz-osx-font-smoothing: auto;",
    "italic": "font-style: italic;",
    "not-italic": "font-style: normal;",
    "font-thin": "font-weight: 100;",
    "font-extralight": "font-weight: 200;",
    "font-light": "font-weight: 300;",
    "font-normal": "font-weight: 400;",
    "font-medium": "font-weight: 500;",
    "font-semibold": "font-weight: 600;",
    "font-bold": "font-weight: 700;",
    "font-extrabold": "font-weight: 800;",
    "font-black": "font-weight: 900;",
    "normal-nums": "font-variant-numeric: normal;",
    "ordinal": "font-variant-numeric: ordinal;",
    "slashed-zero": "font-variant-numeric: slashed-zero;",
    "lining-nums": "font-variant-numeric: lining-nums;",
    "oldstyle-nums": "font-variant-numeric: oldstyle-nums;",
    "proportional-nums": "font-variant-numeric: proportional-nums;",
    "tabular-nums": "font-variant-numeric: tabular-nums;",
    "diagonal-fractions": "font-variant-numeric: diagonal-fractions;",
    "stacked-fractions": "font-variant-numeric: stacked-fractions;",
    "tracking-tighter": "letter-spacing: -0.05em;",
    "tracking-tight": "letter-spacing: -0.025em;",
    "tracking-normal": "letter-spacing: 0;",
    "tracking-wide": "letter-spacing: 0.025em;",
    "tracking-wider": "letter-spacing: 0.05em;",
    "tracking-widest": "letter-spacing: 0.1em;",
    "leading-none": "line-height: 1;",
    "leading-tight": "line-height: 1.25;",
    "leading-snug": "line-height: 1.375;",
    "leading-normal": "line-height: 1.5;",
    "leading-relaxed": "line-height: 1.625;",
    "leading-loose": "line-height: 2;",
    "leading-3": "line-height: .75rem;",
    "leading-4": "line-height: 1rem;",
    "leading-5": "line-height: 1.25rem;",
    "leading-6": "line-height: 1.5rem;",
    "leading-7": "line-height: 1.75rem;",
    "leading-8": "line-height: 2rem;",
    "leading-9": "line-height: 2.25rem;",
    "leading-10": "line-height: 2.5rem;",
    "list-none": "list-style-type: none;",
    "list-disc": "list-style-type: disc;",
    "list-decimal": "list-style-type: decimal;",
    "list-inside": "list-style-position: inside;",
    "list-outside": "list-style-position: outside;",
    "text-left": "text-align: left;",
    "text-center": "text-align: center;",
    "text-right": "text-align: right;",
    "text-justify": "text-align: justify;",
    "underline": "text-decoration: underline;",
    "overline": "text-decoration: overline;",
    "line-through": "text-decoration: line-through;",
    "no-underline": "text-decoration: none;",
    "decoration-solid": "text-decoration-style: solid;",
    "decoration-double": "text-decoration-style: double;",
    "decoration-dotted": "text-decoration-style: dotted;",
    "decoration-dashed": "text-decoration-style: dashed;",
    "decoration-wavy": "text-decoration-style: wavy;",
    "decoration-auto": "text-decoration-thickness: auto;",
    "decoration-from-font": "text-decoration-thickness: from-font;",
    "decoration-0": "text-decoration-thickness: 0px;",
    "decoration-1": "text-decoration-thickness: 1px;",
    "decoration-2": "text-decoration-thickness: 2px;",
    "decoration-4": "text-decoration-thickness: 4px;",
    "decoration-8": "text-decoration-thickness: 8px;",
    "underline-offset-auto": "text-underline-offset: auto;",
    "underline-offset-from-font": "text-underline-offset: from-font;",
    "underline-offset-0": "text-underline-offset: 0px;",
    "underline-offset-1": "text-underline-offset: 1px;",
    "underline-offset-2": "text-underline-offset: 2px;",
    "underline-offset-4": "text-underline-offset: 4px;",
    "underline-offset-8": "text-underline-offset: 8px;",
    "uppercase": "text-transform: uppercase;",
    "lowercase": "text-transform: lowercase;",
    "capitalize": "text-transform: capitalize;",
    "normal-case": "text-transform: none;",
    "truncate": "overflow: hidden;\ntext-overflow: ellipsis;\nwhite-space: nowrap;",
    "text-ellipsis": "text-overflow: ellipsis;",
    "text-clip": "text-overflow: clip;",
    "indent-0": "text-indent: 0;",
    "indent-0.5": "text-indent: 0.125rem;",
    "indent-1": "text-indent: 0.25rem;",
    "indent-1.5": "text-indent: 0.375rem;",
    "indent-2": "text-indent: 0.5rem;",
    "indent-2.5": "text-indent: 0.625rem;",
    "indent-3": "text-indent: 0.75rem;",
    "indent-3.5": "text-indent: 0.875rem;",
    "indent-4": "text-indent: 1rem;",
    "indent-5": "text-indent: 1.25rem;",
    "indent-6": "text-indent: 1.5rem;",
    "indent-8": "text-indent: 2rem;",
    "indent-10": "text-indent: 2.5rem;",
    "indent-11": "text-indent: 2.75rem;",
    "indent-12": "text-indent: 3rem;",
    "indent-14": "text-indent: 3.5rem;",
    "indent-16": "text-indent: 4rem;",
    "indent-20": "text-indent: 5rem;",
    "indent-24": "text-indent: 6rem;",
    "indent-28": "text-indent: 7rem;",
    "indent-32": "text-indent: 8rem;",
    "indent-36": "text-indent: 9rem;",
    "indent-40": "text-indent: 10rem;",
    "indent-44": "text-indent: 11rem;",
    "indent-48": "text-indent: 12rem;",
    "indent-52": "text-indent: 13rem;",
    "indent-56": "text-indent: 14rem;",
    "indent-64": "text-indent: 16rem;",
    "indent-72": "text-indent: 18rem;",
    "indent-80": "text-indent: 20rem;",
    "indent-96": "text-indent: 24rem;",
    "indent-px": "text-indent: 1px;",
    "align-baseline": "vertical-align: baseline;",
    "align-top": "vertical-align: top;",
    "align-middle": "vertical-align: middle;",
    "align-bottom": "vertical-align: bottom;",
    "align-text-top": "vertical-align: text-top;",
    "align-text-bottom": "vertical-align: text-bottom;",
    "align-sub": "vertical-align: sub;",
    "align-super": "vertical-align: super;",
    "whitespace-normal": "white-space: normal;",
    "whitespace-nowrap": "white-space: nowrap;",
    "whitespace-pre": "white-space: pre;",
    "whitespace-pre-line": "white-space: pre-line;",
    "whitespace-pre-wrap": "white-space: pre-wrap;",
    "break-normal": "overflow-wrap: normal;\nword-break: normal;",
    "break-words": "overflow-wrap: break-word;",
    "break-all": "word-break: break-all;",
    "content-none": "content: none;",
    "appearance-none": "appearance: none;",
    "cursor-auto": "cursor: auto;",
    "cursor-default": "cursor: default;",
    "cursor-pointer": "cursor: pointer;",
    "cursor-wait": "cursor: wait;",
    "cursor-text": "cursor: text;",
    "cursor-move": "cursor: move;",
    "cursor-help": "cursor: help;",
    "cursor-not-allowed": "cursor: not-allowed;",
    "cursor-none": "cursor: none;",
    "cursor-context-menu": "cursor: context-menu;",
    "cursor-progress": "cursor: progress;",
    "cursor-cell": "cursor: cell;",
    "cursor-crosshair": "cursor: crosshair;",
    "cursor-vertical-text": "cursor: vertical-text;",
    "cursor-alias": "cursor: alias;",
    "cursor-copy": "cursor: copy;",
    "cursor-no-drop": "cursor: no-drop;",
    "cursor-grab": "cursor: grab;",
    "cursor-grabbing": "cursor: grabbing;",
    "cursor-all-scroll": "cursor: all-scroll;",
    "cursor-col-resize": "cursor: col-resize;",
    "cursor-row-resize": "cursor: row-resize;",
    "cursor-n-resize": "cursor: n-resize;",
    "cursor-e-resize": "cursor: e-resize;",
    "cursor-s-resize": "cursor: s-resize;",
    "cursor-w-resize": "cursor: w-resize;",
    "cursor-ne-resize": "cursor: ne-resize;",
    "cursor-nw-resize": "cursor: nw-resize;",
    "cursor-se-resize": "cursor: se-resize;",
    "cursor-sw-resize": "cursor: sw-resize;",
    "cursor-ew-resize": "cursor: ew-resize;",
    "cursor-ns-resize": "cursor: ns-resize;",
    "cursor-nesw-resize": "cursor: nesw-resize;",
    "cursor-nwse-resize": "cursor: nwse-resize;",
    "cursor-zoom-in": "cursor: zoom-in;",
    "cursor-zoom-out": "cursor: zoom-out;",
    "pointer-events-none": "pointer-events: none;",
    "pointer-events-auto": "pointer-events: auto;",
    "resize-none": "resize: none;",
    "resize": "resize: both;",
    "resize-y": "resize: vertical;",
    "resize-x": "resize: horizontal;",
    "scroll-auto": "scroll-behavior: auto;",
    "scroll-smooth": "scroll-behavior: smooth;",
    "scroll-m-0": "scroll-margin: 0;",
    "scroll-m-0.5": "scroll-margin: 0.125rem;",
    "scroll-m-1": "scroll-margin: 0.25rem;",
    "scroll-m-1.5": "scroll-margin: 0.375rem;",
    "scroll-m-2": "scroll-margin: 0.5rem;",
    "scroll-m-2.5": "scroll-margin: 0.625rem;",
    "scroll-m-3": "scroll-margin: 0.75rem;",
    "scroll-m-3.5": "scroll-margin: 0.875rem;",
    "scroll-m-4": "scroll-margin: 1rem;",
    "scroll-m-5": "scroll-margin: 1.25rem;",
    "scroll-m-6": "scroll-margin: 1.5rem;",
    "scroll-m-8": "scroll-margin: 2rem;",
    "scroll-m-10": "scroll-margin: 2.5rem;",
    "scroll-m-11": "scroll-margin: 2.75rem;",
    "scroll-m-12": "scroll-margin: 3rem;",
    "scroll-m-14": "scroll-margin: 3.5rem;",
    "scroll-m-16": "scroll-margin: 4rem;",
    "scroll-m-20": "scroll-margin: 5rem;",
    "scroll-m-24": "scroll-margin: 6rem;",
    "scroll-m-28": "scroll-margin: 7rem;",
    "scroll-m-32": "scroll-margin: 8rem;",
    "scroll-m-36": "scroll-margin: 9rem;",
    "scroll-m-40": "scroll-margin: 10rem;",
    "scroll-m-44": "scroll-margin: 11rem;",
    "scroll-m-48": "scroll-margin: 12rem;",
    "scroll-m-52": "scroll-margin: 13rem;",
    "scroll-m-56": "scroll-margin: 14rem;",
    "scroll-m-64": "scroll-margin: 16rem;",
    "scroll-m-72": "scroll-margin: 18rem;",
    "scroll-m-80": "scroll-margin: 20rem;",
    "scroll-m-96": "scroll-margin: 24rem;",
    "scroll-m-px": "scroll-margin: 1px;",
    "scroll-my-0": "scroll-margin-top: 0;\nscroll-margin-bottom: 0;",
    "scroll-mx-0": "scroll-margin-left: 0;\nscroll-margin-right: 0;",
    "scroll-my-0.5": "scroll-margin-top: 0.125rem;\nscroll-margin-bottom: 0.125rem;",
    "scroll-mx-0.5": "scroll-margin-left: 0.125rem;\nscroll-margin-right: 0.125rem;",
    "scroll-my-1": "scroll-margin-top: 0.25rem;\nscroll-margin-bottom: 0.25rem;",
    "scroll-mx-1": "scroll-margin-left: 0.25rem;\nscroll-margin-right: 0.25rem;",
    "scroll-my-1.5": "scroll-margin-top: 0.375rem;\nscroll-margin-bottom: 0.375rem;",
    "scroll-mx-1.5": "scroll-margin-left: 0.375rem;\nscroll-margin-right: 0.375rem;",
    "scroll-my-2": "scroll-margin-top: 0.5rem;\nscroll-margin-bottom: 0.5rem;",
    "scroll-mx-2": "scroll-margin-left: 0.5rem;\nscroll-margin-right: 0.5rem;",
    "scroll-my-2.5": "scroll-margin-top: 0.625rem;\nscroll-margin-bottom: 0.625rem;",
    "scroll-mx-2.5": "scroll-margin-left: 0.625rem;\nscroll-margin-right: 0.625rem;",
    "scroll-my-3": "scroll-margin-top: 0.75rem;\nscroll-margin-bottom: 0.75rem;",
    "scroll-mx-3": "scroll-margin-left: 0.75rem;\nscroll-margin-right: 0.75rem;",
    "scroll-my-3.5": "scroll-margin-top: 0.875rem;\nscroll-margin-bottom: 0.875rem;",
    "scroll-mx-3.5": "scroll-margin-left: 0.875rem;\nscroll-margin-right: 0.875rem;",
    "scroll-my-4": "scroll-margin-top: 1rem;\nscroll-margin-bottom: 1rem;",
    "scroll-mx-4": "scroll-margin-left: 1rem;\nscroll-margin-right: 1rem;",
    "scroll-my-5": "scroll-margin-top: 1.25rem;\nscroll-margin-bottom: 1.25rem;",
    "scroll-mx-5": "scroll-margin-left: 1.25rem;\nscroll-margin-right: 1.25rem;",
    "scroll-my-6": "scroll-margin-top: 1.5rem;\nscroll-margin-bottom: 1.5rem;",
    "scroll-mx-6": "scroll-margin-left: 1.5rem;\nscroll-margin-right: 1.5rem;",
    "scroll-my-7": "scroll-margin-top: 1.75rem;\nscroll-margin-bottom: 1.75rem;",
    "scroll-mx-7": "scroll-margin-left: 1.75rem;\nscroll-margin-right: 1.75rem;",
    "scroll-my-8": "scroll-margin-top: 2rem;\nscroll-margin-bottom: 2rem;",
    "scroll-mx-8": "scroll-margin-left: 2rem;\nscroll-margin-right: 2rem;",
    "scroll-my-9": "scroll-margin-top: 2.25rem;\nscroll-margin-bottom: 2.25rem;",
    "scroll-mx-9": "scroll-margin-left: 2.25rem;\nscroll-margin-right: 2.25rem;",
    "scroll-my-10": "scroll-margin-top: 2.5rem;\nscroll-margin-bottom: 2.5rem;",
    "scroll-mx-10": "scroll-margin-left: 2.5rem;\nscroll-margin-right: 2.5rem;",
    "scroll-my-11": "scroll-margin-top: 2.75rem;\nscroll-margin-bottom: 2.75rem;",
    "scroll-mx-11": "scroll-margin-left: 2.75rem;\nscroll-margin-right: 2.75rem;",
    "scroll-my-12": "scroll-margin-top: 3rem;\nscroll-margin-bottom: 3rem;",
    "scroll-mx-12": "scroll-margin-left: 3rem;\nscroll-margin-right: 3rem;",
    "scroll-my-14": "scroll-margin-top: 3.5rem;\nscroll-margin-bottom: 3.5rem;",
    "scroll-mx-14": "scroll-margin-left: 3.5rem;\nscroll-margin-right: 3.5rem;",
    "scroll-my-16": "scroll-margin-top: 4rem;\nscroll-margin-bottom: 4rem;",
    "scroll-mx-16": "scroll-margin-left: 4rem;\nscroll-margin-right: 4rem;",
    "scroll-my-20": "scroll-margin-top: 5rem;\nscroll-margin-bottom: 5rem;",
    "scroll-mx-20": "scroll-margin-left: 5rem;\nscroll-margin-right: 5rem;",
    "scroll-my-24": "scroll-margin-top: 6rem;\nscroll-margin-bottom: 6rem;",
    "scroll-mx-24": "scroll-margin-left: 6rem;\nscroll-margin-right: 6rem;",
    "scroll-my-28": "scroll-margin-top: 7rem;\nscroll-margin-bottom: 7rem;",
    "scroll-mx-28": "scroll-margin-left: 7rem;\nscroll-margin-right: 7rem;",
    "scroll-my-32": "scroll-margin-top: 8rem;\nscroll-margin-bottom: 8rem;",
    "scroll-mx-32": "scroll-margin-left: 8rem;\nscroll-margin-right: 8rem;",
    "scroll-my-36": "scroll-margin-top: 9rem;\nscroll-margin-bottom: 9rem;",
    "scroll-mx-36": "scroll-margin-left: 9rem;\nscroll-margin-right: 9rem;",
    "scroll-my-40": "scroll-margin-top: 10rem;\nscroll-margin-bottom: 10rem;",
    "scroll-mx-40": "scroll-margin-left: 10rem;\nscroll-margin-right: 10rem;",
    "scroll-my-44": "scroll-margin-top: 11rem;\nscroll-margin-bottom: 11rem;",
    "scroll-mx-44": "scroll-margin-left: 11rem;\nscroll-margin-right: 11rem;",
    "scroll-my-48": "scroll-margin-top: 12rem;\nscroll-margin-bottom: 12rem;",
    "scroll-mx-48": "scroll-margin-left: 12rem;\nscroll-margin-right: 12rem;",
    "scroll-my-52": "scroll-margin-top: 13rem;\nscroll-margin-bottom: 13rem;",
    "scroll-mx-52": "scroll-margin-left: 13rem;\nscroll-margin-right: 13rem;",
    "scroll-my-56": "scroll-margin-top: 14rem;\nscroll-margin-bottom: 14rem;",
    "scroll-mx-56": "scroll-margin-left: 14rem;\nscroll-margin-right: 14rem;",
    "scroll-my-60": "scroll-margin-top: 15rem;\nscroll-margin-bottom: 15rem;",
    "scroll-mx-60": "scroll-margin-left: 15rem;\nscroll-margin-right: 15rem;",
    "scroll-my-64": "scroll-margin-top: 16rem;\nscroll-margin-bottom: 16rem;",
    "scroll-mx-64": "scroll-margin-left: 16rem;\nscroll-margin-right: 16rem;",
    "scroll-my-70": "scroll-margin-top: 18rem;\nscroll-margin-bottom: 18rem;",
    "scroll-mx-70": "scroll-margin-left: 18rem;\nscroll-margin-right: 18rem;",
    "scroll-my-80": "scroll-margin-top: 20rem;\nscroll-margin-bottom: 20rem;",
    "scroll-mx-80": "scroll-margin-left: 20rem;\nscroll-margin-right: 20rem;",
    "scroll-my-96": "scroll-margin-top: 24rem;\nscroll-margin-bottom: 24rem;",
    "scroll-mx-96": "scroll-margin-left: 24rem;\nscroll-margin-right: 24rem;",
    "scroll-my-px": "scroll-margin-top: 1px;\nscroll-margin-bottom: 1px;",
    "scroll-mx-px": "scroll-margin-left: 1px;\nscroll-margin-right: 1px;",
    "scroll-mt-0": "scroll-margin-top: 0;",
    "scroll-mr-0": "scroll-margin-right: 0;",
    "scroll-mb-0": "scroll-margin-bottom: 0;",
    "scroll-ml-0": "scroll-margin-left: 0;",
    "scroll-mt-0.5": "scroll-margin-top: 0.125rem;",
    "scroll-mr-0.5": "scroll-margin-right: 0.125rem;",
    "scroll-mb-0.5": "scroll-margin-bottom: 0.125rem;",
    "scroll-ml-0.5": "scroll-margin-left: 0.125rem;",
    "scroll-mt-1": "scroll-margin-top: 0.25rem;",
    "scroll-mr-1": "scroll-margin-right: 0.25rem;",
    "scroll-mb-1": "scroll-margin-bottom: 0.25rem;",
    "scroll-ml-1": "scroll-margin-left: 0.25rem;",
    "scroll-mt-1.5": "scroll-margin-top: 0.375rem;",
    "scroll-mr-1.5": "scroll-margin-right: 0.375rem;",
    "scroll-mb-1.5": "scroll-margin-bottom: 0.375rem;",
    "scroll-ml-1.5": "scroll-margin-left: 0.375rem;",
    "scroll-mt-2": "scroll-margin-top: 0.5rem;",
    "scroll-mr-2": "scroll-margin-right: 0.5rem;",
    "scroll-mb-2": "scroll-margin-bottom: 0.5rem;",
    "scroll-ml-2": "scroll-margin-left: 0.5rem;",
    "scroll-mt-2.5": "scroll-margin-top: 0.625rem;",
    "scroll-mr-2.5": "scroll-margin-right: 0.625rem;",
    "scroll-mb-2.5": "scroll-margin-bottom: 0.625rem;",
    "scroll-ml-2.5": "scroll-margin-left: 0.625rem;",
    "scroll-mt-3": "scroll-margin-top: 0.75rem;",
    "scroll-mr-3": "scroll-margin-right: 0.75rem;",
    "scroll-mb-3": "scroll-margin-bottom: 0.75rem;",
    "scroll-ml-3": "scroll-margin-left: 0.75rem;",
    "scroll-mt-3.5": "scroll-margin-top: 0.875rem;",
    "scroll-mr-3.5": "scroll-margin-right: 0.875rem;",
    "scroll-mb-3.5": "scroll-margin-bottom: 0.875rem;",
    "scroll-ml-3.5": "scroll-margin-left: 0.875rem;",
    "scroll-mt-4": "scroll-margin-top: 1rem;",
    "scroll-mr-4": "scroll-margin-right: 1rem;",
    "scroll-mb-4": "scroll-margin-bottom: 1rem;",
    "scroll-ml-4": "scroll-margin-left: 1rem;",
    "scroll-mt-5": "scroll-margin-top: 1.25rem;",
    "scroll-mr-5": "scroll-margin-right: 1.25rem;",
    "scroll-mb-5": "scroll-margin-bottom: 1.25rem;",
    "scroll-ml-5": "scroll-margin-left: 1.25rem;",
    "scroll-mt-6": "scroll-margin-top: 1.5rem;",
    "scroll-mr-6": "scroll-margin-right: 1.5rem;",
    "scroll-mb-6": "scroll-margin-bottom: 1.5rem;",
    "scroll-ml-6": "scroll-margin-left: 1.5rem;",
    "scroll-mt-7": "scroll-margin-top: 1.75rem;",
    "scroll-mr-7": "scroll-margin-right: 1.75rem;",
    "scroll-mb-7": "scroll-margin-bottom: 1.75rem;",
    "scroll-ml-7": "scroll-margin-left: 1.75rem;",
    "scroll-mt-8": "scroll-margin-top: 2rem;",
    "scroll-mr-8": "scroll-margin-right: 2rem;",
    "scroll-mb-8": "scroll-margin-bottom: 2rem;",
    "scroll-ml-8": "scroll-margin-left: 2rem;",
    "scroll-mt-9": "scroll-margin-top: 2.25rem;",
    "scroll-mr-9": "scroll-margin-right: 2.25rem;",
    "scroll-mb-9": "scroll-margin-bottom: 2.25rem;",
    "scroll-ml-9": "scroll-margin-left: 2.25rem;",
    "scroll-mt-10": "scroll-margin-top: 2.5rem;",
    "scroll-mr-10": "scroll-margin-right: 2.5rem;",
    "scroll-mb-10": "scroll-margin-bottom: 2.5rem;",
    "scroll-ml-10": "scroll-margin-left: 2.5rem;",
    "scroll-mt-11": "scroll-margin-top: 2.75rem;",
    "scroll-mr-11": "scroll-margin-right: 2.75rem;",
    "scroll-mb-11": "scroll-margin-bottom: 2.75rem;",
    "scroll-ml-11": "scroll-margin-left: 2.75rem;",
    "scroll-mt-12": "scroll-margin-top: 3rem;",
    "scroll-mr-12": "scroll-margin-right: 3rem;",
    "scroll-mb-12": "scroll-margin-bottom: 3rem;",
    "scroll-ml-12": "scroll-margin-left: 3rem;",
    "scroll-mt-14": "scroll-margin-top: 3.5rem;",
    "scroll-mr-14": "scroll-margin-right: 3.5rem;",
    "scroll-mb-14": "scroll-margin-bottom: 3.5rem;",
    "scroll-ml-14": "scroll-margin-left: 3.5rem;",
    "scroll-mt-16": "scroll-margin-top: 4rem;",
    "scroll-mr-16": "scroll-margin-right: 4rem;",
    "scroll-mb-16": "scroll-margin-bottom: 4rem;",
    "scroll-ml-16": "scroll-margin-left: 4rem;",
    "scroll-mt-20": "scroll-margin-top: 5rem;",
    "scroll-mr-20": "scroll-margin-right: 5rem;",
    "scroll-mb-20": "scroll-margin-bottom: 5rem;",
    "scroll-ml-20": "scroll-margin-left: 5rem;",
    "scroll-mt-24": "scroll-margin-top: 6rem;",
    "scroll-mr-24": "scroll-margin-right: 6rem;",
    "scroll-mb-24": "scroll-margin-bottom: 6rem;",
    "scroll-ml-24": "scroll-margin-left: 6rem;",
    "scroll-mt-28": "scroll-margin-top: 7rem;",
    "scroll-mr-28": "scroll-margin-right: 7rem;",
    "scroll-mb-28": "scroll-margin-bottom: 7rem;",
    "scroll-ml-28": "scroll-margin-left: 7rem;",
    "scroll-mt-32": "scroll-margin-top: 8rem;",
    "scroll-mr-32": "scroll-margin-right: 8rem;",
    "scroll-mb-32": "scroll-margin-bottom: 8rem;",
    "scroll-ml-32": "scroll-margin-left: 8rem;",
    "scroll-mt-36": "scroll-margin-top: 9rem;",
    "scroll-mr-36": "scroll-margin-right: 9rem;",
    "scroll-mb-36": "scroll-margin-bottom: 9rem;",
    "scroll-ml-36": "scroll-margin-left: 9rem;",
    "scroll-mt-40": "scroll-margin-top: 10rem;",
    "scroll-mr-40": "scroll-margin-right: 10rem;",
    "scroll-mb-40": "scroll-margin-bottom: 10rem;",
    "scroll-ml-40": "scroll-margin-left: 10rem;",
    "scroll-mt-44": "scroll-margin-top: 11rem;",
    "scroll-mr-44": "scroll-margin-right: 11rem;",
    "scroll-mb-44": "scroll-margin-bottom: 11rem;",
    "scroll-ml-44": "scroll-margin-left: 11rem;",
    "scroll-mt-48": "scroll-margin-top: 12rem;",
    "scroll-mr-48": "scroll-margin-right: 12rem;",
    "scroll-mb-48": "scroll-margin-bottom: 12rem;",
    "scroll-ml-48": "scroll-margin-left: 12rem;",
    "scroll-mt-52": "scroll-margin-top: 13rem;",
    "scroll-mr-52": "scroll-margin-right: 13rem;",
    "scroll-mb-52": "scroll-margin-bottom: 13rem;",
    "scroll-ml-52": "scroll-margin-left: 13rem;",
    "scroll-mt-56": "scroll-margin-top: 14rem;",
    "scroll-mr-56": "scroll-margin-right: 14rem;",
    "scroll-mb-56": "scroll-margin-bottom: 14rem;",
    "scroll-ml-56": "scroll-margin-left: 14rem;",
    "scroll-mt-60": "scroll-margin-top: 15rem;",
    "scroll-mr-60": "scroll-margin-right: 15rem;",
    "scroll-mb-60": "scroll-margin-bottom: 15rem;",
    "scroll-ml-60": "scroll-margin-left: 15rem;",
    "scroll-mt-64": "scroll-margin-top: 16rem;",
    "scroll-mr-64": "scroll-margin-right: 16rem;",
    "scroll-mb-64": "scroll-margin-bottom: 16rem;",
    "scroll-ml-64": "scroll-margin-left: 16rem;",
    "scroll-mt-72": "scroll-margin-top: 18rem;",
    "scroll-mr-72": "scroll-margin-right: 18rem;",
    "scroll-mb-72": "scroll-margin-bottom: 18rem;",
    "scroll-ml-72": "scroll-margin-left: 18rem;",
    "scroll-mt-80": "scroll-margin-top: 20rem;",
    "scroll-mr-80": "scroll-margin-right: 20rem;",
    "scroll-mb-80": "scroll-margin-bottom: 20rem;",
    "scroll-ml-80": "scroll-margin-left: 20rem;",
    "scroll-mt-96": "scroll-margin-top: 24rem;",
    "scroll-mr-96": "scroll-margin-right: 24rem;",
    "scroll-mb-96": "scroll-margin-bottom: 24rem;",
    "scroll-ml-96": "scroll-margin-left: 24rem;",
    "scroll-mt-px": "scroll-margin-top: 1px;",
    "scroll-mr-px": "scroll-margin-right: 1px;",
    "scroll-mb-px": "scroll-margin-bottom: 1px;",
    "scroll-ml-px": "scroll-margin-left: 1px;",
    "scroll-p-0": "scroll-padding: 0;",
    "scroll-p-0.5": "scroll-padding: 0.125rem;",
    "scroll-p-1": "scroll-padding: 0.25rem;",
    "scroll-p-1.5": "scroll-padding: 0.375rem;",
    "scroll-p-2": "scroll-padding: 0.5rem;",
    "scroll-p-2.5": "scroll-padding: 0.625rem;",
    "scroll-p-3": "scroll-padding: 0.75rem;",
    "scroll-p-3.5": "scroll-padding: 0.875rem;",
    "scroll-p-4": "scroll-padding: 1rem;",
    "scroll-p-5": "scroll-padding: 1.25rem;",
    "scroll-p-6": "scroll-padding: 1.5rem;",
    "scroll-p-8": "scroll-padding: 2rem;",
    "scroll-p-10": "scroll-padding: 2.5rem;",
    "scroll-p-11": "scroll-padding: 2.75rem;",
    "scroll-p-12": "scroll-padding: 3rem;",
    "scroll-p-14": "scroll-padding: 3.5rem;",
    "scroll-p-16": "scroll-padding: 4rem;",
    "scroll-p-20": "scroll-padding: 5rem;",
    "scroll-p-24": "scroll-padding: 6rem;",
    "scroll-p-28": "scroll-padding: 7rem;",
    "scroll-p-32": "scroll-padding: 8rem;",
    "scroll-p-36": "scroll-padding: 9rem;",
    "scroll-p-40": "scroll-padding: 10rem;",
    "scroll-p-44": "scroll-padding: 11rem;",
    "scroll-p-48": "scroll-padding: 12rem;",
    "scroll-p-52": "scroll-padding: 13rem;",
    "scroll-p-56": "scroll-padding: 14rem;",
    "scroll-p-64": "scroll-padding: 16rem;",
    "scroll-p-72": "scroll-padding: 18rem;",
    "scroll-p-80": "scroll-padding: 20rem;",
    "scroll-p-96": "scroll-padding: 24rem;",
    "scroll-p-px": "scroll-padding: 1px;",
    "scroll-py-0": "scroll-padding-top: 0;\nscroll-padding-bottom: 0;",
    "scroll-px-0": "scroll-padding-left: 0;\nscroll-padding-right: 0;",
    "scroll-py-0.5": "scroll-padding-top: 0.125rem;\nscroll-padding-bottom: 0.125rem;",
    "scroll-px-0.5": "scroll-padding-left: 0.125rem;\nscroll-padding-right: 0.125rem;",
    "scroll-py-1": "scroll-padding-top: 0.25rem;\nscroll-padding-bottom: 0.25rem;",
    "scroll-px-1": "scroll-padding-left: 0.25rem;\nscroll-padding-right: 0.25rem;",
    "scroll-py-1.5": "scroll-padding-top: 0.375rem;\nscroll-padding-bottom: 0.375rem;",
    "scroll-px-1.5": "scroll-padding-left: 0.375rem;\nscroll-padding-right: 0.375rem;",
    "scroll-py-2": "scroll-padding-top: 0.5rem;\nscroll-padding-bottom: 0.5rem;",
    "scroll-px-2": "scroll-padding-left: 0.5rem;\nscroll-padding-right: 0.5rem;",
    "scroll-py-2.5": "scroll-padding-top: 0.625rem;\nscroll-padding-bottom: 0.625rem;",
    "scroll-px-2.5": "scroll-padding-left: 0.625rem;\nscroll-padding-right: 0.625rem;",
    "scroll-py-3": "scroll-padding-top: 0.75rem;\nscroll-padding-bottom: 0.75rem;",
    "scroll-px-3": "scroll-padding-left: 0.75rem;\nscroll-padding-right: 0.75rem;",
    "scroll-py-3.5": "scroll-padding-top: 0.875rem;\nscroll-padding-bottom: 0.875rem;",
    "scroll-px-3.5": "scroll-padding-left: 0.875rem;\nscroll-padding-right: 0.875rem;",
    "scroll-py-4": "scroll-padding-top: 1rem;\nscroll-padding-bottom: 1rem;",
    "scroll-px-4": "scroll-padding-left: 1rem;\nscroll-padding-right: 1rem;",
    "scroll-py-5": "scroll-padding-top: 1.25rem;\nscroll-padding-bottom: 1.25rem;",
    "scroll-px-5": "scroll-padding-left: 1.25rem;\nscroll-padding-right: 1.25rem;",
    "scroll-py-6": "scroll-padding-top: 1.5rem;\nscroll-padding-bottom: 1.5rem;",
    "scroll-px-6": "scroll-padding-left: 1.5rem;\nscroll-padding-right: 1.5rem;",
    "scroll-py-7": "scroll-padding-top: 1.75rem;\nscroll-padding-bottom: 1.75rem;",
    "scroll-px-7": "scroll-padding-left: 1.75rem;\nscroll-padding-right: 1.75rem;",
    "scroll-py-8": "scroll-padding-top: 2rem;\nscroll-padding-bottom: 2rem;",
    "scroll-px-8": "scroll-padding-left: 2rem;\nscroll-padding-right: 2rem;",
    "scroll-py-9": "scroll-padding-top: 2.25rem;\nscroll-padding-bottom: 2.25rem;",
    "scroll-px-9": "scroll-padding-left: 2.25rem;\nscroll-padding-right: 2.25rem;",
    "scroll-py-10": "scroll-padding-top: 2.5rem;\nscroll-padding-bottom: 2.5rem;",
    "scroll-px-10": "scroll-padding-left: 2.5rem;\nscroll-padding-right: 2.5rem;",
    "scroll-py-11": "scroll-padding-top: 2.75rem;\nscroll-padding-bottom: 2.75rem;",
    "scroll-px-11": "scroll-padding-left: 2.75rem;\nscroll-padding-right: 2.75rem;",
    "scroll-py-12": "scroll-padding-top: 3rem;\nscroll-padding-bottom: 3rem;",
    "scroll-px-12": "scroll-padding-left: 3rem;\nscroll-padding-right: 3rem;",
    "scroll-py-14": "scroll-padding-top: 3.5rem;\nscroll-padding-bottom: 3.5rem;",
    "scroll-px-14": "scroll-padding-left: 3.5rem;\nscroll-padding-right: 3.5rem;",
    "scroll-py-16": "scroll-padding-top: 4rem;\nscroll-padding-bottom: 4rem;",
    "scroll-px-16": "scroll-padding-left: 4rem;\nscroll-padding-right: 4rem;",
    "scroll-py-20": "scroll-padding-top: 5rem;\nscroll-padding-bottom: 5rem;",
    "scroll-px-20": "scroll-padding-left: 5rem;\nscroll-padding-right: 5rem;",
    "scroll-py-24": "scroll-padding-top: 6rem;\nscroll-padding-bottom: 6rem;",
    "scroll-px-24": "scroll-padding-left: 6rem;\nscroll-padding-right: 6rem;",
    "scroll-py-28": "scroll-padding-top: 7rem;\nscroll-padding-bottom: 7rem;",
    "scroll-px-28": "scroll-padding-left: 7rem;\nscroll-padding-right: 7rem;",
    "scroll-py-32": "scroll-padding-top: 8rem;\nscroll-padding-bottom: 8rem;",
    "scroll-px-32": "scroll-padding-left: 8rem;\nscroll-padding-right: 8rem;",
    "scroll-py-36": "scroll-padding-top: 9rem;\nscroll-padding-bottom: 9rem;",
    "scroll-px-36": "scroll-padding-left: 9rem;\nscroll-padding-right: 9rem;",
    "scroll-py-40": "scroll-padding-top: 10rem;\nscroll-padding-bottom: 10rem;",
    "scroll-px-40": "scroll-padding-left: 10rem;\nscroll-padding-right: 10rem;",
    "scroll-py-44": "scroll-padding-top: 11rem;\nscroll-padding-bottom: 11rem;",
    "scroll-px-44": "scroll-padding-left: 11rem;\nscroll-padding-right: 11rem;",
    "scroll-py-48": "scroll-padding-top: 12rem;\nscroll-padding-bottom: 12rem;",
    "scroll-px-48": "scroll-padding-left: 12rem;\nscroll-padding-right: 12rem;",
    "scroll-py-52": "scroll-padding-top: 13rem;\nscroll-padding-bottom: 13rem;",
    "scroll-px-52": "scroll-padding-left: 13rem;\nscroll-padding-right: 13rem;",
    "scroll-py-56": "scroll-padding-top: 14rem;\nscroll-padding-bottom: 14rem;",
    "scroll-px-56": "scroll-padding-left: 14rem;\nscroll-padding-right: 14rem;",
    "scroll-py-60": "scroll-padding-top: 15rem;\nscroll-padding-bottom: 15rem;",
    "scroll-px-60": "scroll-padding-left: 15rem;\nscroll-padding-right: 15rem;",
    "scroll-py-64": "scroll-padding-top: 16rem;\nscroll-padding-bottom: 16rem;",
    "scroll-px-64": "scroll-padding-left: 16rem;\nscroll-padding-right: 16rem;",
    "scroll-py-70": "scroll-padding-top: 18rem;\nscroll-padding-bottom: 18rem;",
    "scroll-px-70": "scroll-padding-left: 18rem;\nscroll-padding-right: 18rem;",
    "scroll-py-80": "scroll-padding-top: 20rem;\nscroll-padding-bottom: 20rem;",
    "scroll-px-80": "scroll-padding-left: 20rem;\nscroll-padding-right: 20rem;",
    "scroll-py-96": "scroll-padding-top: 24rem;\nscroll-padding-bottom: 24rem;",
    "scroll-px-96": "scroll-padding-left: 24rem;\nscroll-padding-right: 24rem;",
    "scroll-py-px": "scroll-padding-top: 1px;\nscroll-padding-bottom: 1px;",
    "scroll-px-px": "scroll-padding-left: 1px;\nscroll-padding-right: 1px;",
    "scroll-pt-0": "scroll-padding-top: 0;",
    "scroll-pr-0": "scroll-padding-right: 0;",
    "scroll-pb-0": "scroll-padding-bottom: 0;",
    "scroll-pl-0": "scroll-padding-left: 0;",
    "scroll-pt-0.5": "scroll-padding-top: 0.125rem;",
    "scroll-pr-0.5": "scroll-padding-right: 0.125rem;",
    "scroll-pb-0.5": "scroll-padding-bottom: 0.125rem;",
    "scroll-pl-0.5": "scroll-padding-left: 0.125rem;",
    "scroll-pt-1": "scroll-padding-top: 0.25rem;",
    "scroll-pr-1": "scroll-padding-right: 0.25rem;",
    "scroll-pb-1": "scroll-padding-bottom: 0.25rem;",
    "scroll-pl-1": "scroll-padding-left: 0.25rem;",
    "scroll-pt-1.5": "scroll-padding-top: 0.375rem;",
    "scroll-pr-1.5": "scroll-padding-right: 0.375rem;",
    "scroll-pb-1.5": "scroll-padding-bottom: 0.375rem;",
    "scroll-pl-1.5": "scroll-padding-left: 0.375rem;",
    "scroll-pt-2": "scroll-padding-top: 0.5rem;",
    "scroll-pr-2": "scroll-padding-right: 0.5rem;",
    "scroll-pb-2": "scroll-padding-bottom: 0.5rem;",
    "scroll-pl-2": "scroll-padding-left: 0.5rem;",
    "scroll-pt-2.5": "scroll-padding-top: 0.625rem;",
    "scroll-pr-2.5": "scroll-padding-right: 0.625rem;",
    "scroll-pb-2.5": "scroll-padding-bottom: 0.625rem;",
    "scroll-pl-2.5": "scroll-padding-left: 0.625rem;",
    "scroll-pt-3": "scroll-padding-top: 0.75rem;",
    "scroll-pr-3": "scroll-padding-right: 0.75rem;",
    "scroll-pb-3": "scroll-padding-bottom: 0.75rem;",
    "scroll-pl-3": "scroll-padding-left: 0.75rem;",
    "scroll-pt-3.5": "scroll-padding-top: 0.875rem;",
    "scroll-pr-3.5": "scroll-padding-right: 0.875rem;",
    "scroll-pb-3.5": "scroll-padding-bottom: 0.875rem;",
    "scroll-pl-3.5": "scroll-padding-left: 0.875rem;",
    "scroll-pt-4": "scroll-padding-top: 1rem;",
    "scroll-pr-4": "scroll-padding-right: 1rem;",
    "scroll-pb-4": "scroll-padding-bottom: 1rem;",
    "scroll-pl-4": "scroll-padding-left: 1rem;",
    "scroll-pt-5": "scroll-padding-top: 1.25rem;",
    "scroll-pr-5": "scroll-padding-right: 1.25rem;",
    "scroll-pb-5": "scroll-padding-bottom: 1.25rem;",
    "scroll-pl-5": "scroll-padding-left: 1.25rem;",
    "scroll-pt-6": "scroll-padding-top: 1.5rem;",
    "scroll-pr-6": "scroll-padding-right: 1.5rem;",
    "scroll-pb-6": "scroll-padding-bottom: 1.5rem;",
    "scroll-pl-6": "scroll-padding-left: 1.5rem;",
    "scroll-pt-7": "scroll-padding-top: 1.75rem;",
    "scroll-pr-7": "scroll-padding-right: 1.75rem;",
    "scroll-pb-7": "scroll-padding-bottom: 1.75rem;",
    "scroll-pl-7": "scroll-padding-left: 1.75rem;",
    "scroll-pt-8": "scroll-padding-top: 2rem;",
    "scroll-pr-8": "scroll-padding-right: 2rem;",
    "scroll-pb-8": "scroll-padding-bottom: 2rem;",
    "scroll-pl-8": "scroll-padding-left: 2rem;",
    "scroll-pt-9": "scroll-padding-top: 2.25rem;",
    "scroll-pr-9": "scroll-padding-right: 2.25rem;",
    "scroll-pb-9": "scroll-padding-bottom: 2.25rem;",
    "scroll-pl-9": "scroll-padding-left: 2.25rem;",
    "scroll-pt-10": "scroll-padding-top: 2.5rem;",
    "scroll-pr-10": "scroll-padding-right: 2.5rem;",
    "scroll-pb-10": "scroll-padding-bottom: 2.5rem;",
    "scroll-pl-10": "scroll-padding-left: 2.5rem;",
    "scroll-pt-11": "scroll-padding-top: 2.75rem;",
    "scroll-pr-11": "scroll-padding-right: 2.75rem;",
    "scroll-pb-11": "scroll-padding-bottom: 2.75rem;",
    "scroll-pl-11": "scroll-padding-left: 2.75rem;",
    "scroll-pt-12": "scroll-padding-top: 3rem;",
    "scroll-pr-12": "scroll-padding-right: 3rem;",
    "scroll-pb-12": "scroll-padding-bottom: 3rem;",
    "scroll-pl-12": "scroll-padding-left: 3rem;",
    "scroll-pt-14": "scroll-padding-top: 3.5rem;",
    "scroll-pr-14": "scroll-padding-right: 3.5rem;",
    "scroll-pb-14": "scroll-padding-bottom: 3.5rem;",
    "scroll-pl-14": "scroll-padding-left: 3.5rem;",
    "scroll-pt-16": "scroll-padding-top: 4rem;",
    "scroll-pr-16": "scroll-padding-right: 4rem;",
    "scroll-pb-16": "scroll-padding-bottom: 4rem;",
    "scroll-pl-16": "scroll-padding-left: 4rem;",
    "scroll-pt-20": "scroll-padding-top: 5rem;",
    "scroll-pr-20": "scroll-padding-right: 5rem;",
    "scroll-pb-20": "scroll-padding-bottom: 5rem;",
    "scroll-pl-20": "scroll-padding-left: 5rem;",
    "scroll-pt-24": "scroll-padding-top: 6rem;",
    "scroll-pr-24": "scroll-padding-right: 6rem;",
    "scroll-pb-24": "scroll-padding-bottom: 6rem;",
    "scroll-pl-24": "scroll-padding-left: 6rem;",
    "scroll-pt-28": "scroll-padding-top: 7rem;",
    "scroll-pr-28": "scroll-padding-right: 7rem;",
    "scroll-pb-28": "scroll-padding-bottom: 7rem;",
    "scroll-pl-28": "scroll-padding-left: 7rem;",
    "scroll-pt-32": "scroll-padding-top: 8rem;",
    "scroll-pr-32": "scroll-padding-right: 8rem;",
    "scroll-pb-32": "scroll-padding-bottom: 8rem;",
    "scroll-pl-32": "scroll-padding-left: 8rem;",
    "scroll-pt-36": "scroll-padding-top: 9rem;",
    "scroll-pr-36": "scroll-padding-right: 9rem;",
    "scroll-pb-36": "scroll-padding-bottom: 9rem;",
    "scroll-pl-36": "scroll-padding-left: 9rem;",
    "scroll-pt-40": "scroll-padding-top: 10rem;",
    "scroll-pr-40": "scroll-padding-right: 10rem;",
    "scroll-pb-40": "scroll-padding-bottom: 10rem;",
    "scroll-pl-40": "scroll-padding-left: 10rem;",
    "scroll-pt-44": "scroll-padding-top: 11rem;",
    "scroll-pr-44": "scroll-padding-right: 11rem;",
    "scroll-pb-44": "scroll-padding-bottom: 11rem;",
    "scroll-pl-44": "scroll-padding-left: 11rem;",
    "scroll-pt-48": "scroll-padding-top: 12rem;",
    "scroll-pr-48": "scroll-padding-right: 12rem;",
    "scroll-pb-48": "scroll-padding-bottom: 12rem;",
    "scroll-pl-48": "scroll-padding-left: 12rem;",
    "scroll-pt-52": "scroll-padding-top: 13rem;",
    "scroll-pr-52": "scroll-padding-right: 13rem;",
    "scroll-pb-52": "scroll-padding-bottom: 13rem;",
    "scroll-pl-52": "scroll-padding-left: 13rem;",
    "scroll-pt-56": "scroll-padding-top: 14rem;",
    "scroll-pr-56": "scroll-padding-right: 14rem;",
    "scroll-pb-56": "scroll-padding-bottom: 14rem;",
    "scroll-pl-56": "scroll-padding-left: 14rem;",
    "scroll-pt-60": "scroll-padding-top: 15rem;",
    "scroll-pr-60": "scroll-padding-right: 15rem;",
    "scroll-pb-60": "scroll-padding-bottom: 15rem;",
    "scroll-pl-60": "scroll-padding-left: 15rem;",
    "scroll-pt-64": "scroll-padding-top: 16rem;",
    "scroll-pr-64": "scroll-padding-right: 16rem;",
    "scroll-pb-64": "scroll-padding-bottom: 16rem;",
    "scroll-pl-64": "scroll-padding-left: 16rem;",
    "scroll-pt-72": "scroll-padding-top: 18rem;",
    "scroll-pr-72": "scroll-padding-right: 18rem;",
    "scroll-pb-72": "scroll-padding-bottom: 18rem;",
    "scroll-pl-72": "scroll-padding-left: 18rem;",
    "scroll-pt-80": "scroll-padding-top: 20rem;",
    "scroll-pr-80": "scroll-padding-right: 20rem;",
    "scroll-pb-80": "scroll-padding-bottom: 20rem;",
    "scroll-pl-80": "scroll-padding-left: 20rem;",
    "scroll-pt-96": "scroll-padding-top: 24rem;",
    "scroll-pr-96": "scroll-padding-right: 24rem;",
    "scroll-pb-96": "scroll-padding-bottom: 24rem;",
    "scroll-pl-96": "scroll-padding-left: 24rem;",
    "scroll-pt-px": "scroll-padding-top: 1px;",
    "scroll-pr-px": "scroll-padding-right: 1px;",
    "scroll-pb-px": "scroll-padding-bottom: 1px;",
    "scroll-pl-px": "scroll-padding-left: 1px;",
    "snap-start": "scroll-snap-align: start;",
    "snap-end": "scroll-snap-align: end;",
    "snap-center": "scroll-snap-align: center;",
    "snap-align-none": "scroll-snap-align: align-none;",
    "snap-normal": "scroll-snap-stop: normal;",
    "snap-always": "scroll-snap-stop: always;",
    "snap-none": "scroll-snap-type: none;",
    "snap-x": "scroll-snap-type: x var(--tw-scroll-snap-strictness);",
    "snap-y": "scroll-snap-type: y var(--tw-scroll-snap-strictness);",
    "snap-both": "scroll-snap-type: both var(--tw-scroll-snap-strictness);",
    "snap-mandatory": "--tw-scroll-snap-strictness: mandatory;",
    "snap-proximity": "--tw-scroll-snap-strictness: proximity;",
    "touch-auto": "touch-action: auto;",
    "touch-none": "touch-action: none;",
    "touch-pan-x": "touch-action: pan-x;",
    "touch-pan-left": "touch-action: pan-left;",
    "touch-pan-right": "touch-action: pan-right;",
    "touch-pan-y": "touch-action: pan-y;",
    "touch-pan-up": "touch-action: pan-up;",
    "touch-pan-down": "touch-action: pan-down;",
    "touch-pinch-zoom": "touch-action: pinch-zoom;",
    "touch-manipulation": "touch-action: manipulation;",
    "select-none": "user-select: none;",
    "select-text": "user-select: text;",
    "select-all": "user-select: all;",
    "select-auto": "user-select: auto;",
    "will-change-auto": "will-change: auto;",
    "will-change-scroll": "will-change: scroll-position;",
    "will-change-contents": "will-change: contents;",
    "will-change-transform": "will-change: transform;",
    "blur-none": "blur: blur(0);",
    "blur-sm": "blur: blur(4px);",
    "blur": "blur: blur(8px);",
    "blur-md": "blur: blur(12px);",
    "blur-lg": "blur: blur(16px);",
    "blur-xl": "blur: blur(24px);",
    "blur-2xl": "blur: blur(40px);",
    "blur-3xl": "blur: blur(64px);",
    "brightness-0": "brightness: brightness(0);",
    "brightness-50": "brightness: brightness(.5);",
    "brightness-75": "brightness: brightness(.75);",
    "brightness-90": "brightness: brightness(.9);",
    "brightness-95": "brightness: brightness(.95);",
    "brightness-100": "brightness: brightness(1);",
    "brightness-105": "brightness: brightness(1.05);",
    "brightness-110": "brightness: brightness(1.1);",
    "brightness-125": "brightness: brightness(1.25);",
    "brightness-150": "brightness: brightness(1.5);",
    "brightness-200": "brightness: brightness(2);",
    "contrast-0": "contrast: contrast(0);",
    "contrast-50": "contrast: contrast(.5);",
    "contrast-75": "contrast: contrast(.75);",
    "contrast-100": "contrast: contrast(1);",
    "contrast-125": "contrast: contrast(1.25);",
    "contrast-150": "contrast: contrast(1.5);",
    "contrast-200": "contrast: contrast(2);",
    "drop-shadow-sm": "drop-shadow: drop-shadow(0 1px 1px rgba(0,0,0,0.05));",
    "drop-shadow": "drop-shadow: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.06));",
    "drop-shadow-md": "drop-shadow: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06));",
    "drop-shadow-lg": "drop-shadow: drop-shadow(0 10px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.1));",
    "drop-shadow-xl": "drop-shadow: drop-shadow(0 20px 13px rgba(0, 0, 0, 0.03)) drop-shadow(0 8px 5px rgba(0, 0, 0, 0.08));",
    "drop-shadow-2xl": "drop-shadow: drop-shadow: drop-shadow(0 25px 25px rgba(0, 0, 0, 0.15));",
    "drop-shadow-none": "drop-shadow: drop-shadow: drop-shadow(0 0 #0000);",
    "grayscale-0": "grayscale: grayscale(0);",
    "grayscale": "grayscale: grayscale(1);",
    "hue-rotate-0": "hue-rotate: hue-rotate(0deg);",
    "hue-rotate-15": "hue-rotate: hue-rotate(15deg);",
    "hue-rotate-30": "hue-rotate: hue-rotate(30deg);",
    "hue-rotate-60": "hue-rotate: hue-rotate(60deg);",
    "hue-rotate-90": "hue-rotate: hue-rotate(90deg);",
    "hue-rotate-180": "hue-rotate: hue-rotate(180deg);",
    "invert-0": "invert: invert(0);",
    "invert": "invert: invert(1);",
    "saturate-0": "saturate: saturate(0);",
    "saturate-50": "saturate: saturate(.5);",
    "saturate-100": "saturate: saturate(1);",
    "saturate-150": "saturate: saturate(1.50);",
    "saturate-200": "saturate: saturate(2);",
    "sepia-0": "sepia: sepia(0);",
    "sepia": "sepia: sepia(1);",
    "backdrop-blur-none": "backdrop-blur: blur(0);",
    "backdrop-blur-sm": "backdrop-blur: blur(4px);",
    "backdrop-blur": "backdrop-blur: blur(8px);",
    "backdrop-blur-md": "backdrop-blur: blur(12px);",
    "backdrop-blur-lg": "backdrop-blur: blur(16px);",
    "backdrop-blur-xl": "backdrop-blur: blur(24px);",
    "backdrop-blur-2xl": "backdrop-blur: blur(40px);",
    "backdrop-blur-3xl": "backdrop-blur: blur(64px);",
    "backdrop-brightness-0": "backdrop-brightness: brightness(0);",
    "backdrop-brightness-sm": "backdrop-brightness: brightness(4px);",
    "backdrop-brightness": "backdrop-brightness: brightness(8px);",
    "backdrop-brightness-md": "backdrop-brightness: brightness(12px);",
    "backdrop-brightness-lg": "backdrop-brightness: brightness(16px);",
    "backdrop-brightness-xl": "backdrop-brightness: brightness(24px);",
    "backdrop-brightness-2xl": "backdrop-brightness: brightness(40px);",
    "backdrop-brightness-3xl": "backdrop-brightness: brightness(64px);",
    "backdrop-contrast-0": "backdrop-contrast: contrast(0);",
    "backdrop-contrast-50": "backdrop-contrast: contrast(.5);",
    "backdrop-contrast-75": "backdrop-contrast: contrast(.75);",
    "backdrop-contrast-100": "backdrop-contrast: contrast(1);",
    "backdrop-contrast-125": "backdrop-contrast: contrast(1.25);",
    "backdrop-contrast-150": "backdrop-contrast: contrast(1.5);",
    "backdrop-contrast-200": "backdrop-contrast: contrast(2);",
    "backdrop-grayscale-0": "backdrop-grayscale: grayscale(0);",
    "backdrop-grayscale": "backdrop-grayscale: grayscale(1);",
    "backdrop-hue-rotate-0": "backdrop-hue-rotate: hue-rotate(0deg);",
    "backdrop-hue-rotate-15": "backdrop-hue-rotate: hue-rotate(15deg);",
    "backdrop-hue-rotate-30": "backdrop-hue-rotate: hue-rotate(30deg);",
    "backdrop-hue-rotate-60": "backdrop-hue-rotate: hue-rotate(60deg);",
    "backdrop-hue-rotate-90": "backdrop-hue-rotate: hue-rotate(90deg);",
    "backdrop-hue-rotate-180": "backdrop-hue-rotate: hue-rotate(180deg);",
    "backdrop-invert-0": "backdrop-invert: invert(0);",
    "backdrop-invert": "backdrop-invert: invert(1);",
    "backdrop-opacity-0": "backdrop-opacity: opacity(0);",
    "backdrop-opacity-5": "backdrop-opacity: opacity(0.05);",
    "backdrop-opacity-10": "backdrop-opacity: opacity(0.1);",
    "backdrop-opacity-20": "backdrop-opacity: opacity(0.2);",
    "backdrop-opacity-25": "backdrop-opacity: opacity(0.25);",
    "backdrop-opacity-30": "backdrop-opacity: opacity(0.3);",
    "backdrop-opacity-40": "backdrop-opacity: opacity(0.4);",
    "backdrop-opacity-50": "backdrop-opacity: opacity(0.5);",
    "backdrop-opacity-60": "backdrop-opacity: opacity(0.6);",
    "backdrop-opacity-70": "backdrop-opacity: opacity(0.7);",
    "backdrop-opacity-75": "backdrop-opacity: opacity(0.75);",
    "backdrop-opacity-80": "backdrop-opacity: opacity(0.8);",
    "backdrop-opacity-90": "backdrop-opacity: opacity(0.9);",
    "backdrop-opacity-95": "backdrop-opacity: opacity(0.95);",
    "backdrop-opacity-100": "backdrop-opacity: opacity(1);",
    "backdrop-saturate-0": "backdrop-saturate: saturate(0);",
    "backdrop-saturate-50": "backdrop-saturate: saturate(.5);",
    "backdrop-saturate-100": "backdrop-saturate: saturate(1);",
    "backdrop-saturate-150": "backdrop-saturate: saturate(1.50);",
    "backdrop-saturate-200": "backdrop-saturate: saturate(2);",
    "backdrop-sepia-0": "backdrop-sepia: sepia(0);",
    "backdrop-sepia": "backdrop-sepia: sepia(1);",
    "basis-0": "flex-basis: 0px;",
    "basis-0.5": "flex-basis: 0.125rem;",
    "basis-1": "flex-basis: 0.25rem;",
    "basis-1.5": "flex-basis: 0.375rem;",
    "basis-2": "flex-basis: 0.5rem;",
    "basis-2.5": "flex-basis: 0.625rem;",
    "basis-3": "flex-basis: 0.75rem;",
    "basis-3.5": "flex-basis: 0.875rem;",
    "basis-4": "flex-basis: 1rem;",
    "basis-5": "flex-basis: 1.25rem;",
    "basis-6": "flex-basis: 1.5rem;",
    "basis-7": "flex-basis: 1.75rem;",
    "basis-8": "flex-basis: 2rem;",
    "basis-9": "flex-basis: 2.25rem;",
    "basis-10": "flex-basis: 2.5rem;",
    "basis-11": "flex-basis: 2.75rem;",
    "basis-12": "flex-basis: 3rem;",
    "basis-14": "flex-basis: 3.5rem;",
    "basis-16": "flex-basis: 4rem;",
    "basis-20": "flex-basis: 5rem;",
    "basis-24": "flex-basis: 6rem;",
    "basis-28": "flex-basis: 7rem;",
    "basis-32": "flex-basis: 8rem;",
    "basis-36": "flex-basis: 9rem;",
    "basis-40": "flex-basis: 10rem;",
    "basis-44": "flex-basis: 11rem;",
    "basis-48": "flex-basis: 12rem;",
    "basis-52": "flex-basis: 13rem;",
    "basis-56": "flex-basis: 14rem;",
    "basis-60": "flex-basis: 15rem;",
    "basis-64": "flex-basis: 16rem;",
    "basis-72": "flex-basis: 18rem;",
    "basis-80": "flex-basis: 20rem;",
    "basis-96": "flex-basis: 24rem;",
    "basis-auto": "flex-basis: auto;",
    "basis-px": "flex-basis: 1px;",
    "basis-1/2": "flex-basis: 50%;",
    "basis-1/3": "flex-basis: 33.333333%;",
    "basis-2/3": "flex-basis: 66.666667%;",
    "basis-1/4": "flex-basis: 25%;",
    "basis-2/4": "flex-basis: 50%;",
    "basis-3/4": "flex-basis: 75%;",
    "basis-1/5": "flex-basis: 20%;",
    "basis-2/5": "flex-basis: 40%;",
    "basis-3/5": "flex-basis: 60%;",
    "basis-4/5": "flex-basis: 80%;",
    "basis-1/6": "flex-basis: 16.666667%;",
    "basis-2/6": "flex-basis: 33.333333%;",
    "basis-3/6": "flex-basis: 50%;",
    "basis-4/6": "flex-basis: 66.666667%;",
    "basis-5/6": "flex-basis: 83.333333%;",
    "basis-1/12": "flex-basis: 8.333333%;",
    "basis-2/12": "flex-basis: 16.666667%;",
    "basis-3/12": "flex-basis: 25%;",
    "basis-4/12": "flex-basis: 33.333333%;",
    "basis-5/12": "flex-basis: 41.666667%;",
    "basis-6/12": "flex-basis: 50%;",
    "basis-7/12": "flex-basis: 58.333333%;",
    "basis-8/12": "flex-basis: 66.666667%;",
    "basis-9/12": "flex-basis: 75%;",
    "basis-10/12": "flex-basis: 83.333333%;",
    "basis-11/12": "flex-basis: 91.666667%;",
    "basis-full": "flex-basis: 100%;",
    "flex-row": "flex-direction: row;",
    "flex-row-reverse": "flex-direction: row-reverse;",
    "flex-col": "flex-direction: column;",
    "flex-col-reverse": "flex-direction: column-reverse;",
    "flex-nowrap": "flex-wrap: nowrap;",
    "flex-wrap": "flex-wrap: wrap;",
    "flex-wrap-reverse": "flex-wrap: wrap-reverse;",
    "flex-1": "flex: 1 1 0%;",
    "flex-auto": "flex: 1 1 auto;",
    "flex-initial": "flex: 0 1 auto;",
    "flex-none": "flex: none;",
    "flex-grow": "flex-grow: 1;",
    "grow-0": "flex-grow: 0;",
    "shrink": "shrink: 1;",
    "shrink-0": "shrink: 0;",
    "order-first": "order: -9999;",
    "order-last": "order: 9999;",
    "order-none": "order: 0;",
    "order-1": "order: 1;",
    "order-2": "order: 2;",
    "order-3": "order: 3;",
    "order-4": "order: 4;",
    "order-5": "order: 5;",
    "order-6": "order: 6;",
    "order-7": "order: 7;",
    "order-8": "order: 8;",
    "order-9": "order: 9;",
    "order-10": "order: 10;",
    "order-11": "order: 11;",
    "order-12": "order: 12;",
    "grid-cols-1": "grid-template-columns: repeat(1, minmax(0, 1fr));",
    "grid-cols-2": "grid-template-columns: repeat(2, minmax(0, 1fr));",
    "grid-cols-3": "grid-template-columns: repeat(3, minmax(0, 1fr));",
    "grid-cols-4": "grid-template-columns: repeat(4, minmax(0, 1fr));",
    "grid-cols-5": "grid-template-columns: repeat(5, minmax(0, 1fr));",
    "grid-cols-6": "grid-template-columns: repeat(6, minmax(0, 1fr));",
    "grid-cols-7": "grid-template-columns: repeat(7, minmax(0, 1fr));",
    "grid-cols-8": "grid-template-columns: repeat(8, minmax(0, 1fr));",
    "grid-cols-9": "grid-template-columns: repeat(9, minmax(0, 1fr));",
    "grid-cols-10": "grid-template-columns: repeat(10, minmax(0, 1fr));",
    "grid-cols-11": "grid-template-columns: repeat(11, minmax(0, 1fr));",
    "grid-cols-12": "grid-template-columns: repeat(12, minmax(0, 1fr));",
    "grid-cols-none": "grid-template-columns: none;",
    "col-auto": "grid-column: auto;",
    "col-span-1": "grid-column: span 1 / span 1;",
    "col-span-2": "grid-column: span 2 / span 2;",
    "col-span-3": "grid-column: span 3 / span 3;",
    "col-span-4": "grid-column: span 4 / span 4;",
    "col-span-5": "grid-column: span 5 / span 5;",
    "col-span-6": "grid-column: span 6 / span 6;",
    "col-span-7": "grid-column: span 7 / span 7;",
    "col-span-8": "grid-column: span 8 / span 8;",
    "col-span-9": "grid-column: span 9 / span 9;",
    "col-span-10": "grid-column: span 10 / span 10;",
    "col-span-11": "grid-column: span 11 / span 11;",
    "col-span-12": "grid-column: span 12 / span 12;",
    "col-start-1": "grid-column-start: 1;",
    "col-start-2": "grid-column-start: 2;",
    "col-start-3": "grid-column-start: 3;",
    "col-start-4": "grid-column-start: 4;",
    "col-start-5": "grid-column-start: 5;",
    "col-start-6": "grid-column-start: 6;",
    "col-start-7": "grid-column-start: 7;",
    "col-start-8": "grid-column-start: 8;",
    "col-start-9": "grid-column-start: 9;",
    "col-start-10": "grid-column-start: 10;",
    "col-start-11": "grid-column-start: 11;",
    "col-start-12": "grid-column-start: 12;",
    "col-start-13": "grid-column-start: 13;",
    "col-start-auto": "grid-column-start: auto;",
    "col-end-1": "grid-column-end: 1;",
    "col-end-2": "grid-column-end: 2;",
    "col-end-3": "grid-column-end: 3;",
    "col-end-4": "grid-column-end: 4;",
    "col-end-5": "grid-column-end: 5;",
    "col-end-6": "grid-column-end: 6;",
    "col-end-7": "grid-column-end: 7;",
    "col-end-8": "grid-column-end: 8;",
    "col-end-9": "grid-column-end: 9;",
    "col-end-10": "grid-column-end: 10;",
    "col-end-11": "grid-column-end: 11;",
    "col-end-12": "grid-column-end: 12;",
    "col-end-13": "grid-column-end: 13;",
    "col-end-auto": "grid-column-end: auto;",
    "grid-rows-1": "grid-template-rows: repeat(1, minmax(0, 1fr));",
    "grid-rows-2": "grid-template-rows: repeat(2, minmax(0, 1fr));",
    "grid-rows-3": "grid-template-rows: repeat(3, minmax(0, 1fr));",
    "grid-rows-4": "grid-template-rows: repeat(4, minmax(0, 1fr));",
    "grid-rows-5": "grid-template-rows: repeat(5, minmax(0, 1fr));",
    "grid-rows-6": "grid-template-rows: repeat(6, minmax(0, 1fr));",
    "grid-rows-none": "grid-template-rows: none;",
    "row-auto": "grid-row: auto;",
    "row-span-1": "grid-row: span 1 / span 1;",
    "row-span-2": "grid-row: span 2 / span 2;",
    "row-span-3": "grid-row: span 3 / span 3;",
    "row-span-4": "grid-row: span 4 / span 4;",
    "row-span-5": "grid-row: span 5 / span 5;",
    "row-span-6": "grid-row: span 6 / span 6;",
    "row-start-1": "grid-row-start: 1;",
    "row-start-2": "grid-row-start: 2;",
    "row-start-3": "grid-row-start: 3;",
    "row-start-4": "grid-row-start: 4;",
    "row-start-5": "grid-row-start: 5;",
    "row-start-6": "grid-row-start: 6;",
    "row-start-7": "grid-row-start: 7;",
    "row-start-auto": "grid-row-start: auto;",
    "row-end-1": "grid-row-end: 1;",
    "row-end-2": "grid-row-end: 2;",
    "row-end-3": "grid-row-end: 3;",
    "row-end-4": "grid-row-end: 4;",
    "row-end-5": "grid-row-end: 5;",
    "row-end-6": "grid-row-end: 6;",
    "row-end-7": "grid-row-end: 7;",
    "row-end-auto": "grid-row-end: auto;",
    "grid-flow-row": "grid-auto-flow: row;",
    "grid-flow-col": "grid-auto-flow: column;",
    "grid-flow-row-dense": "grid-auto-flow: row dense;",
    "grid-flow-col-dense": "grid-auto-flow: column dense;",
    "auto-cols-auto": "grid-auto-columns: auto;",
    "auto-cols-min": "grid-auto-columns: min;",
    "auto-cols-max": "grid-auto-columns: max;",
    "auto-cols-fr": "grid-auto-columns: minmax(0, 1fr);",
    "auto-rows-auto": "grid-auto-rows: auto;",
    "auto-rows-min": "grid-auto-rows: min;",
    "auto-rows-max": "grid-auto-rows: max;",
    "auto-rows-fr": "grid-auto-rows: minmax(0, 1fr);",
    "gap-0": "gap: 0;",
    "gap-0.5": "gap: 0.125rem;",
    "gap-1": "gap: 0.25rem;",
    "gap-1.5": "gap: 0.375rem;",
    "gap-2": "gap: 0.5rem;",
    "gap-2.5": "gap: 0.625rem;",
    "gap-3": "gap: 0.75rem;",
    "gap-3.5": "gap: 0.875rem;",
    "gap-4": "gap: 1rem;",
    "gap-5": "gap: 1.25rem;",
    "gap-6": "gap: 1.5rem;",
    "gap-8": "gap: 2rem;",
    "gap-10": "gap: 2.5rem;",
    "gap-11": "gap: 2.75rem;",
    "gap-12": "gap: 3rem;",
    "gap-14": "gap: 3.5rem;",
    "gap-16": "gap: 4rem;",
    "gap-20": "gap: 5rem;",
    "gap-24": "gap: 6rem;",
    "gap-28": "gap: 7rem;",
    "gap-32": "gap: 8rem;",
    "gap-36": "gap: 9rem;",
    "gap-40": "gap: 10rem;",
    "gap-44": "gap: 11rem;",
    "gap-48": "gap: 12rem;",
    "gap-52": "gap: 13rem;",
    "gap-56": "gap: 14rem;",
    "gap-64": "gap: 16rem;",
    "gap-72": "gap: 18rem;",
    "gap-80": "gap: 20rem;",
    "gap-96": "gap: 24rem;",
    "gap-px": "gap: 1px;",
    "gap-x-0": "column-gap: 0;",
    "gap-x-0.5": "column-gap: 0.125rem;",
    "gap-x-1": "column-gap: 0.25rem;",
    "gap-x-1.5": "column-gap: 0.375rem;",
    "gap-x-2": "column-gap: 0.5rem;",
    "gap-x-2.5": "column-gap: 0.625rem;",
    "gap-x-3": "column-gap: 0.75rem;",
    "gap-x-3.5": "column-gap: 0.875rem;",
    "gap-x-4": "column-gap: 1rem;",
    "gap-x-5": "column-gap: 1.25rem;",
    "gap-x-6": "column-gap: 1.5rem;",
    "gap-x-8": "column-gap: 2rem;",
    "gap-x-10": "column-gap: 2.5rem;",
    "gap-x-11": "column-gap: 2.75rem;",
    "gap-x-12": "column-gap: 3rem;",
    "gap-x-14": "column-gap: 3.5rem;",
    "gap-x-16": "column-gap: 4rem;",
    "gap-x-20": "column-gap: 5rem;",
    "gap-x-24": "column-gap: 6rem;",
    "gap-x-28": "column-gap: 7rem;",
    "gap-x-32": "column-gap: 8rem;",
    "gap-x-36": "column-gap: 9rem;",
    "gap-x-40": "column-gap: 10rem;",
    "gap-x-44": "column-gap: 11rem;",
    "gap-x-48": "column-gap: 12rem;",
    "gap-x-52": "column-gap: 13rem;",
    "gap-x-56": "column-gap: 14rem;",
    "gap-x-64": "column-gap: 16rem;",
    "gap-x-72": "column-gap: 18rem;",
    "gap-x-80": "column-gap: 20rem;",
    "gap-x-96": "column-gap: 24rem;",
    "gap-x-px": "column-gap: 1px;",
    "gap-y-0": "row-gap: 0;",
    "gap-y-0.5": "row-gap: 0.125rem;",
    "gap-y-1": "row-gap: 0.25rem;",
    "gap-y-1.5": "row-gap: 0.375rem;",
    "gap-y-2": "row-gap: 0.5rem;",
    "gap-y-2.5": "row-gap: 0.625rem;",
    "gap-y-3": "row-gap: 0.75rem;",
    "gap-y-3.5": "row-gap: 0.875rem;",
    "gap-y-4": "row-gap: 1rem;",
    "gap-y-5": "row-gap: 1.25rem;",
    "gap-y-6": "row-gap: 1.5rem;",
    "gap-y-8": "row-gap: 2rem;",
    "gap-y-10": "row-gap: 2.5rem;",
    "gap-y-11": "row-gap: 2.75rem;",
    "gap-y-12": "row-gap: 3rem;",
    "gap-y-14": "row-gap: 3.5rem;",
    "gap-y-16": "row-gap: 4rem;",
    "gap-y-20": "row-gap: 5rem;",
    "gap-y-24": "row-gap: 6rem;",
    "gap-y-28": "row-gap: 7rem;",
    "gap-y-32": "row-gap: 8rem;",
    "gap-y-36": "row-gap: 9rem;",
    "gap-y-40": "row-gap: 10rem;",
    "gap-y-44": "row-gap: 11rem;",
    "gap-y-48": "row-gap: 12rem;",
    "gap-y-52": "row-gap: 13rem;",
    "gap-y-56": "row-gap: 14rem;",
    "gap-y-64": "row-gap: 16rem;",
    "gap-y-72": "row-gap: 18rem;",
    "gap-y-80": "row-gap: 20rem;",
    "gap-y-96": "row-gap: 24rem;",
    "gap-y-px": "row-gap: 1px;",
    "justify-start": "justify-content: flex-start;",
    "justify-center": "justify-content: center;",
    "justify-end": "justify-content: flex-end;",
    "justify-between": "justify-content: space-between;",
    "justify-around": "justify-content: space-around;",
    "justify-evenly": "justify-content: space-evenly;",
    "justify-items-stretch": "justify-items: stretch;",
    "justify-items-start": "justify-items: start;",
    "justify-items-center": "justify-items: center;",
    "justify-items-end": "justify-items: end;",
    "justify-self-stretch": "justify-self: stretch;",
    "justify-self-start": "justify-self: start;",
    "justify-self-center": "justify-self: center;",
    "justify-self-end": "justify-self: end;",
    "justify-self-auto": "justify-self: auto;",
    "content-start": "align-content: flex-start;",
    "content-center": "align-content: center;",
    "content-end": "align-content: flex-end;",
    "content-between": "align-content: space-between;",
    "content-around": "align-content: space-around;",
    "content-evenly": "align-content: space-evenly;",
    "items-stretch": "align-items: stretch;",
    "items-start": "align-items: flex-start;",
    "items-center": "align-items: center;",
    "items-end": "align-items: flex-end;",
    "items-baseline": "align-items: baseline;",
    "self-auto": "align-self: auto;",
    "self-start": "align-self: flex-start;",
    "self-center": "align-self: center;",
    "self-end": "align-self: flex-end;",
    "self-stretch": "align-self: stretch;",
    "self-baseline": "align-self: baseline;",
    "place-content-start": "place-content: start;",
    "place-content-center": "place-content: center;",
    "place-content-end": "place-content: end;",
    "place-content-between": "place-content: space-between;",
    "place-content-around": "place-content: space-around;",
    "place-content-evenly": "place-content: space-evenly;",
    "place-content-stretch": "place-content: space-stretch;",
    "place-items-stretch": "place-items: stretch;",
    "place-items-start": "place-items: start;",
    "place-items-center": "place-items: center;",
    "place-items-end": "place-items: end;",
    "place-self-auto": "place-self: auto;",
    "place-self-start": "place-self: start;",
    "place-self-center": "place-self: center;",
    "place-self-end": "place-self: end;",
    "place-self-stretch": "place-self: stretch;",
    "bg-fixed": "background-attachment: fixed;",
    "bg-local": "background-attachment: local;",
    "bg-scroll": "background-attachment: scroll;",
    "bg-clip-border": "background-clip: border-box;",
    "bg-clip-padding": "background-clip: padding-box;",
    "bg-clip-content": "background-clip: content-box;",
    "bg-clip-text": "background-clip: text;",
    "bg-opacity-0": "--bg-opacity: 0;",
    "bg-opacity-5": "--bg-opacity: 0.5;",
    "bg-opacity-10": "--bg-opacity: 0.1;",
    "bg-opacity-20": "--bg-opacity: 0.2;",
    "bg-opacity-25": "--bg-opacity: 0.25;",
    "bg-opacity-30": "--bg-opacity: 0.3;",
    "bg-opacity-40": "--bg-opacity: 0.4;",
    "bg-opacity-50": "--bg-opacity: 0.5;",
    "bg-opacity-60": "--bg-opacity: 0.6;",
    "bg-opacity-70": "--bg-opacity: 0.7;",
    "bg-opacity-75": "--bg-opacity: 0.75;",
    "bg-opacity-80": "--bg-opacity: 0.8;",
    "bg-opacity-90": "--bg-opacity: 0.9;",
    "bg-opacity-95": "--bg-opacity: 0.95;",
    "bg-opacity-100": "--bg-opacity: 1;",
    "bg-origin-border": "background-origin: border-box;",
    "bg-origin-padding": "background-origin: padding-box;",
    "bg-origin-content": "background-origin: content-box;",
    "bg-bottom": "background-position: bottom;",
    "bg-center": "background-position: center;",
    "bg-left": "background-position: left;",
    "bg-left-bottom": "background-position: left bottom;",
    "bg-left-top": "background-position: left top;",
    "bg-right": "background-position: right;",
    "bg-right-bottom": "background-position: right bottom;",
    "bg-right-top": "background-position: right top;",
    "bg-top": "background-position: top;",
    "bg-repeat": "background-repeat: repeat;",
    "bg-no-repeat": "background-repeat: no-repeat;",
    "bg-repeat-x": "background-repeat: repeat-x;",
    "bg-repeat-y": "background-repeat: repeat-y;",
    "bg-repeat-round": "background-repeat: round;",
    "bg-repeat-space": "background-repeat: space;",
    "bg-auto": "background-size: auto;",
    "bg-cover": "background-size: cover;",
    "bg-contain": "background-size: contain;",
    "bg-none": "background-image: none;",
    "bg-gradient-to-t": "background-image:background-image: background-image: linear-gradient(to top, var(--tw-gradient-stops));",
    "bg-gradient-to-tr": "background-image: background-image: linear-gradient(to top right, var(--tw-gradient-stops));",
    "bg-gradient-to-r": "background-image: background-image: linear-gradient(to right, var(--tw-gradient-stops));",
    "bg-gradient-to-br": "background-image: background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));",
    "bg-gradient-to-b": "background-image: background-image: linear-gradient(to bottom, var(--tw-gradient-stops));",
    "bg-gradient-to-bl": "background-image: background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));",
    "bg-gradient-to-l": "background-image: background-image: linear-gradient(to left, var(--tw-gradient-stops));",
    "bg-gradient-to-tl": "background-image: background-image: linear-gradient(to top left, var(--tw-gradient-stops));",
    "fill-current": "fill: currentColor;",
    "stroke-current": "stroke: currentColor;",
    "stroke-0": "stroke-width: 0;",
    "stroke-1": "stroke-width: 1;",
    "stroke-2": "stroke-width: 2;",
    "sr-only": "position: absolute;\nwidth: 1px;\nheight: 1px;\npadding: 0;\nmargin: -1px;\noverflow: hidden;\nclip: rect(0, 0, 0, 0);\nwhite-space: nowrap;\nborder-width: 0;",
    "not-sr-only": "position: static;\nwidth: auto;\nheight: auto;\npadding: 0;\nmargin: 0;\noverflow: visible;\nclip: auto;\nwhite-space: normal;",
    "rounded-none": "border-radius: 0;",
    "rounded-sm": "border-radius: 0.125rem;",
    "rounded": "border-radius: 0.25rem;",
    "rounded-md": "border-radius: 0.375rem;",
    "rounded-lg": "border-radius: 0.5rem;",
    "rounded-xl": "border-radius: 0.75rem;",
    "rounded-2xl": "border-radius: 1rem;",
    "rounded-3xl": "border-radius: 1.5rem;",
    "rounded-full": "border-radius: 9999px;",
    "rounded-t-none": "border-top-left-radius: 0;\nborder-top-right-radius: 0;",
    "rounded-r-none": "border-top-right-radius: 0;\nborder-bottom-right-radius: 0;",
    "rounded-b-none": "border-bottom-right-radius: 0;\nborder-bottom-left-radius: 0;",
    "rounded-l-none": "border-top-left-radius: 0;\nborder-bottom-left-radius: 0;",
    "rounded-t-sm": "border-top-left-radius: 0.125rem;\nborder-top-right-radius: 0.125rem;",
    "rounded-r-sm": "border-top-right-radius: 0.125rem;\nborder-bottom-right-radius: 0.125rem;",
    "rounded-b-sm": "border-bottom-right-radius: 0.125rem;\nborder-bottom-left-radius: 0.125rem;",
    "rounded-l-sm": "border-top-left-radius: 0.125rem;\nborder-bottom-left-radius: 0.125rem;",
    "rounded-t": "border-top-left-radius: 0.25rem;\nborder-top-right-radius: 0.25rem;",
    "rounded-r": "border-top-right-radius: 0.25rem;\nborder-bottom-right-radius: 0.25rem;",
    "rounded-b": "border-bottom-right-radius: 0.25rem;\nborder-bottom-left-radius: 0.25rem;",
    "rounded-l": "border-top-left-radius: 0.25rem;\nborder-bottom-left-radius: 0.25rem;",
    "rounded-t-md": "border-top-left-radius: 0.375rem;\nborder-top-right-radius: 0.375rem;",
    "rounded-r-md": "border-top-right-radius: 0.375rem;\nborder-bottom-right-radius: 0.375rem;",
    "rounded-b-md": "border-bottom-right-radius: 0.375rem;\nborder-bottom-left-radius: 0.375rem;",
    "rounded-l-md": "border-top-left-radius: 0.375rem;\nborder-bottom-left-radius: 0.375rem;",
    "rounded-t-lg": "border-top-left-radius: 0.5rem;\nborder-top-right-radius: 0.5rem;",
    "rounded-r-lg": "border-top-right-radius: 0.5rem;\nborder-bottom-right-radius: 0.5rem;",
    "rounded-b-lg": "border-bottom-right-radius: 0.5rem;\nborder-bottom-left-radius: 0.5rem;",
    "rounded-l-lg": "border-top-left-radius: 0.5rem;\nborder-bottom-left-radius: 0.5rem;",
    "rounded-t-xl": "border-top-left-radius: 0.75rem;\nborder-top-right-radius: 0.75rem;",
    "rounded-r-xl": "border-top-right-radius: 0.75rem;\nborder-bottom-right-radius: 0.75rem;",
    "rounded-b-xl": "border-bottom-right-radius: 0.75rem;\nborder-bottom-left-radius: 0.75rem;",
    "rounded-l-xl": "border-top-left-radius: 0.75rem;\nborder-bottom-left-radius: 0.75rem;",
    "rounded-t-2xl": "border-top-left-radius: 1rem;\nborder-top-right-radius: 1rem;",
    "rounded-r-2xl": "border-top-right-radius: 1rem;\nborder-bottom-right-radius: 1rem;",
    "rounded-b-2xl": "border-bottom-right-radius: 1rem;\nborder-bottom-left-radius: 1rem;",
    "rounded-l-2xl": "border-top-left-radius: 1rem;\nborder-bottom-left-radius: 1rem;",
    "rounded-t-3xl": "border-top-left-radius: 1.5rem;\nborder-top-right-radius: 1.5rem;",
    "rounded-r-3xl": "border-top-right-radius: 1.5rem;\nborder-bottom-right-radius: 1.5rem;",
    "rounded-b-3xl": "border-bottom-right-radius: 1.5rem;\nborder-bottom-left-radius: 1.5rem;",
    "rounded-l-3xl": "border-top-left-radius: 1.5rem;\nborder-bottom-left-radius: 1.5rem;",
    "rounded-t-full": "border-top-left-radius: 9999px;\nborder-top-right-radius: 9999px;",
    "rounded-r-full": "border-top-right-radius: 9999px;\nborder-bottom-right-radius: 9999px;",
    "rounded-b-full": "border-bottom-right-radius: 9999px;\nborder-bottom-left-radius: 9999px;",
    "rounded-l-full": "border-top-left-radius: 9999px;\nborder-bottom-left-radius: 9999px;",
    "rounded-tl-none": "border-top-left-radius: 0;",
    "rounded-tr-none": "border-top-right-radius: 0;",
    "rounded-br-none": "border-bottom-right-radius: 0;",
    "rounded-bl-none": "border-bottom-left-radius: 0;",
    "rounded-tl-sm": "border-top-left-radius: 0.125rem;",
    "rounded-tr-sm": "border-top-right-radius: 0.125rem;",
    "rounded-br-sm": "border-bottom-right-radius: 0.125rem;",
    "rounded-bl-sm": "border-bottom-left-radius: 0.125rem;",
    "rounded-tl": "border-top-left-radius: 0.25rem;",
    "rounded-tr": "border-top-right-radius: 0.25rem;",
    "rounded-br": "border-bottom-right-radius: 0.25rem;",
    "rounded-bl": "border-bottom-left-radius: 0.25rem;",
    "rounded-tl-md": "border-top-left-radius: 0.375rem;",
    "rounded-tr-md": "border-top-right-radius: 0.375rem;",
    "rounded-br-md": "border-bottom-right-radius: 0.375rem;",
    "rounded-bl-md": "border-bottom-left-radius: 0.375rem;",
    "rounded-tl-lg": "border-top-left-radius: 0.5rem;",
    "rounded-tr-lg": "border-top-right-radius: 0.5rem;",
    "rounded-br-lg": "border-bottom-right-radius: 0.5rem;",
    "rounded-bl-lg": "border-bottom-left-radius: 0.5rem;",
    "rounded-tl-xl": "border-top-left-radius: 0.75rem;",
    "rounded-tr-xl": "border-top-right-radius: 0.75rem;",
    "rounded-br-xl": "border-bottom-right-radius: 0.75rem;",
    "rounded-bl-xl": "border-bottom-left-radius: 0.75rem;",
    "rounded-tl-2xl": "border-top-left-radius: 1rem;",
    "rounded-tr-2xl": "border-top-right-radius: 1rem;",
    "rounded-br-2xl": "border-bottom-right-radius: 1rem;",
    "rounded-bl-2xl": "border-bottom-left-radius: 1rem;",
    "rounded-tl-3xl": "border-top-left-radius: 1.5rem;",
    "rounded-tr-3xl": "border-top-right-radius: 1.5rem;",
    "rounded-br-3xl": "border-bottom-right-radius: 1.5rem;",
    "rounded-bl-3xl": "border-bottom-left-radius: 1.5rem;",
    "rounded-tl-full": "border-top-left-radius: 9999px;",
    "rounded-tr-full": "border-top-right-radius: 9999px;",
    "rounded-br-full": "border-bottom-right-radius: 9999px;",
    "rounded-bl-full": "border-bottom-left-radius: 9999px;",
    "border": "border-width: 1px;",
    "border-0": "border-width: 0;",
    "border-2": "border-width: 2px;",
    "border-4": "border-width: 4px;",
    "border-8": "border-width: 8px;",
    "border-t": "border-top-width: 1px;",
    "border-t-0": "border-top-width: 0;",
    "border-t-2": "border-top-width: 2px;",
    "border-t-4": "border-top-width: 4px;",
    "border-t-8": "border-top-width: 8px;",
    "border-r": "border-right-width: 1px;",
    "border-r-0": "border-right-width: 0;",
    "border-r-2": "border-right-width: 2px;",
    "border-r-4": "border-right-width: 4px;",
    "border-r-8": "border-right-width: 8px;",
    "border-b": "border-bottom-width: 1px;",
    "border-b-0": "border-bottom-width: 0;",
    "border-b-2": "border-bottom-width: 2px;",
    "border-b-4": "border-bottom-width: 4px;",
    "border-b-8": "border-bottom-width: 8px;",
    "border-l": "border-left-width: 1px;",
    "border-l-0": "border-left-width: 0;",
    "border-l-2": "border-left-width: 2px;",
    "border-l-4": "border-left-width: 4px;",
    "border-l-8": "border-left-width: 8px;",
    "border-opacity-0": "border-opacity: 0;",
    "border-opacity-5": "border-opacity: 0.05;",
    "border-opacity-10": "border-opacity: 0.1;",
    "border-opacity-20": "border-opacity: 0.2;",
    "border-opacity-25": "border-opacity: 0.25;",
    "border-opacity-30": "border-opacity: 0.3;",
    "border-opacity-40": "border-opacity: 0.4;",
    "border-opacity-50": "border-opacity: 0.5;",
    "border-opacity-60": "border-opacity: 0.6;",
    "border-opacity-70": "border-opacity: 0.7;",
    "border-opacity-75": "border-opacity: 0.75;",
    "border-opacity-80": "border-opacity: 0.8;",
    "border-opacity-90": "border-opacity: 0.9;",
    "border-opacity-100": "border-opacity: 1;",
    "border-solid": "border-style: solid;",
    "border-dashed": "border-style: dashed;",
    "border-dotted": "border-style: dotted;",
    "border-double": "border-style: double;",
    "border-hidden": "border-style: hidden;",
    "border-none": "border-style: none;",
    "divide-x-0": "border-left-width: 0;",
    "divide-x-2": "border-left-width: 2px;",
    "divide-x-4": "border-left-width: 4px;",
    "divide-x-8": "border-left-width: 8px;",
    "divide-x": "border-left-width: 1px;",
    "divide-y-0": "border-top-width: 0;",
    "divide-y-2": "border-top-width: 2px;",
    "divide-y-4": "border-top-width: 4px;",
    "divide-y-8": "border-top-width: 8px;",
    "divide-y": "border-top-width: 1px;",
    "divide-x-reverse": "--divide-x-reverse: 1;",
    "divide-y-reverse": "--divide-y-reverse: 1;",
    "divide-opacity-0": "--divide-opacity: 0;",
    "divide-opacity-5": "--divide-opacity: 0.05;",
    "divide-opacity-10": "--divide-opacity: 0.1;",
    "divide-opacity-20": "--divide-opacity: 0.2;",
    "divide-opacity-25": "--divide-opacity: 0.25;",
    "divide-opacity-30": "--divide-opacity: 0.3;",
    "divide-opacity-40": "--divide-opacity: 0.4;",
    "divide-opacity-50": "--divide-opacity: 0.5;",
    "divide-opacity-60": "--divide-opacity: 0.6;",
    "divide-opacity-70": "--divide-opacity: 0.7;",
    "divide-opacity-75": "--divide-opacity: 0.75;",
    "divide-opacity-80": "--divide-opacity: 0.8;",
    "divide-opacity-90": "--divide-opacity: 0.9;",
    "divide-opacity-100": "--divide-opacity: 1;",
    "divide-solid": "border-style: solid;",
    "divide-dashed": "border-style: dashed;",
    "divide-dotted": "border-style: dotted;",
    "divide-double": "border-style: double;",
    "divide-none": "border-style: none;",
    "outline-0": "outline-width: 0px;",
    "outline-1": "outline-width: 1px;",
    "outline-2": "outline-width: 2px;",
    "outline-4": "outline-width: 4px;",
    "outline-8": "outline-width: 8px;",
    "outline-solid": "outline-style: solid;",
    "outline-dashed": "outline-style: dashed;",
    "outline-dotted": "outline-style: dotted;",
    "outline-double": "outline-style: double;",
    "outline-hidden": "outline-style: hidden;",
    "outline-none": "outline-style: none;",
    "outline-offset-0": "outline-offset: 0px;",
    "outline-offset-1": "outline-offset: 1px;",
    "outline-offset-2": "outline-offset: 2px;",
    "outline-offset-4": "outline-offset: 4px;",
    "outline-offset-8": "outline-offset: 8px;",
    "ring-0": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring-1": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring-2": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring-4": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring-8": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring": "box-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);",
    "ring-inset": "--tw-ring-inset: inset;",
    "ring-opacity-0": "--ring-opacity: 0;",
    "ring-opacity-5": "--ring-opacity: 0.05;",
    "ring-opacity-10": "--ring-opacity: 0.1;",
    "ring-opacity-20": "--ring-opacity: 0.2;",
    "ring-opacity-25": "--ring-opacity: 0.25;",
    "ring-opacity-30": "--ring-opacity: 0.3;",
    "ring-opacity-40": "--ring-opacity: 0.4;",
    "ring-opacity-50": "--ring-opacity: 0.5;",
    "ring-opacity-60": "--ring-opacity: 0.6;",
    "ring-opacity-70": "--ring-opacity: 0.7;",
    "ring-opacity-75": "--ring-opacity: 0.75;",
    "ring-opacity-80": "--ring-opacity: 0.8;",
    "ring-opacity-90": "--ring-opacity: 0.9;",
    "ring-opacity-100": "--ring-opacity: 1;",
    "ring-offset-0": "--ring-offset-width: 0px;\nbox-shadow: 0 0 0 var(--ring-offset-width) var(--ring-offset-color), var(--ring-shadow);",
    "ring-offset-1": "--ring-offset-width: 1px;\nbox-shadow: 0 0 0 var(--ring-offset-width) var(--ring-offset-color), var(--ring-shadow);",
    "ring-offset-2": "--ring-offset-width: 2px;\nbox-shadow: 0 0 0 var(--ring-offset-width) var(--ring-offset-color), var(--ring-shadow);",
    "ring-offset-4": "--ring-offset-width: 4px;\nbox-shadow: 0 0 0 var(--ring-offset-width) var(--ring-offset-color), var(--ring-shadow);",
    "ring-offset-8": "--ring-offset-width: 8px;\nbox-shadow: 0 0 0 var(--ring-offset-width) var(--ring-offset-color), var(--ring-shadow);",
    "transition": "transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "transition-none": "transition-property: none;",
    "transition-all": "transition-property: all;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "transition-colors": "transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "transition-opacity": "transition-property: opacity;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "transition-shadow": "transition-property: box-shadow;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "transition-transform": "transition-property: transform;\ntransition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\ntransition-duration: 300ms;",
    "duration-75": "transition-duration: 75ms;",
    "duration-100": "transition-duration: 100ms;",
    "duration-150": "transition-duration: 150ms;",
    "duration-200": "transition-duration: 200ms;",
    "duration-300": "transition-duration: 300ms;",
    "duration-500": "transition-duration: 500ms;",
    "duration-700": "transition-duration: 700ms;",
    "duration-1000": "transition-duration: 1000ms;",
    "ease-linear": "transition-timing-function: linear;",
    "ease-in": "transition-timing-function: cubic-bezier(0.4, 0, 1, 1);",
    "ease-out": "transition-timing-function: cubic-bezier(0, 0, 0.2, 1);",
    "ease-in-out": "transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);",
    "delay-75": "transition-delay: 75ms;",
    "delay-100": "transition-delay: 100ms;",
    "delay-150": "transition-delay: 150ms;",
    "delay-200": "transition-delay: 200ms;",
    "delay-300": "transition-delay: 300ms;",
    "delay-500": "transition-delay: 500ms;",
    "delay-700": "transition-delay: 700ms;",
    "delay-1000": "transition-delay: 1000ms;",
    "animate-none": "animation: none;",
    "animate-spin": "animation: spin 1s linear infinite;\n@keyframes spin {  from {    transform: rotate(0deg);\n  }  to {    transform: rotate(360deg);\n  }};",
    "animate-ping": "animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n@keyframes ping {  75%, 100% {    transform: scale(2);\n    opacity: 0;\n  }};",
    "animate-pulse": "animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n@keyframes pulse {  0%, 100% {    opacity: 1;\n  }  50% {    opacity: .5;\n  }};",
    "animate-bounce": "animation: animation: bounce 1s infinite;\n@keyframes bounce {  0%, 100% {    transform: translateY(-25%);\n    animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);\n  }  50% {    transform: translateY(0);\n    animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);\n  }};",
    "border-collapse": "border-collapse: collapse;",
    "border-separate": "border-collapse: separate;",
    "table-auto": "table-layout: auto;",
    "table-fixed": "table-layout: fixed;"
}


module.exports = tailwindMap

